import { showcaseFrench } from "./showcase";
import { CompetitionFormat, Exercise } from "../index.js";
import dico from "./dico.js";

const fr = {
  showcase: showcaseFrench,
  athleteCount: {
    title: "Comptage des athlètes",
    notice:
      "Une inscription réserve une place. La participation est comptabilisée définitivement lorsque le champ choisi prend une des valeurs de fin. Sans règle, elle reste réservée jusqu’à sa suppression.",
    field: "Champ de fin de participation",
    none: "Aucune règle",
    values: "Valeurs de fin (une par ligne)",
    hint: "Pour une liste, utilisez les valeurs des options, pas leurs libellés traduits.",
    defaultValue: "Terminé",
    invalid:
      "Choisissez un champ athlète et au moins une valeur de fin valide.",
  },
  athleteEntry: {
    signAndSend: "Signer et envoyer",
    signatureTitle: "Signature pour cette compétition",
    signatureDraw: "Dessinez votre signature avec le doigt ou la souris",
    signatureClear: "Effacer et recommencer",
    signatureNotice:
      "En signant, je confirme les valeurs affichées et j’autorise la conservation de ma signature pour les tickets de cette compétition. Chaque clic sur « Signer et envoyer » associera cette signature au ticket confirmé.",
    mobileTicketTitle: "Saisie athlète",
    ticketReceivedAt: "Reçu le",
    ticketSigned: "Signé",
    ticketUnsigned: "Non signé",
    signatureConfirmedAt: "Confirmation reçue le",

    refusedAttemptClosed:
      "Saisie de cette tentative clôturée après refus du secrétariat.",
    attemptsTab: "Barres",
    notifications: "Notifications",
    equipmentTab: "Matériel",
    historyTab: "Historique",
    noTickets: "Aucun ticket",

    equipmentGroupPartial: "Matériel partiellement verrouillé",
    equipmentGroupLocked: "Matériel verrouillé",
    equipmentGroupOpen: "Matériel déverrouillé",
    equipmentLockGroup: "Verrouiller le matériel de tout le groupe",
    equipmentUnlockGroup: "Déverrouiller le matériel de tout le groupe",
    refusedBySecretary: "Ticket refusé par le secrétariat",
    retainedValue: "Valeur retenue",
    hideCode: "Masquer le code",
    phoneNotConnected: "Non connecté",
    equipmentEditable: "Modifiables",
    onlineCompact: "Connecté",
    offlineCompact: "Indisponible",
    equipmentSettings: "Réglages du matériel",
    equipmentLock: "Verrouiller les réglages du matériel",
    positionRack: "Position squat",
    cales: "Cales",
    athleteAccessAction: "Accès de cet athlète",
    meetEntryButton: "Saisie athlète",
    settingsSavedCompact: "Réglages enregistrés",
    entryDisabledCompact: "Désactivée",
    entrySyncPending: "Synchronisation en cours",
    entryGroupExcluded: "Saisie mobile désactivée pour ce groupe",
    entryGroupNotReady:
      "État du plateau à confirmer dans les réglages de la compétition",
    processedAt: "Traitement plateau",
    notRecorded: "Saisie non enregistrée",
    allTickets: "Tous les tickets",
    historySearch: "Nom, tentative, charge ou commentaire",
    athleteTicketHistory: "Tickets de cet athlète",
    reviewTicket: "Examiner",
    ticketAccepted: "Accepté",
    ticketRefused: "Refusé",
    ticketFailed: "Non enregistré",
    ticketCancelled: "Annulé",
    ticketToReview: "À examiner",
    ticketSaved: "Enregistré",
    ticketPending: "En attente",
    ticketHistory: "Historique des tickets",
    customAttemptChange:
      "Modification de tentative à décider par le secrétariat",
    allowWhileCalled: "Autoriser la saisie lorsque l’athlète est appelé",
    unlimitedChanges: "Autoriser un nombre illimité de changements",
    reviewChanges: "Soumettre les changements au secrétariat",
    thirdAttemptChange:
      "Changement de troisième barre à décider par le secrétariat",
    refuseKeepCurrent: "Refuser le ticket sans modifier la charge",
    refuseKeepCurrentHelp:
      "Le refus peut être consigné sans modifier la charge actuelle. Indiquez un commentaire ; toute correction de la barre doit ensuite être effectuée manuellement par le secrétariat.",
    refusedEntryManual:
      "Ticket refusé ; charge inchangée. Toute correction doit être effectuée manuellement par le secrétariat.",
    decisionConflict:
      "La tentative a changé, a commencé ou son état précédent n’est plus restaurable. Aucune modification effectuée. Vérifiez la barre au secrétariat.",
    previousValue: "Valeur précédente",
    lateCellHelp:
      "Ticket à décider : cliquez pour accepter ou refuser la saisie.",
    refusedEntry: "Saisie refusée par le secrétariat ; état précédent rétabli",
    acceptedEntry: "Saisie acceptée par le secrétariat",
    refuseEntry: "Refuser la saisie",
    acceptEntry: "Accepter la saisie",
    decisionHelp:
      "Cette charge a été enregistrée. Accepter confirme sa recevabilité. Refuser rétablit l’état précédent si la tentative n’a pas changé et n’a pas commencé.",
    draftNotSent:
      "La tentative a changé ou a été verrouillée. Votre proposition n’a pas été envoyée.",
    groupContextUnavailable:
      "La saisie attend la confirmation de l’état du plateau par le secrétariat.",
    prepareGroup: "Préparer la saisie de ce groupe",
    prepareGroupHelp:
      "Après un redémarrage, confirmez l’état du plateau avant d’ouvrir les saisies de ce groupe.",
    prepareGroupConfirm:
      "Confirmez qu’aucun athlète de ce groupe n’est actuellement sur la barre. Un appel déjà connu reste pris en compte.",

    draftChanged:
      "Les données de cette tentative ont changé. Votre proposition est conservée. Vérifiez les valeurs avant de confirmer à nouveau.",
    proposed: "Votre proposition",
    useCurrentRules: "Reprendre avec les données actuelles",
    lateReceiptHelp:
      "Charge enregistrée hors délai. Sa recevabilité reste à vérifier avec le secrétariat avant le passage.",
    secretaryFeedback: "Retour du secrétariat",
    phoneNumber: "Téléphone n°",

    settingsTab: "Réglages",
    accessTab: "Codes et téléphones",
    plateauFilter: "Plateau",
    allPlateaus: "Tous les plateaux",
    groupFilter: "Groupe",
    allGroups: "Tous les groupes",
    profileUnavailable: "Profil mobile à configurer dans la discipline",
    excludedAthlete:
      "Ce groupe n’est pas autorisé à saisir sur téléphone. Un code déjà remis reste consultable, mais ne permet pas de se connecter.",
    syncPending:
      "Réglage enregistré localement, en attente de confirmation du serveur.",
    settingsSaved:
      "Réglages enregistrés. Vérifiez la confirmation de synchronisation avant de remettre les codes.",
    accessChanged: "Accès mis à jour.",
    cancelledRequests: "Demandes annulées",
    inProgress: "Enregistrements en cours",
    revocationHelp:
      "Les demandes en attente sont annulées. Un enregistrement déjà en cours peut encore aboutir : vérifiez son reçu dans Tickets.",
    requestsInFlight: "Demandes en cours",
    refreshSessions: "Actualiser les téléphones",
    localHistory:
      "Historique local : serveur indisponible. Le traitement des tickets sera disponible après reconnexion.",
    reviewHelp:
      "Les tickets tardifs, les horaires incertains et les changements soumis à vérification attendent une décision du secrétariat : accepter ou refuser la saisie.",
    unreviewedOnly: "Non traités uniquement",
    emptyFilteredTickets: "Aucun ticket correspondant aux filtres.",
    executing: "Enregistrement en cours - attendre son reçu final.",

    otherPhonePending:
      "Une saisie est en cours depuis l’autre téléphone. Attendez sa confirmation.",

    unconfirmedAfterExpiry:
      "Une saisie était en cours. Vérifiez son enregistrement auprès du secrétariat avant toute nouvelle demande.",
    checkedWithSecretary: "Vérifié avec le secrétariat",

    weight: "Poids",
    invalidWeight:
      "Valeur non autorisée : respectez le minimum et les incréments indiqués",
    waitingResult:
      "Barre enregistrée. En attente du résultat avant la prochaine saisie.",
    onBar:
      "Passage en cours. La saisie reprendra après validation du résultat.",
    finished: "Toutes les tentatives sont terminées. Aucune barre à saisir.",
    noHeightsAvailable:
      "Aucune hauteur modifiable actuellement. Adressez-vous au secrétariat si nécessaire.",

    recordPermissions: "Records autorisant le pas de 0,5 kg",
    recordPermissionsHelp:
      "Aucun par défaut. Sélectionner uniquement les disciplines, organismes et catégories dont les records sont admissibles pour cette compétition. Le seuil tient compte des barres déjà réussies.",
    recordException: "Autoriser un incrément réduit pour les records",
    recordStep: "Pas record",
    recordThreshold: "Seuil du record (calculé)",
    recordEligibility: "Record admissible (calculé)",
    recordBehaviorHelp:
      "Deux sorties Behavior en lecture seule : le seuil du record applicable et son admissibilité selon la discipline, la catégorie et la compétition. Sans seuil ou sans admissibilité, seul le pas ordinaire est autorisé.",

    ticketsToReview: "Tickets à vérifier",
    noAttemptAvailable:
      "La prochaine tentative sera disponible après validation du résultat précédent, hors verrouillage du plateau.",
    ticketSubmitted: "Ticket déjà saisi",
    retry: "Renvoyer la même demande",
    profileSettings: "Accès et identification",
    attemptStateRules: "Résultats et annonce",
    changeRules: "Modifications de tentative",
    profileHelp:
      "Choisissez les hauteurs et les tentatives accessibles sur téléphone, y compris les premiers essais, puis définissez le nombre de changements autorisés. Le poids de corps et les résultats restent au secrétariat. L’activation de la compétition est indépendante.",
    profileEnabled: "Autoriser ces champs pour la saisie athlète",
    profileInvalid:
      "Complétez les règles et vérifiez les champs sélectionnés avant d’activer ce profil.",
    nameFields: "Champs composant le nom affiché",
    field: "Champ",
    entryKind: "Type de saisie",
    min: "Minimum",
    max: "Maximum",
    step: "Incrément",
    attemptNumber: "Numéro de tentative (1 ou plus)",
    previousWeight: "Charge précédente",
    previousResult: "Résultat précédent",
    targetResult: "État de la tentative à saisir",
    successValue: "Valeur « réussi »",
    failedValue: "Valeur « échoué »",
    announcedValue: "Valeur « annoncé »",
    successIncrement: "Augmentation après réussite",
    autoField: "Charge proposée automatiquement",
    changesField: "Compteur des changements",
    maxChanges: "Changements autorisés",
    ticketReference: "Chronomètre du ticket",
    ticketReferenceHelp:
      "Référence du chronomètre Behavior. Variables disponibles : {athleteId}, {field}.",
    conditions: "Conditions d’ouverture (toutes requises)",
    allowedValues: "Valeurs autorisées, séparées par des virgules",
    addCondition: "Ajouter une condition",
    addField: "Ajouter un champ de saisie",
    remove: "Retirer",
    title: "Saisie athlète",
    openPage: "Page de saisie athlètes",
    manage: "Accès athlètes",
    enabled: "Activer la saisie sur téléphone",
    optional:
      "Option désactivée par défaut. Le secrétariat peut toujours effectuer les saisies.",
    groups: "Groupes autorisés",
    save: "Enregistrer",
    close: "Fermer",
    print: "Imprimer le QR code",
    code: "Code personnel",
    connect: "Se connecter",
    disconnect: "Se déconnecter",
    twoPhones:
      "Deux téléphones maximum par athlète. Le code peut être partagé avec le coach.",
    disabled: "La saisie sur téléphone est désactivée pour cette compétition.",
    offline: "Le poste plateau est indisponible. Adressez-vous au secrétariat.",
    online: "Poste plateau connecté",
    loading: "Connexion en cours…",
    athlete: "Athlète",
    showCode: "Afficher le code",
    replaceCode: "Remplacer le code et déconnecter les téléphones",
    revoke: "Déconnecter ce téléphone",
    replaceConfirm:
      "Remplacer le code ? Les téléphones connectés perdront leur accès.",
    sessions: "Téléphones connectés",
    noSessions: "Aucun téléphone connecté",
    heights: "Hauteurs",
    attempts: "Prochaines barres",
    submit: "Confirmer la saisie",
    locked: "Saisie verrouillée",
    current: "Valeur enregistrée",
    pending: "En cours de traitement - attendre la confirmation du plateau.",
    uncertain:
      "Confirmation à vérifier. Ne soumettez pas une nouvelle demande ; consultez le secrétariat.",
    applied: "Enregistré sur le poste plateau",
    rejected: "Saisie refusée",
    cancelled: "Demande annulée",
    late: "Ticket hors délai",
    unknownTime: "Temps ticket à vérifier",
    remaining: "Temps ticket restant",
    exceeded: "Temps ticket dépassé de",
    noTimer: "Temps ticket indisponible",
    lateNotice:
      "Vous pouvez envoyer la saisie ; le retard sera signalé au secrétariat.",
    timely: "Ticket reçu à temps",
    tickets: "Historique des saisies mobiles",
    review: "Marquer comme traité",
    reviewed: "Traité",
    note: "Décision / commentaire du secrétariat",
    receivedAt: "Réception serveur",
    appliedAt: "Enregistrement plateau",
    deadline: "Échéance du ticket",
    lateOnly: "Tickets hors délai ou à vérifier uniquement",
    emptyTickets: "Aucune saisie mobile enregistrée",
    refresh: "Actualiser",
    error: "Opération impossible",
    kg: "kg",
    squat1: "Squat - 1re barre",
    squat2: "Squat - 2e barre",
    squat3: "Squat - 3e barre",
    bench1: "Développé couché - 1re barre",
    bench2: "Développé couché - 2e barre",
    bench3: "Développé couché - 3e barre",
    deadlift1: "Soulevé de terre - 1re barre",
    deadlift2: "Soulevé de terre - 2e barre",
    deadlift3: "Soulevé de terre - 3e barre",
    hauteurSquat: "Hauteur squat",
    hauteurDc: "Hauteur développé couché",
    hauteurSecu: "Hauteur sécurités",
    errors: {
      SIGNATURE_REQUIRED:
        "Une signature est requise pour cette comp\u00e9tition.",
      SIGNATURE_CONFIRMATION_REQUIRED: "Veuillez signer et envoyer ce ticket.",
      SIGNATURE_ALREADY_CAPTURED:
        "La signature a d\u00e9j\u00e0 \u00e9t\u00e9 enregistr\u00e9e sur un autre t\u00e9l\u00e9phone. V\u00e9rifiez les valeurs puis signez et envoyez \u00e0 nouveau.",
      SIGNATURE_CANCELLED: "Signature annul\u00e9e : aucun ticket envoy\u00e9.",
      INVALID_CODE: "Code incorrect.",
      TWO_PHONES_CONNECTED:
        "Deux téléphones sont déjà connectés. Déconnectez un appareil ou contactez le secrétariat.",
      ENTRY_SESSION_EXPIRED:
        "Accès expiré ou révoqué. Reconnectez-vous ou contactez le secrétariat.",
      ENTRY_DISABLED: "La saisie sur téléphone est désactivée.",
      DESKTOP_OFFLINE: "Le poste plateau est indisponible.",
      PERSISTENCE_UNAVAILABLE:
        "L'enregistrement a échoué sur le poste plateau. La décision n'est pas confirmée. Actualisez puis réessayez.",
      CONFLICT: "Les données ont changé. Actualisez avant de recommencer.",
      LOCKED: "Cette saisie est verrouillée. Contactez le secrétariat.",
      INVALID_VALUE: "Valeur non autorisée.",
      COMMAND_PENDING:
        "Une saisie est déjà en cours. Attendez sa confirmation.",
      OTHER_DESKTOP_ACTIVE:
        "Un autre poste gère déjà les saisies mobiles de cette compétition.",
      RECOVERY_REQUIRED:
        "Une saisie doit être rapprochée avec le poste précédent avant la reprise.",
      ENTRY_KEY_REQUIRED:
        "Le chiffrement des codes doit être configuré sur le serveur.",
      ENTRY_UNAVAILABLE:
        "La page de saisie de cette compétition est indisponible.",
      COMMAND_CANCELLED: "Cette demande a été annulée.",
      INVALID_REQUEST: "Demande invalide.",
      ENTRY_OPERATOR_REQUIRED: "Accès réservé au secrétariat autorisé.",
    },
  },
  planningOutputs: {
    refereeField: "Champ d’arbitre du planning",
    selection: "Sélection dans le planning",
    single: "Choix unique",
    multiple: "Choix multiple",
    electronImport: "Import dans Electron",
    electronImportHelp:
      "Associez les informations du planning aux champs de la discipline. Les valeurs custom importées dans le planning sont conservées par leur clé.",
    customValueOnly: "Valeur custom uniquement",
    refereesRules: "Affectation des arbitres",
    minimum: "Minimum",
    maximum: "Maximum",
    unlimited: "0 = sans limite",
    exclusive: "Groupe d’exclusion",
    exclusiveHelp: "Vide = cumul autorisé",
    allowedRanks: "Grades autorisés",
    allowedRanksHelp: "Séparés par des virgules ; vide = tous les grades",
    assignmentError:
      "Affectation incompatible avec les règles de cette discipline.",
    policyHelp:
      "Les règles des disciplines du plateau s’appliquent à ces affectations.",
  },
  planningDisciplines: {
    yes: "Oui",
    no: "Non",
    section: "Planification",
    description:
      "Réglages proposés dans l’espace licencié. Les catégories d’âge et de poids proviennent du catalogue de cette discipline.",
    enabled: "Accessible dans l’outil de planification",
    movementCount: "Nombre de mouvements",
    attemptsPerMovement: "Essais par mouvement",
    seedField: "Performance utilisée pour répartir les athlètes",
    alphabetical: "Ordre alphabétique",
    perDiscipline: "Paramètres par discipline",
    perDisciplineHelp:
      "Chaque discipline conserve ses propres groupes et ses propres durées. Les réglages sont sauvegardés avec ce planning.",
    importProfile: "Profil d’import",
    autoDetect: "Plusieurs disciplines · détection par colonne",
    importHelp:
      "La colonne Discipline identifie chaque ligne. Les correspondances définies dans l’admin sont appliquées selon la discipline.",
    appendImport: "Ajouter aux athlètes existants",
    importIssues: "Certaines lignes n’ont pas été importées",
    importFailed:
      "L’import a échoué. Vérifiez le format du fichier et les colonnes.",
    noAthletes:
      "Aucun athlète importé : vérifiez les disciplines et les catégories.",
    ageCategory: "Catégorie d’âge",
    weightCategory: "Catégorie de poids",
    isHandisport: "Handisport",
    unknownCategory:
      "Catégorie incompatible avec cette discipline, ce sexe ou cet âge.",
    mixedPlateau: "Un plateau ne peut contenir qu’une seule discipline.",
    mixedGroup: "Un groupe ne peut contenir qu’une seule discipline.",
    restoreDefaults: "Reprendre les réglages de l’admin",
    importColumns: "Colonnes d’import",
    customFields: "Données de la discipline",
    generateError: "La génération n’a pas pu être terminée.",
    resumeExisting: "Reprendre le planning existant",
    resumeError: "Le planning existant n’a pas pu être ouvert.",
    disabledDiscipline:
      "La planification est désactivée pour cette discipline.",
    loading: "Chargement des disciplines…",
  },
  refereeing: {
    sounds: "Signaux sonores du chronomètre",
    screenTitle: "Titre de l’écran",
    buttonLabel: "Libellé de l’élément",
    appearance: "Élément",
    appearances: {
      BUTTON: "Bouton MUI",
      AREA: "Zone personnalisée",
      TEXT: "Texte",
    },
    addClickableElement: "Ajouter un élément cliquable",
    refresh: "Actualiser les profils",
    edit: "Modifier",
    title: "Arbitrage",
    classic: "Arbitrage classique",
    legacy: "Arbitrage legacy",
    profiles: "Profils partagés",
    newProfile: "Nouveau profil",
    profileName: "Nom du profil",
    screens: "Écrans",
    assignments: "Disciplines",
    rules: "Règles Behavior",
    layout: "Display Editor",
    addScreen: "Ajouter un écran",
    addButton: "Ajouter un bouton",
    role: "Poste",
    key: "Clé",
    label: "Libellé",
    enabled: "Actif",
    save: "Enregistrer le profil",
    saved: "Profil enregistré",
    remove: "Supprimer",
    back: "Retour aux profils",
    preview: "Aperçu interactif",
    command: "Commande",
    value: "Valeur",
    mode: "Système d’arbitrage",
    classicMode: "Classique · trois arbitres et jury",
    behaviorMode: "Personnalisé · résultat calculé par Behavior",
    sharedHint:
      "Un profil partagé produit un seul jeu de liens et de QR codes. Sans profil affecté, la discipline utilise les écrans d’arbitrage legacy.",
    rulesHint:
      "À chaque commande, Behavior reçoit inputValues.refereeing (votes, state, result, role, command). Le service refereeing accepte setState et publishResult via options. Les boutons et leurs Behavior se modifient dans Display Editor.",
    syncHint:
      "Dans Meet Manager, actualisez le catalogue des disciplines pour télécharger les profils, puis ouvrez Arbitrage.",
    discard: "Quitter sans enregistrer les modifications ?",
    assigned: "Déjà affectée à un autre profil",
    profile: "Profil d’arbitrage",
    selectDisciplines: "Disciplines de la compétition",
    none: "Aucun écran actif",
    pending: "Chargement de l’arbitrage…",
    commands: {
      vote: "Voter",
      startTimer: "Barre chargée / démarrer le chrono",
      resumeTimer: "Reprendre le chrono",
      stopTimer: "Arrêter le chrono",
      resetTimer: "Réinitialiser le chrono",
      resetLights: "Réinitialiser les votes",
      juryStop: "Discussion du jury",
      resetJuryMember: "Effacer le vote du jury",
      updateTimer: "Durée du chrono",
      updateResultDuration: "Durée des résultats",
      setState: "Mettre à jour l’état partagé",
      publishResult: "Publier le résultat Behavior",
    },
    errors: {
      REFEREE_PROFILE_INVALID: "Configuration d’arbitrage invalide.",
      REFEREE_DISCIPLINE_INVALID: "Discipline inconnue.",
      REFEREE_DISCIPLINE_ASSIGNED:
        "Cette discipline est déjà affectée à un autre profil.",
      REFEREE_CLASSIC_REQUIRED: "Le profil classique est nécessaire.",
      REFEREE_PROFILE_UNAVAILABLE:
        "Ce profil ou cet écran n’est pas disponible. Actualisez le catalogue dans Meet Manager.",
      REFEREE_PROFILE_INACTIVE:
        "L’arbitrage du groupe affiché utilise un autre profil.",
      REFEREE_CATALOG_UNAVAILABLE: "Le catalogue d’arbitrage est indisponible.",
      REFEREE_COMMAND_INVALID: "Commande invalide.",
      REFEREE_COMMAND_FAILED:
        "Commande non confirmée. Vérifiez l’état avant de réessayer.",
      REFEREE_VOTE_INVALID: "Vote invalide pour ce poste.",
      REFEREE_TIME_INVALID: "Utilisez le format minutes:secondes.",
    },
  },
  appName: "Meet Manager",
  accountSync: {
    synced: "Synchronisé",
    syncing: "Synchronisation…",
    offline: "Hors ligne",
    error: "Synchronisation en attente",
    partial: "Synchronisation partielle",
    ownershipConflictDetail:
      "Une compétition locale appartient à un autre compte et reste inchangée. Les autres compétitions de votre compte sont synchronisées.",
    "auth-required": "Connexion requise",
    detail:
      "Vos compétitions et groupes sont synchronisés automatiquement entre les appareils connectés à votre compte.",
    offlineDetail:
      "Modifications conservées sur cet appareil. La synchronisation reprendra au retour de la connexion.",
    authDetail:
      "Connectez-vous à votre compte pour synchroniser vos compétitions et groupes.",
    errorDetail:
      "Vos modifications sont conservées sur cet appareil. Une nouvelle tentative de synchronisation aura lieu automatiquement.",
    restoreDetail:
      "Cette compétition a été supprimée du compte. Réimportez-la comme nouvelle compétition pour synchroniser la copie conservée sur cet appareil.",
    identityConflictDetail:
      "Un groupe ou un athlète figure dans plusieurs compétitions. Retirez le doublon de la compétition concernée pour reprendre la synchronisation.",
    adoption: {
      title: "Examiner les anciennes copies",
      examine: "Examiner l'ancienne copie",
      detail:
        "Une ancienne copie de cette compétition contient des différences. Examinez-les avant sa première synchronisation.",
      description:
        "Comparez cette copie aux valeurs déjà partagées et choisissez les valeurs à conserver. Aucun rapprochement automatique n'a lieu pendant cet examen.",
      backupDetail:
        "La copie locale d'origine est sauvegardée durablement avant toute modification. Vous pourrez la retrouver dans Copies d'origine, même après validation.",
      nextPage: "Page suivante",
      previousPage: "Page précédente",
      differences: "Différences entre ancienne copie et données partagées",
      field: "Athlète / champ",
      local: "Ancienne copie",
      remote: "Valeur partagée",
      choice: "Valeur à conserver",
      localChoice: "Copie locale",
      remoteChoice: "Partagée",
      protected: "Partagée · protégée",
      empty: "-",
      emptyText: "(vide)",
      yes: "Oui",
      no: "Non",
      keepWeighIn: "Conserver ma pesée",
      keepShared: "Garder les valeurs partagées",
      weighInDetail:
        "La pesée conserve les poids de corps et premières barres modifiables de cette copie ; tous les autres champs prennent explicitement la valeur partagée.",
      remaining: (count: number) =>
        `${count} champ${count > 1 ? "s" : ""} nécessite${count > 1 ? "nt" : ""} encore un choix.`,
      additions: (count: number) =>
        `${count} élément${count > 1 ? "s" : ""} présent${count > 1 ? "s" : ""} uniquement dans cette copie ${count > 1 ? "seront" : "sera"} ajouté${count > 1 ? "s" : ""} après validation.`,
      competition: "Compétition",
      loading: "Chargement des différences…",
      saving: "Enregistrement…",
      confirm: "Appliquer ces choix",
      archive: "Archiver la copie locale",
      deleted:
        "Cette compétition a été supprimée du compte. L'archivage conserve la copie d'origine sans recréer la compétition partagée.",
      stale:
        "Les données ont changé depuis cet aperçu. Il a été rechargé et vos choix ont été effacés : vérifiez les nouvelles différences avant de valider.",
      saved: "Vos choix ont été enregistrés.",
      noReviews: "Aucune ancienne copie ne reste à examiner.",
      loadError:
        "Impossible de charger les copies à examiner. Vos données sont conservées. Réessayez ou redémarrez l’application si le problème persiste.",
      scoreUnavailable:
        "Le score ne peut pas être recalculé avec ces choix. Vérifiez le poids de corps, le sexe, la discipline et la formule, puis chargez les coefficients nécessaires avant de réessayer.",
      resolveError:
        "Impossible d'appliquer ces choix. Vos données sont conservées. Rechargez l'aperçu avant de réessayer.",
      archives: "Copies d'origine",
      reviewTab: "À examiner",
      archiveTab: "Archives",
      export: "Enregistrer la copie d'origine",
      exportSaved: "La copie d'origine a été enregistrée.",
      exportError: "Impossible d'enregistrer la copie d'origine. Réessayez.",
      noArchives: "Aucune copie d'origine archivée.",
      archiveDescription:
        "Ces copies sont conservées avant leur première synchronisation. Enregistrez-les en JSON pour garder un exemplaire indépendant.",
      archivedOn: "Sauvegardée le",
      pendingArchive: "Examen en attente",
      resolvedArchive: "Examen terminé",
    },
  },
  common: {
    kg: "kg",
    retry: "Réessayer",
    close: "Fermer",
    exitApplication: "Fermer l'application",
  },
  ahleteDisplay: "Athlète",
  refereeLightsDisplay: "Lumières d'arbitrage",
  LoaderDisplay: "Chargeurs",
  publicDisplay: "Classement public",
  disc: "Disc.",
  publicDisplayLabels: {
    discipline: "Discipline",
    name: "Nom",
    pdc: "PDC",
    category: "Catégorie",
    squat: "Squat",
    squat1: "Squat 1",
    squat2: "Squat 2",
    squat3: "Squat 3",
    bench: "Bench",
    bench1: "Bench 1",
    bench2: "Bench 2",
    bench3: "Bench 3",
    deadlift: "Deadlift",
    deadlift1: "Deadlift 1",
    deadlift2: "Deadlift 2",
    deadlift3: "Deadlift 3",
    totalAnnonced: "Total Annoncé",
    totalReal: "Total Réalisé",
    placement: "Place",
  },
  Live: "Direct",
  enableLive: "Activer le direct",
  enableLiveError: "Erreur lors de l'activation du direct",
  disableLive: "Désactiver le direct",
  refereeLights: "Lumières",
  liveEnabled: "Direct activé.",
  liveDisabled: "Direct désactivé.",
  liveAccessDenied:
    "Votre licence ne permet pas d'activer le direct. Contactez votre administrateur.",

  definePublic: "Définir public",
  definePrivate: "Définir privé",
  about: {
    title: "À propos de Meet Manager",
    version: "Version",
    logoAlt: "Logo Meet Manager",
    buildNumber: "Build n°",
    localFolder: "Dossier local",
  },
  home: "Accueil",
  webHome: {
    title: "Solution de Gestion de Compétition",
    subtitle:
      "Gérez vos compétitions de force athlétique en toute simplicité ! Centralisez l'organisation, suivez les performances en temps réel et affichez les résultats instantanément sur tous vos écrans. Un outil pensé pour les ligues et les clubs, fiable en compétition et prêt pour la diffusion en direct.",

    features: {
      title: "Fonctionnalités",
      subtitle:
        "Tous les outils dont vous avez besoin pour réussir vos compétitions",
      manager: {
        title: "Interface de saisie des résultats",
        description:
          "Saisissez rapidement les tentatives et suivez les performances en temps réel, sans perte de temps.",
      },
      displays: {
        title: "Affichages",
        description:
          "Projetez les informations clés sur plusieurs écrans pour le public, les officiels et les athlètes.",
      },
      groups: {
        title: "Centralisation des compétitions",
        description:
          "Centralisez la gestion de vos compétitions, leurs groupes et leurs athlètes. Toutes vos compétitions sont à portée de main, et sauvegardables en ligne.",
      },
      widgets: {
        title: "Ressources de direct",
        description:
          "Intégrez des widgets à votre diffusion en direct pour partager les résultats en temps réel.",
      },
      lights: {
        title: "Lumières d'arbitrage",
        description:
          "Numérisez l'arbitrage avec un système simple, rapide et connecté pour plus de fluidité en plateau. Synchronisez les lumières avec l'application pour un arbitrage automatique.",
      },
      webApp: {
        title: "Application web",
        description:
          "Offrez au public et aux clubs un accès direct aux résultats et classements depuis n'importe quel appareil.",
      },
    },
    pricing: {
      title: "Tarification",
      subtitle: "Des formules adaptées à vos besoins",
      leagues: {
        title: "Ligues",
        subtitle:
          "Ces forfaits donnent accès à l'application bureau pour les organisateurs de compétitions (ligues, clubs, etc.). Sélectionnez un forfait en fonction du nombre de jours de compétition que vous organisez.",
        oneDay: {
          title: "1 jour",
          price: "50 €",
          pricePerDay: "50 €/jour",
          description: "Accès pour 1 journée",
        },
        tenDays: {
          title: "Forfait 10 jours",
          price: "400 €",
          pricePerDay: "40 €/jour",
          description: "Utilisable librement sur l'année",
        },
        twentyDays: {
          title: "Forfait 20 jours",
          price: "700 €",
          pricePerDay: "35 €/jour",
          description: "Utilisable librement sur l'année",
        },
        twentyDaysPlus: {
          title: "Forfait 30 jours",
          price: "900 €",
          pricePerDay: "30 €/jour",
          description: "Utilisable librement sur l'année",
        },
      },
      streamer: {
        subtitle:
          "Des formules adaptées à vos besoins pour les diffuseurs de compétitions",
      },
      features: {
        fullAccess: "Accès complet à l'application",
        technicalSupport: "Support technique",
        prioritySupport: "Support prioritaire",
        athleteManagement: "Gestion des athlètes",
        groupManagement: "Gestion des groupes",
        yearlyValidity: "Utilisable sur 365 jours",
        unlimitedViewers: "Écrans spectateurs illimités",
        unlimitedLoaders: "Écrans chargeurs illimités",
      },
    },
    contact: {
      title: "Nous contacter",
      subtitle: "Une question ? Un besoin spécifique ? Contactez-nous !",
      form: {
        name: "Nom",
        email: "Email",
        subject: "Sujet",
        message: "Message",
        send: "Envoyer",
      },
    },
    services: {
      title: "Services",
      subtitle: "Plus qu'un logiciel, un partenaire pour vos compétitions",
      support: {
        title: "Support technique",
        description:
          "Un support technique 100% français pour vous accompagner dans l'utilisation de l'application.",
      },
      updates: {
        title: "Mises à jour régulières",
        description:
          "Notre équipe travaille en continu pour vous proposer les dernières fonctionnalités et améliorations.",
      },
      training: {
        title: "Formation",
        description:
          "Un guide d'utilisation détaillé vous est fourni pour vous aider à utiliser l'application. De plus, nous proposons des formations pour rendre votre équipe opérationnelle le plus rapidement possible.",
      },
      backup: {
        title: "Sauvegarde",
        description:
          "Nous vous proposons une sauvegarde de vos données sur nos serveur, accessible partout.",
      },
      customization: {
        title: "Personnalisation",
        description:
          "Besoin d'une fonctionnalité spécifique ? D'un export particulier ? Ou d'un affichage personnalisé ? Notre équipe est à votre disposition pour vous proposer une solution sur mesure.",
      },
    },
    cta: {
      title: "Prêt à transformer vos compétitions ?",
      subtitle:
        "Rejoignez l'avenir de la gestion de compétition avec Meet Manager",
      demo: "Demander une démo",
      try: "Services",
      start: "Demandez un devis",
    },
  },
  webFooter: {
    legalSectionTitle: "Légal",
    linkTerms: "Conditions d'utilisation",
    linkPrivacy: "Politique de confidentialité",
    linkLegal: "Mentions légales",
    linkCookies: "Cookies",
    brandDescription:
      "La solution complète pour la gestion de vos compétitions de force athlétique. Simplifiez l'organisation de vos événements.",
    copyright: (year: number) =>
      `© ${year} Meet Manager. Tous droits réservés.`,
    developedInFrance: "Développé en France par 9/9 solutions",
  },
  analyticsBanner: {
    message:
      "Nous collectons des statistiques anonymes de navigation (pages visitées, durées) pour améliorer le site. Aucune donnée personnelle n'est collectée.",
    privacyLink: "En savoir plus sur notre politique de confidentialité",
    acknowledge: "Compris",
  },
  legalPages: {
    lastUpdated: (formattedDate: string) =>
      `Dernière mise à jour : ${formattedDate}`,
    legalNotice: {
      breadcrumb: "Mentions légales",
      title: "Mentions légales",
      section1Title: "1. Éditeur du site",
      section1Body: `9/9 Solutions
Société par Actions Simplifiée (SAS)
Capital social : 2500€
Siège social : 3, place d'Orléans, 31380 Montastruc-la-Conseillère
Email : contact@9of9solutions.com`,
      section2Title: "2. Directeur de la publication",
      section2Body: `Marin Lespingal
En qualité de président`,
      section3Title: "3. Hébergeur",
      section3Body: `OVH
2, rue Kellermann, 59100 Roubaix
Téléphone : 09 72 10 10 07`,
      section4Title: "4. Propriété intellectuelle",
      section4Body:
        "L'ensemble du site meet-manager.com, y compris sa structure et son contenu (textes, images, graphismes, logos, icônes, sons, logiciels, etc.), est la propriété exclusive de Meet Manager. Toute reproduction, représentation, modification, publication, transmission, dénaturation, totale ou partielle du site ou de son contenu, par quelque procédé que ce soit, et sur quelque support que ce soit est interdite sans l'autorisation écrite préalable de Meet Manager.",
      section5Title: "5. Protection des données personnelles",
      section5Body:
        "Conformément à la loi Informatique et Libertés du 6 janvier 1978 modifiée et au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant. Pour exercer ces droits, contactez-nous à l'adresse : dpo@meet-manager.com",
      section6Title: "6. Cookies",
      section6Body:
        "Le site utilise des cookies pour améliorer l'expérience utilisateur. Pour plus d'informations sur l'utilisation des cookies, consultez notre politique de cookies.",
      section7Title: "7. Loi applicable et juridiction",
      section7Body:
        "Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.",
      section8Title: "8. Contact",
      section8Body:
        "Pour toute question concernant ces mentions légales, vous pouvez nous contacter à l'adresse : contact@9of9solutions.com",
    },
    terms: {
      breadcrumb: "Conditions d'utilisation",
      title: "Conditions d'utilisation",
      section1Title: "1. Acceptation des conditions",
      section1Body:
        "En accédant et en utilisant Meet Manager, vous acceptez d'être lié par ces conditions d'utilisation, toutes les lois et réglementations applicables, et acceptez que vous êtes responsable du respect des lois locales applicables.",
      section2Title: "2. Licence d'utilisation",
      section2Body:
        "Meet Manager vous accorde une licence limitée, non exclusive et non transférable pour utiliser le service conformément à ces conditions. Cette licence est strictement pour votre usage personnel et non commercial.",
      section3Title: "3. Comptes utilisateurs",
      section3Body:
        "Pour accéder à certaines fonctionnalités du service, vous devrez créer un compte. Vous êtes responsable de maintenir la confidentialité de votre compte et de votre mot de passe, et de restreindre l'accès à votre ordinateur.",
      section4Title: "4. Utilisation du service",
      section4Body: `Vous acceptez de ne pas utiliser le service pour :
- Des activités illégales ou frauduleuses
- La violation des droits de propriété intellectuelle
- La transmission de contenu malveillant
- Toute activité qui pourrait perturber le service`,
      section5Title: "5. Propriété intellectuelle",
      section5Body:
        "Le service et son contenu original, ses fonctionnalités et ses fonctionnalités sont la propriété de Meet Manager et sont protégés par les lois internationales sur le droit d'auteur et les marques.",
      section6Title: "6. Limitation de responsabilité",
      section6Body:
        "Meet Manager ne sera pas responsable des dommages directs, indirects, accessoires, spéciaux ou consécutifs résultant de l'utilisation ou de l'impossibilité d'utiliser le service.",
      section7Title: "7. Modifications des conditions",
      section7Body:
        "Meet Manager se réserve le droit de modifier ces conditions à tout moment. Les modifications entrent en vigueur immédiatement après leur publication sur le service.",
      section8Title: "8. Contact",
      section8Body:
        "Pour toute question concernant ces conditions d'utilisation, veuillez nous contacter à l'adresse suivante : contact@meet-manager.com",
    },
    privacy: {
      breadcrumb: "Politique de confidentialité",
      title: "Politique de confidentialité",
      section1Title: "1. Collecte des données",
      section1Body: `Nous collectons les informations que vous nous fournissez directement lorsque vous :
- Créez un compte
- Utilisez nos services
- Communiquez avec nous
- Participez à nos enquêtes ou promotions`,
      section2Title: "2. Types de données collectées",
      section2Body: `Les données personnelles que nous pouvons collecter incluent :
- Nom et prénom
- Adresse email
- Numéro de téléphone
- Informations de connexion
- Données d'utilisation du service`,
      section3Title: "3. Utilisation des données",
      section3Body: `Nous utilisons vos données personnelles pour :
- Fournir et maintenir nos services
- Améliorer nos services
- Communiquer avec vous
- Assurer la sécurité de nos services
- Se conformer aux obligations légales`,
      section4Title: "4. Protection des données",
      section4Body:
        "Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données personnelles contre l'accès, la modification, la divulgation ou la destruction non autorisés.",
      section5Title: "5. Partage des données",
      section5Body: `Nous ne vendons pas vos données personnelles. Nous pouvons partager vos informations avec :
- Nos prestataires de services
- Les autorités légales si requis
- Des tiers avec votre consentement`,
      section6Title: "6. Vos droits",
      section6Body: `Conformément au RGPD, vous avez le droit de :
- Accéder à vos données
- Rectifier vos données
- Supprimer vos données
- Limiter le traitement
- Porter vos données
- Vous opposer au traitement`,
      section7Title: "7. Cookies",
      section7Body:
        "Nous utilisons des cookies pour améliorer votre expérience. Vous pouvez contrôler les cookies via les paramètres de votre navigateur.",
      section8Title: "8. Contact",
      section8Body:
        "Pour toute question concernant notre politique de confidentialité ou pour exercer vos droits, contactez notre délégué à la protection des données : dpo@meet-manager.com",
    },
    cookies: {
      breadcrumb: "Politique de cookies",
      title: "Politique de cookies",
      section1Title: "1. Qu'est-ce qu'un cookie ?",
      section1Body:
        "Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, tablette ou mobile) lors de la visite d'un site web. Il permet au site de mémoriser des informations sur votre visite, comme votre langue préférée et d'autres paramètres.",
      section2Title: "2. Types de cookies utilisés",
      section2Intro: "Nous utilisons différents types de cookies :",
      section2EssentialTitle: "Cookies essentiels :",
      section2EssentialBody: `- Authentification et sécurité
- Gestion de session
- Préférences de base`,
      section2PerformanceTitle: "Cookies de performance :",
      section2PerformanceBody: `- Analyse du trafic
- Statistiques d'utilisation
- Optimisation des performances`,
      section2FunctionalityTitle: "Cookies de fonctionnalité :",
      section2FunctionalityBody: `- Personnalisation de l'interface
- Sauvegarde des préférences
- Fonctionnalités sociales`,
      section3Title: "3. Durée de conservation",
      section3Body: `Nous utilisons deux types de cookies selon leur durée :
- Cookies de session : supprimés à la fermeture du navigateur
- Cookies persistants : conservés pour une durée définie (maximum 13 mois)`,
      section4Title: "4. Gestion des cookies",
      section4Body: `Vous pouvez à tout moment choisir de désactiver ces cookies. Votre navigateur peut également être paramétré pour vous signaler les cookies qui sont déposés dans votre terminal et vous demander de les accepter ou non.

Pour gérer les cookies, vous pouvez configurer votre navigateur :
- Chrome : Menu > Paramètres > Confidentialité et sécurité > Cookies
- Firefox : Menu > Options > Vie privée et sécurité
- Safari : Menu > Préférences > Confidentialité
- Edge : Menu > Paramètres > Confidentialité et services`,
      section5Title: "5. Cookies tiers",
      section5Body: `Certains cookies sont déposés par des services tiers pour :
- L'analyse d'audience (Google Analytics)
- Les fonctionnalités sociales
- La publicité personnalisée`,
      section6Title: "6. Impact de la désactivation des cookies",
      section6Body: `La désactivation des cookies peut empêcher l'utilisation de certaines fonctionnalités du site, notamment :
- L'accès à votre espace personnel
- La mémorisation de vos préférences
- Certaines fonctionnalités interactives`,
      section7Title: "7. Mise à jour de la politique",
      section7Body:
        "Nous nous réservons le droit de modifier cette politique de cookies à tout moment. Les modifications prennent effet dès leur publication sur le site.",
      section8Title: "8. Contact",
      section8Body:
        "Pour toute question concernant notre politique de cookies, contactez-nous à : privacy@meet-manager.com",
    },
  },
  navigation: {
    administration: "Administration",
    licensedPortal: "Espace licencié",
    displayEditorPortal: "Éditeur d'affichages",
    speakerPortal: "Espace speaker",
    backToHome: "Retour à l'accueil",
    logIn: "Se connecter",
    logOut: "Se déconnecter",
  },
  // Portal shell sidebars (Licensed + Admin workspace tabs)
  portalNav: {
    licensedTitle: "Espace licencié",
    adminTitle: "Administration",
    toggleSidebar: "Afficher / masquer le menu",
    collapseSidebar: "Masquer le menu",
    expandSidebar: "Afficher le menu",
    groups: {
      home: "Mon espace",
      competition: "Compétition",
      display: "Affichage",
      live: "Live",
      speaker: "Speaker",
      accounts: "Comptes",
      competitions: "Compétitions",
      federation: "Fédéral",
      tools: "Outils",
    },
    items: {
      profile: "Mon profil",
      myLicense: "Ma licence",
      installer: "Installateur",
      acceptedTerms: "Conditions acceptées",

      dashboard: "Tableau de bord",
      myMeets: "Mes compétitions",
      myRecords: "Mes records",
      myLevels: "Mes niveaux",
      myReferees: "Mes arbitres",
      backups: "Sauvegardes",
      layouts: "Mes affichages",
      themes: "Mes thèmes",
      controlRoom: "Régie",
      speakerLanding: "Espace speaker",
      users: "Utilisateurs",
      licenses: "Licences",
      licenseTerms: "Conditions",
      meets: "Meets",
      organisations: "Organisations",
      referees: "Arbitres",
      themesAdmin: "Thèmes",
      levels: "Niveaux",
      records: "Records",
      analytics: "Analytics",
      testExport: "Test Export",
      ffForceExport: "Export FFForce",
      planningTab: (name: string) => (name ? name : "Planning"),
      planningCreatedTab: (name: string) => (name ? name : "Planning"),
      layoutEditorTab: (name: string) => `Éditeur · ${name}`,
      meetDetailTab: (name: string) => `Compétition · ${name}`,
      backupDetailTab: (name: string) => `Backup · ${name}`,
      backupMeetTab: (name: string) => `Backups · ${name}`,
      liveTab: (name: string) => `Live · ${name}`,
    },
  },
  meet: {
    success: {
      imported: "Compétition importée avec succès",
    },
    confirm: {
      overwriteMeet: (existing: string, incoming: string) =>
        `La compétition "${incoming}" va remplacer la compétition existante "${existing}". Voulez-vous continuer ?`,
    },
    importSynchronisedMeet: "Importer une compétition synchronisée",
    groupCount: "Groupes",
    title: "Compétition",
    name: "Nom",
    date: "Date",
    startDate: "Date de début",
    endDate: "Date de fin",
    location: "Lieu",
    ville: "Ville",
    streamUrl: "URL de Stream",
    streamUrlPlaceholder:
      "YouTube: youtube.com/watch?v=xxx ou @channel | Twitch: twitch.tv/channel",
    streamUrlHelper: "YouTube/Twitch",
    isNational: "Compétition nationale",
    isNationalHelper:
      "Les placements regroupent toutes les catégories d’âge, par sexe, discipline et catégorie de poids.",
    pointsFormula: "Formule de points",
    pointsFormulaGl: "GL (IPF Goodlift)",
    pointsFormulaDots: "DOTS",
    pointsFormulaHelper:
      "Formule utilisée pour calculer l'indice (points = total × indice).",
    description: "Description",
    selectMeet: "Sélectionner une compétition",
    currentMeet: "Compétition actuelle",
    selectExistingMeet: "Sélectionner une compétition existante",
    createNewMeet: "Créer une nouvelle compétition",
    saved: "Compétition enregistrée",
    created: "Compétition créée",
    deleted: "Compétition supprimée",
    error: {
      leagueRequired:
        "Veuillez sélectionner une organisation avant de créer la compétition.",
      creationFailed:
        "Impossible de créer la compétition. Vérifiez les informations saisies et réessayez.",
      prismaGeneric:
        "Une erreur technique est survenue lors de l'enregistrement. Réessayez ou contactez le support.",
    },
    confirmDeleteTitle: "Confirmer la suppression",
    confirmDelete:
      "Voulez-vous vraiment supprimer cette compétition ? Tous les groupes liés seront également supprimés. Cette action est irréversible.",
    deleteAthleteConfirm:
      "Voulez-vous vraiment supprimer cet athlète ? Tous les groupes liés seront également supprimés.",

    importMatchSheet: "Importer la feuille de match",
    importSynchronisedGroup: "Importer un groupe synchronisé",
    noGroupFound: "Aucun groupe n'a été trouvé",
    noMeetFound: "Aucune compétition n'a été trouvé",
    nbAthletes: "Athlètes",
    // Formats de compétition
    formats: {
      fullPower: "FA/PL",
      singleLift: "DC/BP",
    },
    selectFormat: "Format",
    formatDescription: {
      fullPower: "Compétition avec squat, développé couché et soulevé de terre",
      singleLift: "Compétition avec uniquement le développé couché",
    },
    validation: {
      incompatibleDisciplines:
        "Disciplines incompatibles avec le format du groupe",
      selectCompatibleDiscipline: "Sélectionnez une discipline compatible",
      tooFast:
        "Validation automatique trop rapide. Veuillez attendre 5 secondes avant de valider à nouveau.",
    },
    tabs: {
      createOrImportMatchSheet: "Créer / Importer (Feuille de match)",
      importSyncPlanning: "Importer (Synchronisation / Planning)",
    },
    fromPlanning: {
      createFromPlanning: "Créer depuis un planning",
      myPlannings: "Mes plannings",
      selectPlanning: "Sélectionner un planning",
      noPlanningFound: "Aucun planning trouvé",
      refresh: "Rafraîchir",
      searchMeet: "Rechercher une compétition",
      searchPlanning: "Rechercher un planning",
      overwriteConfirm:
        "Cette compétition existe déjà. L'importer à nouveau écrasera les données existantes. Continuer ?",
      statusOnlyCreated:
        "Seuls les plannings finalisés (statut « Créé ») peuvent être importés.",
      missingRefereesInfo:
        "Certains rôles d'arbitres ne sont pas attribués sur un ou plusieurs plateaux.",
      errorLoadPlannings: "Impossible de charger la liste des plannings.",
      errorCreateMeet: "Impossible de créer la compétition depuis le planning.",
      statusColumn: "Statut",
    },
    import: {
      formatDetected: "Format détecté automatiquement",
      fullPowerDetected: "Format 3 mouvements détecté (FA/PL)",
      singleLiftDetected: "Format 1 mouvement détecté (DC/BP)",
      formatDetectionFailed:
        "Impossible de détecter le format, utilisation du format par défaut",
      missingFieldError: (fieldName: string, cellAddress?: string) =>
        cellAddress
          ? `Le champ "${fieldName}" est requis mais absent ou vide dans le fichier d'import (cellule ${cellAddress})`
          : `Le champ "${fieldName}" est requis mais absent ou vide dans le fichier d'import`,
      niveaux: {
        fullPowerFormat:
          "Format attendu : Niveaux basés sur le total des 3 mouvements",
        singleLiftFormat:
          "Format attendu : Niveaux basés sur le développé couché uniquement",
      },
      records: {
        fullPowerFormat:
          "Format attendu : Records pour squat, bench, deadlift et total",
        singleLiftFormat:
          "Format attendu : Records pour le développé couché uniquement",
      },
      downloadGenericTemplate: "Télécharger le modèle d'import",
      generateLots: "Générer les lots automatiquement",
      generateLotsHint:
        "Si tous les lots du fichier sont déjà renseignés, ils sont conservés. Sinon, des lots aléatoires uniques (1…N) sont attribués à tous les athlètes.",
      noImportEnabled: "L'import n'est pas activé pour votre organisation",
      allowedFormats: (formats: string) => `Formats autorisés : ${formats}`,
      formatUnknown:
        "Format de fichier non reconnu. Utilisez une feuille FFForce ou le modèle d'import Meet Manager.",
      formatNotAllowed:
        "Ce format d'import n'est pas autorisé pour votre organisation",
      formatAmbiguous: "Impossible de déterminer le format du fichier",
      invalidDiscipline: (value: string, sheet: string, row: number) =>
        `Discipline invalide « ${value} » (onglet ${sheet}, ligne ${row})`,
      invalidAgeCategory: (value: string, sheet: string, row: number) =>
        `Catégorie d'âge invalide « ${value} » (onglet ${sheet}, ligne ${row})`,
      invalidWeightCategory: (value: string, sheet: string, row: number) =>
        `Catégorie de poids invalide « ${value} » (onglet ${sheet}, ligne ${row})`,
      ageCategoryDisciplineMismatch: (
        ageValue: string,
        discipline: string,
        sheet: string,
        row: number,
      ) =>
        `Catégorie d'âge « ${ageValue} » incompatible avec la discipline « ${discipline} » (onglet ${sheet}, ligne ${row})`,
      weightCategorySexMismatch: (
        weightValue: string,
        sex: string,
        sheet: string,
        row: number,
      ) =>
        `Catégorie de poids « ${weightValue} » incompatible avec le sexe « ${sex} » (onglet ${sheet}, ligne ${row})`,
      invalidSex: (value: string, sheet: string, row: number) =>
        `Sexe invalide « ${value} » (onglet ${sheet}, ligne ${row})`,
      missingAthleteName: (sheet: string, row: number) =>
        `Nom ou prénom manquant (onglet ${sheet}, ligne ${row})`,
      missingSex: (sheet: string, row: number) =>
        `Sexe manquant (onglet ${sheet}, ligne ${row})`,
      missingDiscipline: (sheet: string, row: number) =>
        `Discipline manquante (onglet ${sheet}, ligne ${row})`,
      missingAgeCategory: (sheet: string, row: number) =>
        `Catégorie d'âge manquante (onglet ${sheet}, ligne ${row})`,
      missingWeightCategory: (sheet: string, row: number) =>
        `Catégorie de poids manquante (onglet ${sheet}, ligne ${row})`,
      // Fallback when Prisma rejects null catAgeId/catPoidId (should be rare after row validation)
      categoryRequiredDb:
        "Catégorie d'âge ou de poids manquante - renseignez age_category et weight_category.",
      noGroupsInWorkbook: "Aucun groupe trouvé dans le classeur",
      organisationNotMatched: (value: string) =>
        `Organisation « ${value} » introuvable dans vos organisations - l'organisation du formulaire a été conservée.`,
      capabilityFfForce: "Feuille FFForce",
      capabilityGeneric: "Import Excel",
    },
  },
  dragAndDrop: {
    defaultMessage: "Glissez-déposez vos fichiers ici",
    filesSelected: "fichiers sélectionnés",
    unsupportedFormat: (fileName: string) =>
      `Format de fichier non supporté: ${fileName}`,
    fileProcessingError: (fileName: string) =>
      `Erreur lors du traitement du fichier: ${fileName}`,
  },
  browseFiles: "Sélectionner un fichier",
  supportedFiles(extensions: string[]) {
    return `Fichiers pris en charge : ${extensions?.join(", ").toUpperCase()}`;
  },
  league: "Organisation",
  webClient: "Application web",
  leagues: {
    title: "Organisations",
    name: "Nom",
    description: "Description",
    selectLigue: "Sélectionner une organisation",
    currentLigue: "Organisation actuelle",
    selectExistingLigue: "Sélectionner une organisation existante",
    createNewLigue: "Créer une nouvelle organisation",
  },
  keyBinds: {
    title: "Raccourcis",
    keybind: "Raccourci",
    key: "Touches",
    bindingError: (value: string) => {
      return `Vous devez obligatoirement combiner la touche "${value}" avec une seconde touche.`;
    },
    pressAKey: "Appuyez sur des touches...",
    keybindName: (keybind: string) => {
      switch (keybind) {
        case "validateLift":
          return "Valider la barre";
        case "failLift":
          return "Invalider la barre";
        case "resetLift":
          return "Réinitialiser la barre";
        case "validateAuto":
          return "Valider la barre de l'athlète actuel";
        case "failAuto":
          return "Invalider la barre de l'athlète actuel";
        default:
          return "";
      }
    },
  },
  category: "Catégorie",
  group: "Groupe",
  groups: {
    historyConflict:
      "Cette action ne peut pas être appliquée car les données ont changé entre-temps. Aucune donnée n'a été écrasée. Vérifiez les valeurs actuelles avant de réessayer.",
    historyRestoreUnavailable:
      "Cette fiche ne peut pas être restaurée ici. Une suppression synchronisée nécessite de créer une nouvelle copie dans un groupe existant.",
    historyRestoredAsCopy:
      "L'athlète a été restauré dans une nouvelle fiche. La suppression de l'ancienne fiche est conservée.",
    status: "Statut",
    statusLabels: {
      upcoming: "À venir",
      openerToEnter: "Openers à saisir",
      completed: "Terminé",
    },
    synchronisationSuccess: "Groupe synchronisé avec succès",
    action: {
      import: "Importer",
    },
    confirm: {
      title: "Confirmer l'action",
      overwriteGroup: (existing: string, incoming: string) =>
        `Le groupe "${incoming}" va remplacer le groupe existant "${existing}". Voulez-vous continuer ?`,
      confirmLabel: "Écraser",
      cancelLabel: "Annuler",
      exceedBarChangeLimit: {
        title: "Limite de changements atteinte",
        message: (liftField: string, count: number, max: number) =>
          `Cette barre (${liftField}) a déjà été modifiée ${count} fois sur ${max} autorisé(s). Voulez-vous quand même continuer ?`,
      },
    },
    success: {
      imported: "Groupe importé avec succès",
    },
    error: {
      default: "Une erreur est survenue",
      duplicateAthleteImport: (athleteName: string, groupName: string) =>
        `Import impossible: l'athlète "${athleteName}" existe déjà dans le groupe "${groupName}".`,
    },
    new: "Nouveau groupe",
    title: "Groupes",
    plateauSection: (n: number) => `Plateau ${n}`,
    noPlateauSection: "Sans plateau",
    name: "Nom",
    description: "Description",
    selectGroup: "Sélectionner un groupe",
    currentGroup: "Groupe actuel",
    selectExistingGroup: "Sélectionner un groupe existant",
    createNewGroup: "Créer un nouveau groupe",
    added: "Groupe créé avec succès.",
    updated: "Groupe mis à jour avec succès.",
    deleted: "Groupe supprimé avec succès.",
    plateauNumber: "Plateau",
    groupNumber: "Groupe",
    jury: "Jury",
    chefPlateau: "Chef de plateau",
    assesseur1: "Assesseur 1",
    assesseur2: "Assesseur 2",
    secretaire: "Secrétaire",
    observations: "Observations",
    editModal: {
      title: "Modifier le groupe",
      open: "Modifier le groupe",
      save: "Enregistrer",
      cancel: "Annuler",
    },
    selectFormatModal: {
      title: "Choisir le format du groupe",
      cancel: "Annuler",
      loading: "Chargement des disciplines…",
      syncError: "Impossible de charger les disciplines personnalisées.",
    },
    createModal: {
      title: "Créer un groupe",
      save: "Enregistrer",
      cancel: "Annuler",
    },
    actions: "Actions des groupes",
    rowActionsColumn: "Actions",
    exportFeuilleFederation: "Feuille fédération",
    exportFeuilleFederationMeetManager: "Feuille fédération (Meet Manager)",
    exportFeuilleFederationMeetManagerDescription:
      "Export au format Feuille fédération (Meet Manager)",
    exportFeuilleFederationMacroExcel: "Feuille fédération (Macro Excel)",
    exportFeuilleFederationMacroExcelDescription:
      "Export au format Feuille fédération (Macro Excel)",
    exportResultat: "Export des résultat",
    exportSuccess: "Export réussi",
    exportOpenPowerlifting: "Export OpenPowerlifting",
    exports: "Exports",
    export: "Exporter",
    selectSheetDate: {
      title: "Sélectionner la feuille fédération",
      question: "Quel feuille fédération voulez vous utiliser ?",
      select: "Sélectionner",
      cancel: "Annuler",
      loading: "Chargement des feuilles fédération...",
      error: "Erreur lors du chargement des feuilles fédération",
    },
    tooltips: {
      synchroGroup: "Synchroniser le groupe",
      autoProposal: "Charge proposée automatiquement",
      auto: "Barre validée automatiquement par les arbitres",
      overturn: "Le jury est revenu sur la décision",
      automaticRefereeing:
        "Valide ou invalide automatiquement la barre de l'athlète en cours à partir des lumières d'arbitrage",
      automaticRefereeingDisabled:
        "Vous devez activer les lumières d'arbitrage pour utiliser l'arbitrage automatique",
      undo: "Annuler la dernière modification (Ctrl+Z)",
      redo: "Rétablir la dernière modification annulée (Ctrl+Y)",
      validate: (shortcut: string, shortcutAuto: string) =>
        `Valider la barre de l'athlète sélectionné (${shortcut} ou ${shortcutAuto} pour l'athlète en cours)`,
      fail: (shortcut: string, shortcutAuto: string) =>
        `Marquer la barre comme ratée (${shortcut} ou ${shortcutAuto} pour l'athlète en cours)`,
      reset: (shortcut: string) =>
        `Réinitialiser le statut de la barre (${shortcut})`,
      orderByBar: "Trier les athlètes par ordre de passage à la barre",
      orderByCategory: "Trier les athlètes par catégorie",
      start: "Démarrer l'affichage du groupe",
      stop: "Arrêter l'affichage du groupe",
      addAthlete: "Ajouter un nouvel athlète au groupe",
      deleteAthlete: "Supprimer l'athlète du groupe",
      moveAthlete: "Déplacer l'athlète du groupe",
      export: "Exporter les données du groupe",
      columns: "Gérer l'affichage des colonnes",
      density: "Ajuster la densité d'affichage",
      exportFeuilleFederation: "Exporter la feuille fédération",
      exportOpenPowerlifting:
        "Exporter les données de la compétition au format OpenPowerlifting",
      barChanges: (count: number, max: number) =>
        `${count} changement(s) sur ${max} autorisé(s)`,
      ticketTime: "Temps ticket",
      ticketTimeExpired: "Temps ticket dépassé",
    },
    messages: {
      barChangesCancelled: "Modification de la barre annulée",
    },
  },
  barOrder: {
    title: "Ordre de passage des barres",
    print: "Ordre de passage",
    squatOrder: "Ordre de passage - Squat",
    benchOrder: "Ordre de passage - Développé couché",
    deadliftOrder: "Ordre de passage - Soulevé de terre",
    group: "Groupe",
    athlete: "Athlète",
    weight: "Poids (kg)",
    order: "Ordre",
    selectGroups: "Sélectionner les groupes à imprimer",
    selectAll: "Tout sélectionner",
    deselectAll: "Tout désélectionner",
    noGroupSelected: "Aucun groupe sélectionné",
  },
  tickets: {
    tickets: "Engagements",
    discipline: "Discipline : ",
    lastName: "NOM :",
    firstName: "Prénom :",
    drawNum: "N° tirage au sort :",
    sex: "Sexe :",
    birthDate: "Date de naissance :",
    ageCategory: "Catégorie d'âge :",
    athleteVisa: "Visa de l'athlète :",
    club: "Club :",
    licenceNumber: "N° de licence :",
    bodyweight: "Poids de corps :",
    opener: "Barre de départ",
    firstTry: "1er essai",
    secondTry: "2° essai",
    thirdTry: "3° essai",
    modifThirdTry: "Modif 3° essai",
    result: "Résultat",
    squat: "Squat",
    bench: "Dév. Couché",
    deadlift: "Soulevé de Terre",
    supportHeight: "Hauteur support :",
    hauteurDC: "H support",
    hauteurSecu: "H sécurité",
    cales: "Cales :",
    height: "Hauteur :",
    yes: "O",
    no: "N",
  },
  catage: {
    title: "Catégories d'âge",
    name: "Nom",
    nomRecord: "Nom pour import",
    description: "Description",
    selectCatage: "Sélectionner une catégorie d'âge",
    currentCatage: "Catégorie d'âge actuelle",
    selectExistingCatage: "Sélectionner une catégorie d'âge existante",
    createNewCatage: "Créer une nouvelle catégorie d'âge",
    added: "Catégorie d'âge créée avec succès.",
    updated: "Catégorie d'âge mise à jour avec succès.",
    deleted: "Catégorie d'âge supprimée avec succès.",
    minAge: "Age minimum",
    maxAge: "Age maximum",
    interdit: "INTERDIT",
  },
  catpoid: {
    title: "Catégories de poids",
    name: "Nom",
    description: "Description",
    selectCatpoid: "Sélectionner une catégorie de poids",
    currentCatpoid: "Catégorie de poids actuelle",
    selectExistingCatpoid: "Sélectionner une catégorie de poids existante",
    createNewCatpoid: "Créer une nouvelle catégorie de poids",
    added: "Catégorie de poids créée avec succès.",
    updated: "Catégorie de poids mise à jour avec succès.",
    deleted: "Catégorie de poids supprimée avec succès.",
    minWeight: "Poids minimum",
    maxWeight: "Poids maximum",
    isJunior: "Catégorie junior",
    errorMinMax: "Le poids maximum doit être supérieur au poids minimum.",
    nbAthletes: "Athlètes",
  },
  openers: "Openers",
  identification: "Identification",
  techniques: "Informations techniques",
  athletes: {
    title: "Athlètes",
    licence: "Licen.",
    club: "Club",
    sexe: "Sexe",
    dateNaissance: "Date de \nNaissance",
    nom: "Nom",
    prenom: "Prénom",
    fullName: "Nom complet",
    pdc: "PDC",
    indice: "Indice",
    /** Column header for realised points; depends on meet scoring formula. */
    points: (formula?: string) =>
      String(formula ?? "").toUpperCase() === "DOTS" ? "DOTS" : "Points GL",
    /** Column header for announced points; depends on meet scoring formula. */
    pointsAnnonced: (formula?: string) =>
      String(formula ?? "").toUpperCase() === "DOTS"
        ? "DOTS annoncés"
        : "Points GL annoncés",
    lot: "Lot",
    squat1: "1",
    squat2: "2",
    squat3: "3",
    bench1: "1",
    bench2: "2",
    bench3: "3",
    deadlift1: "1",
    deadlift2: "2",
    deadlift3: "3",
    totalkg: "Total RÉALISÉ",
    totalAnnonce: "Total ANNONCÉ",
    placement: "Class.",
    hauteurSquat: "Hauteur Squat",
    hauteurDc: "Hauteur DC",
    hauteurSecu: "Hauteur Sécurité",
    cales: "Cales",
    positionRack: "Position Rack",
    // Canonical storage values; labels match DB (INT/EXT/1/2 G/1/2 D)
    rackPositions: {
      ext: "EXT",
      int: "INT",
      demiDroit: "1/2 D",
      demiGauche: "1/2 G",
    },
    catAge: "Catégorie d'âge",

    catAgeN1: "Catégorie d'âge N+1",
    isDisqualified: "Hors Match",
    catPoid: "Catégorie de poid",
    hm: "HM",
    disqualified: "Disqualifié(e)",
    dq: "DQ",
    niveau: "Niveau",
    niveauAnnonced: "Niveau annoncé",
    niveauN1: "Niveau N+1",
    niveauDpt: "dépt.",
    discipline: "Discipline",
  },
  powerscout: {
    notSupported: "Discipline non supportée par Powerscout",
    columnHeader: "Info",
    notSynced: "Non synchronisé",
    notFound: "Non trouvé dans Powerscout",
    syncError: "Erreur de synchronisation",
    syncStarted: (count: number) =>
      `Synchronisation Powerscout démarrée pour ${count} athlète${count > 1 ? "s" : ""}`,
    serverUnreachable:
      "Le serveur Powerscout n'est pas joignable. Vérifiez votre connexion réseau.",
    pending: "En attente",
    syncedOn: (date: string) => `Synchronisé le ${date}`,
    squatBest: (kg: string, meetName: string, meetDate: string) =>
      `Squat: ${kg}kg (${meetName}, ${meetDate})`,
    benchBest: (kg: string, meetName: string, meetDate: string) =>
      `Bench: ${kg}kg (${meetName}, ${meetDate})`,
    deadliftBest: (kg: string, meetName: string, meetDate: string) =>
      `Deadlift: ${kg}kg (${meetName}, ${meetDate})`,
    totalBest: (kg: string, meetName: string, meetDate: string) =>
      `Total: ${kg}kg (${meetName}, ${meetDate})`,
    glBest: (points: string, meetName: string, meetDate: string) =>
      `GL: ${points} points (${meetName}, ${meetDate})`,
    squat1SuccessRate: (rate: string) => `Taux de réussite Squat 1: ${rate}%`,
    squat2SuccessRate: (rate: string) => `Taux de réussite Squat 2: ${rate}%`,
    squat3SuccessRate: (rate: string) => `Taux de réussite Squat 3: ${rate}%`,
    bench1SuccessRate: (rate: string) => `Taux de réussite Bench 1: ${rate}%`,
    bench2SuccessRate: (rate: string) => `Taux de réussite Bench 2: ${rate}%`,
    bench3SuccessRate: (rate: string) => `Taux de réussite Bench 3: ${rate}%`,
    deadlift1SuccessRate: (rate: string) =>
      `Taux de réussite Deadlift 1: ${rate}%`,
    deadlift2SuccessRate: (rate: string) =>
      `Taux de réussite Deadlift 2: ${rate}%`,
    deadlift3SuccessRate: (rate: string) =>
      `Taux de réussite Deadlift 3: ${rate}%`,
    na: "N/A",
    selectLifter: "Sélectionner l'athlète Powerscout",
    multipleMatches: "Plusieurs athlètes trouvés - cliquer pour sélectionner",
    noMatchesFound: "Aucun athlète trouvé",
    birthYear: "Année de naissance",
    country: "Pays",
    bestTotal: "Meilleur total",
    lastCompetition: "Dernière compétition",
    select: "Sélectionner",
    actions: "Actions",
    name: "Nom",
    sex: "Sexe",
    searchPlaceholder: "Rechercher par nom…",
    searchButton: "Rechercher sur Powerscout",
    changeLink: "Changer",
    searchTitle: "Recherche Powerscout",
    linkError: "Impossible d'associer l'athlète Powerscout",
    meetNotLive: "La compétition n'est pas en direct",
    authRequired: "Connexion requise pour rechercher sur Powerscout",
    sessionExpired: "Session expirée, veuillez vous reconnecter",
    linkSuccess: "Athlète Powerscout associé",
    competitionsTitle: "Historique des compétitions",
    competitionsButton: "Compétitions",
    competitionsEmpty: "Aucune compétition trouvée",
    competitionsLoadError: "Impossible de charger l'historique Powerscout",
    competitionDate: "Date",
    competitionName: "Compétition",
    competitionTown: "Ville",
    competitionFederation: "Fédération",
    competitionRegion: "Région",
    competitionDiscipline: "Discipline",
    competitionWeightClass: "Catégorie de poids",
    competitionAgeClass: "Catégorie d'âge",
    competitionAge: "Âge",
    competitionCategories: "Catégories",
    competitionBodyweight: "Poids de corps",
    competitionPlace: "Place",
    competitionTotal: "Total",
    competitionSquat: "Squat",
    competitionBench: "Développé couché",
    competitionDeadlift: "Soulevé de terre",
    competitionGoodlift: "GL",
    competitionDots: "Dots",
    competitionWilks: "Wilks",
    competitionMinima: "Minima",
    competitionResult: "Résultat",
    competitionHistory: "Voir l'historique",
    hypotheticalRankTooltip: "Classement Powerscout",
    hypotheticalRankTitle: "Classement Powerscout",
    hypotheticalRankSelected: "Perf sélectionnée",
    hypotheticalRankLoadError: "Impossible de charger le classement Powerscout",
    hypotheticalRankEmpty: "Aucun résultat dans avec ces filtres",
    hypotheticalRankShowMore: "Afficher plus",
    hypotheticalRankNational: "National",
    hypotheticalRankInternational: "International",
    hypotheticalRankFilterAge: "Catégorie d'âge",
    hypotheticalRankAgeSelectPlaceholder: "Sélectionner les catégories d'âge",
    hypotheticalRankAgeSelectEmpty: "Tous les âges",
    hypotheticalRankFilterWeight: "Catégorie de poids",
    hypotheticalRankWeightSelectPlaceholder:
      "Sélectionner les catégories de poids",
    hypotheticalRankWeightSelectEmpty: "Toutes les catégories de poids",
    hypotheticalRankWeightJunior: "Junior",
    hypotheticalRankFilterFederation: "Fédération",
    hypotheticalRankFederationSelectPlaceholder: "Sélectionner les fédérations",
    hypotheticalRankFederationSelectEmpty: "Toutes les fédérations",
    hypotheticalRankFilterYearFrom: "Année de début",
    hypotheticalRankFilterYearTo: "Année de fin",
    hypotheticalRankRank: "Rang",
    hypotheticalRankKg: "Poids",
    hypotheticalRankOf: (rank: number, total: number) => `${rank} / ${total}`,
    hypotheticalRankBar: (lift: string, kg: string) => `${lift} - ${kg} kg`,
    hypotheticalRankRecords: "Records fédération",
    hypotheticalRankRecordSquat: "Record squat",
    hypotheticalRankRecordBench: "Record développé couché",
    hypotheticalRankRecordDeadlift: "Record soulevé de terre",
    hypotheticalRankRecordTotal: "Record total",
    hypotheticalRankRecordBy: (name: string) => `par ${name}`,
    hypotheticalRankNoRecord: "Aucun record ",
  },
  success: {
    athleteAdded: "Athlète ajouté avec succès",
    importSuccess: {
      records: "Import des records terminé avec succès",
      niveaux: "Import des niveaux terminé avec succès",
    },
  },
  error: {
    noCellSelected:
      "Aucune cellule sélectionnée. Veuillez cliquer sur une cellule.",
    invalidCell: "Cellule invalide. Veuillez cliquer sur une cellule valide.",
    noAthleteSelected: "Aucun athlète sélectionné",
    athleteAddFailed: "Erreur lors de l'ajout de l'athlète",
    athleteDeleteFailed: "Erreur lors de la suppression de l'athlète",
    // Messages de warning pour les limites d'athlètes
    athleteLimitWarning: {
      first: "Vous approchez de la limite de votre licence",
      urgent: "Attention ! Vous approchez de la limite de votre licence",
    },
    // Messages d'erreur spécifiques pour l'ajout d'athlètes
    athleteLimitReached: {
      title: "Limite d'athlètes atteinte",
      message: "Vous avez atteint la limite d'athlètes de votre licence",
      details: "Limite atteinte : {current}/{max} athlètes",
      action: "Contactez votre administrateur pour augmenter votre quota",
    },
    athleteQuotaExceeded: {
      title: "Quota d'athlètes dépassé",
      message:
        "Impossible d'ajouter cet athlète car cela dépasserait votre quota",
      details:
        "Tentative d'ajout : {current} + {nonFinished} non terminés + 1 nouveau = {total}/{max}",
      action:
        "Terminez d'abord les athlètes en cours ou contactez votre administrateur",
    },
    athleteDataCorrupted: {
      title: "Données corrompues détectées",
      message:
        "Les données de comptage d'athlètes semblent avoir été modifiées",
      action:
        "Veuillez vous reconnecter en ligne pour synchroniser vos données",
    },
    // Messages d'erreur génériques
    databaseError: "Erreur de base de données",
    unknownError: "Erreur inconnue",
    retryOrContactSupport: "Veuillez réessayer ou contacter le support",
    // Fonctions pour les messages d'erreur d'athlètes
    getAthleteLimitError: (reason?: string) => ({
      title: "Limite d'athlètes atteinte",
      message:
        reason || "Vous avez atteint la limite d'athlètes de votre licence",
      action: "Contactez votre administrateur pour augmenter votre quota",
    }),
    getAthleteQuotaError: (reason?: string) => ({
      title: "Quota d'athlètes dépassé",
      message:
        reason ||
        "Impossible d'ajouter cet athlète car cela dépasserait votre quota",
      action:
        "Terminez d'abord les athlètes en cours ou contactez votre administrateur",
    }),
    getAthleteDataCorruptedError: (reason?: string) => ({
      title: "Données corrompues détectées",
      message:
        reason ||
        "Les données de comptage d'athlètes semblent avoir été modifiées",
      action:
        "Veuillez vous reconnecter en ligne pour synchroniser vos données",
    }),
    getDatabaseError: (details?: string) => ({
      title: "Erreur de base de données",
      message: "Une erreur est survenue lors de la création de l'athlète",
      details: details || "Erreur inconnue",
      action: "Veuillez réessayer ou contacter le support",
    }),
    exportError: "Erreur lors de l'export",
    importError: "Erreur lors de l'import",
    editError: "Erreur lors de la modification de l'athlète",
    wifiInfoError:
      "Impossible de récupérer les informations du réseau Wi-Fi. Veuillez réessayer.",
    invalidDateFormat: (value: string, row?: number) =>
      `Format de date invalide : "${value}" ${row ? `(ligne: ${row})` : ""}`,
    // Messages d'erreur spécifiques pour les problèmes de licence et de comptage
    licenseNotFound:
      "Aucune licence valide trouvée. Veuillez vérifier votre licence.",
    quotaCheckFailed:
      "Impossible de vérifier le quota d'athlètes. Veuillez réessayer ou vous reconnecter en ligne.",
    dataCorrupted:
      "Données corrompues détectées. Veuillez vous reconnecter en ligne pour synchroniser vos données.",
    serverUnavailable:
      "Impossible de contacter le serveur. Veuillez vérifier votre connexion internet.",
    validationFailed:
      "Validation critique échouée. Veuillez vous reconnecter en ligne.",
    requiredField(name: string) {
      return `Le champ "${name}" est requis`;
    },
    importAthleteLimitExceeded: (
      athletesToImportCount: number,
      nonFinishedCount: number,
      maxAthletes: number,
    ) =>
      `Import impossible : l'ajout de ${athletesToImportCount} athlètes dépasserait la limite de votre licence (${nonFinishedCount} non terminés + ${athletesToImportCount} à importer > ${maxAthletes} autorisés)`,
    /** Message cohérent avec canAddResult (cumulatif + non terminés + à importer). */
    importAthleteLimitExceededFull: (
      cumulativeCount: number,
      nonFinishedCount: number,
      toImportCount: number,
      maxAthletes: number,
    ) => {
      const total = cumulativeCount + nonFinishedCount + toImportCount;
      return `Import impossible : limite d'athlètes atteinte (${total}/${maxAthletes}) - ${cumulativeCount} terminés + ${nonFinishedCount} non terminés + ${toImportCount} à importer.`;
    },
  },
  discipline: "Discipline",
  barreReussie: "Barre réussie",
  automaticRefereeing: "Arbitrage auto",
  barreRatee: "Barre ratée",
  resetBarre: "Réinitialiser",
  ordreBarre: "Ordre barre",
  triCate: "Trier par catégorie",
  undo: "Annuler",
  redo: "Rétablir",
  name: "Nom",
  code: "Code",
  sex: "Sexe",
  male: "Masculin",
  female: "Féminin",
  add: "Ajouter",
  afficher: "Afficher",
  stopper: "Stopper",
  edit: "Modifier",
  print: "Imprimer",
  save: "Sauvegarder",
  select: "Sélectionner",
  validate: "Valider",
  chargement: "Chargement",
  loading: "Chargement...",
  refuse: "Refuser",
  invalidate: "Invalider",
  create: "Créer",
  delete: "Supprimer",
  import: "Importer",
  addSuccess: "Element ajouté avec succès",
  updateSuccess: "Element mis à jour avec succès",
  cancel: "Annuler",
  /** Generic DataGrid / toolbar column header for row actions */
  actionsColumn: "Actions",
  close: "Fermer",
  deleteConfirm: "Voulez-vous vraiment supprimer cet élément ?",
  deleteAthleteConfirm: "Voulez-vous vraiment supprimer cet athlète ?",
  deleteError: "Erreur lors de la suppression.",
  deleteSuccess: "Element supprimé avec succès",
  deleteErrorAlert: "Erreur lors de la suppression de l'organisation.",
  meetManager: "Meet Manager",
  meets: "Compétitions",
  date: "Date",
  city: "Ville",
  ligue: "Organisation",
  squat: "Flexion de Jambes",
  sq: "Sq",
  bench: "Développé couché",
  dc: "D.C.",
  deadlift: "Soulevé de terre",
  sdt: "S.d.T.",
  best: "Max",
  annonce: "Annoncé",
  athlete: "Athlète",
  searchHere: "Recherchez ici...",
  noMeetFound: "Aucune compétition ne correspond à votre recherche",
  meetPage: {
    name: "Nom",
    status: "Statut",
    athletes: "Athlètes",
    finished: "Terminé",
    ongoing: "En cours",
    upcoming: "À venir",
  },
  widget: {
    browserSourceHelp:
      "Copiez le lien dans une source navigateur de votre logiciel de diffusion. Les paramètres d’affichage dépendent du widget et des droits de la licence.",
    announcedTotal: "Total ANNONCÉ",
    achievedTotal: "Total RÉALISÉ",
    announcedRank: "Place ANNONCÉE",
    squatPr: "Squat",
    benchPr: "Bench",
    deadliftPr: "Deadlift",
    totalPr: "Total",
    bestSquat: "Meilleur Squat",
    bestBench: "Meilleur Bench",
    bestDeadlift: "Meilleur Deadlift",
    bestTotal: "Meilleur Total",
    kg: "kg",
    personalBest: "Meilleures performances",
    total: "Total",
    squat: "Squat",
    bench: "Bench",
    deadlift: "Deadlift",
    settings: "Paramètres des widgets",
    title: "Widgets",
    widgetAvailable: "Widgets Disponibles",
    subtitle:
      "Sélectionnez un widget pour le visualiser et obtenir son URL d'intégration.",
    currentAthleteWidgetName: "Widget Athlète Actuel",
    currentAthleteWidgetDescription:
      "Ce widget affiche les informations de l'athlète actuellement en compétition. Les données sont mises à jour automatiquement.",
    categoryRankingWidgetName: "Widget Catégorie Actuelle",
    categoryRankingWidgetDescription:
      "Ce widget affiche le classement des athlètes de la même catégorie que l'athlète actuel. Les données sont mises à jour automatiquement.",
    currentGroupWidgetName: "Widget Groupe Actuel",
    currentGroupWidgetDescription:
      "Ce widget affiche le classement du groupe en cours de la compétition. Les données sont mises à jour automatiquement.",
    lightsWidget: "Widget Lumières d'Arbitrage",
    lightsWidgetDescription:
      "Ce widget affiche les lumières d'abitrage. Les données sont mises à jour automatiquement.",
    timerWidget: "Widget Chronomètre",
    timerWidgetDescription:
      "Ce widget affiche le chronomètre de la compétition. Les données sont mises à jour automatiquement.",
    viewWidget: "Voir le widget",
    openStreamMode: "Ouvrir en mode stream",
    openInNewPage: "Ouvrir dans une nouvelle page",
    copyUrl: "Copier l'URL",
    widgetNotFound: "Widget non trouvé",
    backToWidgets: "Retour aux widgets",
    integrationUrl: "URL d'intégration :",
    runtimeLayoutsTitle: "Affichages personnalisés",
    runtimeSectionTitle: "Affichages",
    runtimeWidgetsButton: "Widgets",
    runtimeDisplaysButton: "Écrans",
    runtimeDisplaysTitle: "Écrans",
    runtimeDisplaysSubtitle:
      "Ouvrez chaque écran dans une nouvelle page pour obtenir un rendu plein écran sans interface autour.",
    layoutDisplaysTitle: "Affichages",
    noLayoutDisplaysConfigured:
      "Aucun affichage n'est configuré pour le thème courant.",
    displayTargetNotFound: "Cet affichage n'existe pas.",
    displayLayoutNotConfigured:
      "Aucun affichage n'est configuré pour cet écran.",
    runtimeThemeLabel: (themeName: string) => `Thème courant : ${themeName}`,
    missingMeetId: "Veuillez spécifier un ID de compétition dans l'URL",
    noActiveMeet:
      "Aucune compétition active. Ouvrez une compétition dans Meet Manager pour afficher les liens.",
    youNeedToActivateDirect:
      "Vous devez activer le direct avant d'utiliser widgets.",
    linkCopied: "Lien copié !",
    helpTitle: "Comment utiliser les widgets",
    helpDescription:
      "Cette interface vous permet de configurer et gérer les widgets pour votre compétition.",
    helpStep1:
      "Connectez-vous au même réseau Wi-Fi que l'appareil qui souhaite utiliser les widgets",
    helpStep2:
      "Sélectionnez l'URL de l'application dans la liste des adresses disponibles",
    helpStep3: 'Cliquez sur "Démarrer" pour lancer le serveur des widgets',
    helpStep4:
      "Copiez les liens des widgets que vous souhaitez utiliser, et importez les dans votre application de rediffusion.",
    helpNote:
      "Note : Plusieurs adresses peuvent être disponibles pour le même réseau. Si la connexion ne fonctionne pas avec la première adresse, essayez les autres une par une jusqu'à trouver celle qui permet aux arbitres de se connecter.",
    widgetsNeedActivation:
      "Les widgets sont disponible uniquement sur demande. Veuillez nous contacter si vous souhaitez les utiliser.",
    durationsTitle: "Durées",
    durationsCurrentAthleteTitle: "Durées - Widget Athlète Actuel",
    durationsCurrentCategoryTitle: "Durées - Widget Classement Catégorie",
    durationExit: "Sortie (secondes)",
    durationShowPR: "Afficher PR (secondes)",
    durationPRDelay: "Délai PR (secondes)",
    durationHidden: "Masqué (secondes)",
    durationShow: "Afficher (secondes)",
    localWidgets: "Affichages locaux",
    standardWidgetsTab: "Widgets standards",
    customWidgetsTab: "Widgets personnalisés",
    customWidgetAdd: "Ajouter un widget",
    customWidgetName: "Nom du widget",
    customWidgetLayout: "Affichage",
    customWidgetOpen: "Ouvrir le widget",
    customWidgetCopy: "Copier le lien",
    customWidgetDelete: "Supprimer le widget",
    customWidgetEmpty: "Aucun widget personnalisé configuré",
    customWidgetNameRequired: "Le nom du widget est obligatoire",
    customWidgetLayoutRequired: "Veuillez choisir un affichage",
    customWidgetCreateError: "Impossible d'ajouter ce widget personnalisé",
    customWidgetQuota: (count: number, max: number) =>
      `${count}/${max} widgets personnalisés configurés`,
    layoutButton: "Paramètres",
    layoutModalTitle: "Affichage du widget",
    layoutModalHelp:
      "Sélectionnez un de vos affichages enregistrés sur le compte, puis importez-le pour remplacer le widget.",
    layoutJsonPlaceholder: "Collez ici l'affichage du widget...",
    layoutJsonError: "L'affichage du widget est invalide",
    layoutSelectMine: "Mes affichages",
    layoutImportSelected: "Importer",
    layoutLoadingList: "Chargement de la liste des affichages…",
    layoutLoadingImport: "Import de l'affichage…",
    layoutAssigned: "Affichage assigné",
    layoutClearAssignment: "Retirer l'affichage",
    layoutLoadListError: "Impossible de charger la liste des affichages",
    layoutLoadError: "Impossible de charger cet affichage",
  },
  meetGrid: {
    firstname: "Prénom",
    lastname: "Nom",
    dateOfBirth: "Date de naissance",
    club: "Club",
    place: "Classement",
    sex: "Sexe",
    bodyweight: "PDC",
    squat: "Flexion de jambes",
    bench: "Développé couché",
    deadlift: "Soulevé de terre",
    weightClass: "Catégorie de poid",
    announcedTotal: "Total ANNONCÉ",
    achievedTotal: "Total RÉALISÉ",
    dots: (formula?: string) =>
      String(formula ?? "").toUpperCase() === "DOTS" ? "DOTS" : "Points GL",
    ageClass: "Catégorie d'âge",
    ageClassPlus1: "Catégorie d'âge N+1",
  },
  attempt: "Essai",
  rank: "Place",
  guest: "Hors match",
  customDisciplineExports: {
    section: "Exports de fichiers",
    intro: "Profils indépendants pour CSV, Excel et PDF.",
    addProfile: "Nouveau profil",
    copyProfile: "Dupliquer",
    deleteProfile: "Supprimer le profil",
    profile: "Profil",
    name: "Nom du profil",
    enabled: "Disponible dans Meet Manager",
    general: "Formats et fichier",
    columns: "Colonnes et valeurs",
    rows: "Athlètes et lignes",
    template: "Modèle Excel",
    preview: "Aperçu",
    fileName: "Nom du fichier · nom du groupe si vide",
    sheetName: "Feuille Excel",
    addColumn: "Ajouter une colonne",
    label: "En-tête",
    field: "Champ source",
    type: "Type de valeur",
    excelColumn: "Colonne Excel",
    width: "Largeur Excel · caractères",
    numberFormat: "Format numérique Excel",
    valueBehavior: "Valeur et style · Behavior",
    copyField: "Reprendre le calcul du champ",
    signedAttempt: "Essai raté → valeur négative",
    statusField: "Champ du statut",
    failureValue: "Valeur du statut d’échec",
    applySigned: "Créer la règle",
    remove: "Supprimer",
    up: "Monter",
    down: "Descendre",
    visible: "Exporter cette colonne",
    style: "Style",
    cellStyle: "Cellules de la colonne",
    columnHeaderStyle: "En-tête de la colonne",
    defaultStyle: "Cellules · style par défaut",
    headerStyle: "En-têtes · style par défaut",
    font: "Police",
    fontSize: "Taille · points",
    bold: "Gras",
    italic: "Italique",
    underline: "Souligné",
    fill: "Fond",
    textColor: "Texte",
    horizontal: "Alignement horizontal",
    vertical: "Alignement vertical",
    wrap: "Retour à la ligne",
    inherit: "Style hérité",
    border: "Bordures",
    borderColor: "Couleur des bordures",
    borderStyle: "Trait",
    top: "Haut",
    right: "Droite",
    bottom: "Bas",
    left: "Gauche",
    center: "Centre",
    middle: "Milieu",
    thin: "Fin",
    medium: "Moyen",
    thick: "Épais",
    dashed: "Tirets",
    dotted: "Pointillés",
    double: "Double",
    filter: "Inclure les athlètes · Behavior booléen",
    order: "Ordre avancé · Behavior",
    sectionRule: "Clé de section · Behavior",
    addSort: "Ajouter un critère de tri",
    ascending: "Croissant",
    descending: "Décroissant",
    startRow: "Première ligne de données Excel",
    headerRow: "Ligne des en-têtes Excel",
    keepTemplateHeader: "Vide : conserver les en-têtes du modèle",
    keepTemplateStyle: "Vide : conserver le style des cellules du modèle",
    rowStep: "Pas entre deux athlètes · lignes Excel",
    gap: "Lignes vides entre deux sections",
    endRow: "Dernière ligne autorisée",
    rowHeight: "Hauteur des lignes · points",
    headerHeight: "Hauteur des en-têtes · points",
    copyStyleFromRow: "Copier le style de la ligne Excel · facultatif",
    templateDataEndRow: "Dernière ligne d’athlète prévue dans le modèle",
    templateDataEndRowHint:
      "Vide : modèle fixe. Sinon, les lignes supplémentaires décalent le bas du modèle et ses cellules fixes.",
    clearRange:
      "Vider les cellules des colonnes mappées dans la plage délimitée",
    uploadTemplate: "Importer un modèle .xlsx",
    removeTemplate: "Retirer le modèle",
    templateHint:
      "Le modèle est enregistré avec la discipline et disponible hors connexion. Seules les cellules mappées sont remplies.",
    templateLimit: "Modèle .xlsx valide, de 5 Mo maximum.",
    templateError: "Impossible de lire ce modèle Excel.",
    bindings: "Cellules fixes du modèle",
    addBinding: "Ajouter une cellule fixe",
    cell: "Cellule · ex. B4",
    sheet: "Feuille",
    delimiter: "Séparateur CSV",
    bom: "Encodage UTF-8 avec BOM",
    includeHeader: "Inclure les en-têtes CSV",
    protectFormulas: "Neutraliser les formules dans les valeurs texte CSV",
    landscape: "PDF paysage",
    paperSize: "Papier PDF",
    margin: "Marges PDF · mm",
    title: "Titre PDF",
    sampleData: "Données de test",
    athlete: "Athlète",
    addAthlete: "Ajouter un athlète de test",
    value: "Valeur",
    group: "Groupe",
    previewRows: "Lignes de destination",
    downloadPreview: "Télécharger l’aperçu Excel",
    noProfiles: "Aucun profil d’export configuré.",
    exportFile: "Exporter",
    scope: "Périmètre",
    thisGroup: "Ce groupe",
    allGroups: "Tous les groupes de cette discipline",
    format: "Format",
    close: "Fermer",
    loading: "Préparation de l’aperçu…",
    totalRows: "Athlètes exportés",
    rowNumber: "Ligne Excel",
    capacityError:
      "Les athlètes dépassent la dernière ligne autorisée. Augmentez la plage dans l’administration.",
    invalid:
      "Le profil contient un réglage invalide. Vérifiez les colonnes, les lignes et le modèle.",
    previewError: "Impossible de préparer l’export.",
    templateMode: "Excel à partir du modèle",
    tableMode: "Excel sans modèle",
    noRows: "Aucun athlète ne correspond au filtre de ce profil.",
    unlimited: "Sans limite",
    confirmDelete: "Supprimer ce profil d’export ?",
    text: "Texte",
    number: "Nombre",
    boolean: "Booléen",
    date: "Date",
    auto: "Automatique",
    reset: "Réinitialiser",
    previewNote:
      "Aperçu des premières lignes ; toutes les lignes sont incluses dans le fichier.",
    success: "Export terminé.",
    none: "Aucun",
    true: "Oui",
    false: "Non",
  },
  customDisciplineResults: {
    emptyResults:
      "Aucun athlète ne répond actuellement aux règles du classement.",
    section: "Résultats et impressions",
    independent:
      "Colonnes et règles des classements de la compétition et de leurs impressions, indépendantes du groupe et du direct.",
    order: "Ordre du classement",
    podiumOrder: "Ordre des podiums",
    sexField: "Champ du sexe",
    ageField: "Champ de catégorie d’âge",
    weightField: "Champ de catégorie de poids",
    eligibility: "Athlètes admis au classement",
    loadError: "Impossible de charger les résultats personnalisés.",
  },
  customDisciplineWeb: {
    toolbar: {
      title: "Barre de commandes",
      viewMode: "Vue d’affichage",
      followOff: "Suivi désactivé",
      preview: "Aperçu interactif · données de démonstration",
      add: "Ajouter une commande",
      preset: "Reprendre les commandes legacy",
      gridPreset: "Reprendre le style de grille legacy",
      styles: "États des commandes · Display Editor",
      kind: "Type de commande",
      kinds: {
        TITLE: "Nom du groupe",
        SEARCH: "Recherche d’athlète",
        BUTTON: "Bouton",
        TOGGLE: "Boutons à sélection exclusive",
      },
      action: "Action",
      actions: {
        REFRESH: "Actualiser la configuration",
        RESET_VIEW: "Réinitialiser la vue",
        CLEAR_SEARCH: "Effacer la recherche",
        VIEW_MODE: "Changer de vue · catégories / direct",
        FOLLOW_CURRENT: "Activer / désactiver le suivi de l’athlète",
        INPUT: "Valeur locale utilisée par Behavior",
      },
      inputKey: "Clé de la valeur locale",
      inputHint:
        "Accessible dans Behavior : inputValues.<clé>. Modifie uniquement cette vue web.",
      defaultValue: "Valeur initiale",
      searchFields: "Champs recherchés · tous si aucun n’est sélectionné",
      optionValue: "Valeur",
      optionLabel: "Libellé",
      addOption: "Ajouter un choix",
      options: "Choix du sélecteur",
      icon: "Icône",
      automaticWidth: "Largeur automatique",
      styleHint:
        "Chaque commande possède ses états normal, survolé, sélectionné et désactivé dans le Display Editor.",
    },
    tooltip: "Infobulle · Display Editor",
    section: "Vue web du direct",
    independent: "Cette vue possède ses propres colonnes et maquettes.",
    create: "Créer une vue web indépendante",
    empty: "La vue web de ce groupe n’est pas encore configurée.",
    columns: "Colonnes publiées",
    addColumn: "Ajouter une colonne",
    newColumn: "Nouvelle colonne",
    source: "Champ source",
    computed: "Valeur calculée",
    label: "Titre",
    width: "Largeur",
    pin: "Figer",
    noPin: "Défilement normal",
    left: "À gauche",
    right: "À droite",
    visible: "Visible",
    up: "Monter",
    down: "Descendre",
    remove: "Retirer",
    cell: "Cellule · Display Editor",
    header: "En-tête · Display Editor",
    calculation: "Calcul · Behavior",
    styles: "Style de la grille · Display Editor",
    liveOrder: "Tri direct · Behavior",
    categoryOrder: "Tri classement · Behavior",
    categoryColumns: "Regrouper les catégories avec",
    defaultMode: "Mode initial",
    live: "Direct",
    category: "Catégories",
    follow: "Suivre l’athlète en cours",
    refresh: "Actualiser la vue",
    search: "Rechercher un athlète",
    loading: "Chargement de la vue web…",
    error: "Impossible de charger la vue web.",
    retry: "Réessayer",
    noAthletes: "Aucun athlète dans ce groupe.",
    noColumns: "Aucune colonne publiée.",
    copyAction: "Copier le tri d’une action",
    copy: "Copier",
    apply: "Appliquer au brouillon",
    back: "Retour à la vue web",
    headerGroup: "Groupe d’en-têtes",
    rowCount: "athlètes",
    details: "Détails de l’athlète",
  },
  admin: {
    title: "Administration",
    tabs: {
      licenseTerms: "Conditions",
      meets: "Compétitions",
      analytics: "Statistiques",
      testExport: "Test export",
    },
    ligues: "Organisations",
    meet: "Meet",
    admintable: "Admin Table",
    items: "élément(s)",
    config: {
      title: "Configuration",
      id: "ID",
      value: "Valeur",
    },
    resetGrid: "Réinitialiser l'affichage",
    resetGridConfirm:
      "Êtes-vous sûr de vouloir réinitialiser l'affichage de la grille ? Toutes les préférences de colonnes (largeur, visibilité, ordre) seront perdues.",
    resetGridSuccess: "Affichage de la grille réinitialisé avec succès",
    meets: {
      title: "Gestion des Meets",
      confirmDelete: (meetName: string) =>
        `Êtes-vous sûr de vouloir supprimer le meet "${meetName}" ?`,
      columns: {
        name: "Nom",
        city: "Ville",
        organisation: "Organisation",
        startDate: "Début",
        endDate: "Fin",
        status: "Statut",
        createdAt: "Créé le",
        togglePublic: "Public/Privé",
      },
      status: {
        public: "Public",
        private: "Privé",
      },
      actions: {
        makePublic: "Public",
        makePrivate: "Privé",
        processing: "...",
      },
      errors: {
        statusChangeError: "Erreur lors de la modification du statut",
      },
      allOrganisations: "Toutes les organisations",
      form: {
        title: {
          create: "Créer un nouveau meet",
          edit: "Modifier le meet",
        },
        fields: {
          name: "Nom du meet",
          city: "Ville",
          startDate: "Date de début",
          endDate: "Date de fin",
          isPublic: "Meet public",
        },
        validation: {
          nameRequired: "Le nom est requis",
          cityRequired: "La ville est requise",
          startDateRequired: "La date de début est requise",
          endDateRequired: "La date de fin est requise",
          endDateAfterStart: "La date de fin doit être après la date de début",
        },
        actions: {
          create: "Créer",
          edit: "Modifier",
          cancel: "Annuler",
          saving: "Sauvegarde...",
        },
      },
    },
    organisations: {
      title: "Organisations",
      empty: "Aucune organisation",
      create: "Créer",
      edit: "Modifier",
      delete: "Supprimer",
      name: "Nom",
      parent: "Organisation parente",
      noParent: "Aucune (racine)",
      confirmDelete: "Êtes-vous sûr de vouloir supprimer cette organisation ?",
      confirmDeleteWithChildren:
        "Cette organisation a des enfants ou des utilisateurs/arbitres liés. La supprimer peut affecter ces éléments. Continuer ?",
      createTitle: "Créer une organisation",
      editTitle: "Configurer l'organisation",
      identityTitle: "Identité",
      cancel: "Annuler",
      save: "Enregistrer",
      loading: "Chargement...",
      error: "Erreur lors du chargement des organisations",
      code: "Code",
      countryCode: "Code pays",
      recordLabel: "Libellé des records",
      recordColor: "Couleur des records",
      recordBadge: "Logo ou drapeau des records",
      federationSettings: "Configuration fédérale",
      sourcesTitle: "Sources des données",
      sourceDiscipline: "Disciplines",
      sourceAgeCategory: "Catégories d'âge",
      sourceWeightCategory: "Catégories de poids",
      sourceLevel: "Minimas / niveaux",
      sourceRecord: "Records",
      sourceReferee: "Arbitres",
      exportsTitle: "Formats d'export disponibles",
      exportOpenPowerlifting: "OpenPowerlifting",
      exportFfForceSheet: "Feuille de match FFForce",
      exportFfForceMacro: "Macros FFForce",
      importsTitle: "Formats d'import disponibles",
      importFfForceSheet: "Feuille de match FFForce",
      importGenericSheet: "Import Excel",
      openPowerliftingFederation: "Code fédération OpenPowerlifting",
      openPowerliftingCountry: "Pays OpenPowerlifting",
      powerscoutFederationName: "Nom fédération Powerscout",
      powerscoutFederationNameHint:
        "Nom exact (ou partiel) dans Powerscout pour le classement national (ex. FFForce, KDKS). Vide = FFForce.",
      defaultLevelName: "Niveau par défaut",
      defaultLevelNameHint:
        "Libellé affiché quand aucun minima n'est atteint (ex. dépt.). Vide = dépt.",
      uploadBadge: "Importer un logo/drapeau",
      deleteBadge: "Supprimer le logo",
      noBadge: "Aucun logo importé",
      badgeDeleted: "Logo supprimé",
      deleteBadgeError: "Impossible de supprimer le logo/drapeau",
      badgeFileHint: "PNG, JPEG ou WebP - 2 Mo maximum",
      recordsTitle: "Import / export des records",
      downloadEmptyTemplate: "Télécharger le modèle vide",
      downloadCurrentRecords: "Exporter les records actuels",
      importRecords: "Importer les records",
      importedRecords: (count: number) => `${count} record(s) importé(s)`,
      levelsTitle: "Import / export des niveaux (minimas)",
      downloadCurrentLevels: "Exporter les niveaux actuels",
      importLevels: "Importer les niveaux",
      importedLevels: (count: number) => `${count} niveau(x) importé(s)`,
      levelsWorkbookError: "Impossible de traiter le fichier de niveaux",
      configurationSaved: "Configuration enregistrée",
      uploadError: "Impossible d'importer le logo/drapeau",
      workbookError: "Impossible de traiter le fichier de records",
      taxonomyTitle: "Référentiels propres à l'organisation",
      taxonomyHint:
        "Ces éléments pourront être choisis comme source par cette organisation ou ses sous-organisations.",
      manageTaxonomy: "Gérer les catégories et disciplines",
      addDiscipline: "Ajouter une discipline",
      addAgeCategory: "Ajouter une catégorie d'âge",
      addWeightCategory: "Ajouter une catégorie de poids",
      disciplineName: "Nom de la discipline",
      disciplineCode: "Code de la discipline",
      competitionFormat: "Format de compétition",
      fullPower: "Force athlétique",
      singleLift: "Développé couché",
      categoryName: "Nom de la catégorie",
      categoryCode: "Code de la catégorie",
      recordName: "Nom dans les records",
      ageMin: "Âge minimum",
      ageMax: "Âge maximum",
      weightMin: "Poids minimum",
      weightMax: "Poids maximum",
      sex: "Sexe",
      juniorWeight: "Catégorie de poids junior",
      openAge: "Catégorie Open",
      displayOrder: "Ordre d'affichage",
      noTaxonomyRows: "Aucun élément configuré",
      taxonomySaved: "Référentiel enregistré",
      taxonomyError: "Impossible de modifier le référentiel",
      taxonomyDeleteConfirm: (name: string) =>
        `Supprimer définitivement « ${name} » ?`,
    },
    customDisciplines: {
      cellSection: "Cellule",
      headerSection: "En-tête",
      headerGroupSection: "En-tête du regroupement",
      cellHeight: "Hauteur de cellule",
      headerHeight: "Hauteur de l’en-tête",
      headerGroupHeight: "Hauteur du regroupement",
      canvasBackground: "Fond du canevas",
      gridHeightHint:
        "La grille retient la plus grande hauteur configurée pour aligner les colonnes.",
      workspace: {
        previewSample: "Aperçu · données d’exemple",
        fitLayout: "Toute la maquette",
        zoomIn: "Zoom avant",
        zoomOut: "Zoom arrière",
        fitGraph: "Tout le graphe",
        keepEditing: "Continuer à modifier",
        discardDraft: "Abandonner le brouillon",
        customizeCell: "Personnaliser la cellule",
        sharedGroupActions: "Dans la colonne des actions du groupe",
        variants: {
          contained: "Plein",
          outlined: "Contour",
          text: "Discret",
        },
        sizes: {
          small: "Compact",
          medium: "Standard",
          large: "Grand",
        },
        colors: {
          inherit: "Par défaut",
          primary: "Principal",
          secondary: "Secondaire",
          success: "Succès",
          error: "Erreur",
          info: "Information",
          warning: "Attention",
        },
        iconTypes: {
          MUI: "Bibliothèque d’icônes",
          SVG: "Image importée",
        },
        window: "fenêtre",
        catalog: "Catalogue des disciplines",
        languages: "Traductions",
        configure: "Configurer le groupe",
        identity: "Identité de la discipline",
        newDiscipline: "Créer une discipline",
        overview: "Vue d’ensemble",
        groupFields: "Champs du groupe",
        athleteFields: "Champs des athlètes",
        pageActions: "Boutons & raccourcis",
        gridActions: "Icônes dans les listes",
        windows: "Fenêtres & documents",
        gridsForms: "Grilles & formulaires",
        screens: "Écrans de compétition",
        transfer: "Modèles & transferts",
        structure: "Structure",
        interactions: "Interactions",
        appearance: "Apparence",
        tools: "Outils",
        back: "Disciplines",
        backToSection: "Retour à la fiche",
        saved: "Enregistré",
        unsaved: "Modifications non enregistrées",
        apply: "Appliquer au brouillon",
        discard: "Abandonner les modifications non enregistrées ?",
        search: "Rechercher par nom ou clé",
        definitions: "Définitions",
        untitled: "Sans titre",
        newDefinition: "Nouvel élément",
        noResults: "Aucun résultat",
        noDefinitions: "Aucun élément. Utilisez Ajouter pour commencer.",
        properties: "Propriétés",
        logic: "Logique · Behavior",
        design: "Apparence · Display Editor",
        configured: "Personnalisé",
        default: "Standard",
        openEditor: "Ouvrir l’éditeur",
        groupGrid: "Liste des groupes",
        athleteGrid: "Grille des athlètes",
        groupForm: "Formulaire du groupe",
        athleteForm: "Formulaire de l’athlète",
        forms: "Formulaires de saisie",
        grids: "Listes & tableaux",
        importTitle: "Importer une configuration",
        exportTitle: "Exporter une configuration",
        templates: "Modèles de départ",
        exportLabels: "Exporter les clés de traduction",
        deleteType: "Supprimer le type de groupe",
        active: "Active",
        inactive: "Inactive",
        settings: "Identité",
        fields: "champs",
        actions: "actions",
        modals: "fenêtres",
        openBehavior: "Ouvrir Behavior",
        editCell: "Cellule & en-têtes",
        addGroupField: "Ajouter un champ de groupe",
        addAthleteField: "Ajouter un champ d’athlète",
        addPageAction: "Ajouter un bouton ou raccourci",
        addGridAction: "Ajouter une icône",
        addModal: "Ajouter une fenêtre",
        copyHint: "JSON · champs, actions, Behavior et maquettes",
        templateHint: "À utiliser au démarrage d’un nouveau type de groupe",
        newGroupType: "Créer le type de groupe",
        saving: "Enregistrement…",
        saveError:
          "Impossible d’enregistrer. Vos modifications sont conservées.",
        allDisciplines: "Toutes les disciplines",
        allLanguages: "Toutes les langues",
        translationsSearch: "Rechercher une traduction",
        emptyCatalog: "Créez votre première discipline",
        changesPending: "Brouillon",
        editorDiscard: "Quitter cet éditeur sans appliquer les modifications ?",
      },
      importConfiguration: "Importer la configuration",
      exportConfiguration: "Exporter la configuration",
      invalidConfiguration: "Configuration de groupe invalide.",
      configurationImported:
        "Configuration chargée. Enregistrez pour l’appliquer.",

      configurationHelp:
        "Behavior définit les calculs et les actions. Le Display Editor définit les cellules, les modales, les documents imprimés et les écrans.",
      startFromTemplate: "Démarrer d’un modèle :",
      templateFullPower: "Force athlétique (3 mouvements)",
      templateBench: "Développé couché",
      competitionDisplays: "Écrans de compétition",
      competitionDisplaysHelp:
        "Maquettes utilisées automatiquement pour cette discipline. Une affectation locale dans les réglages des écrans reste prioritaire.",
      gridPresentationHelp:
        "Pour les grilles, modifiez le style et la hauteur des exemples nommés en conservant leurs identifiants. Chaque champ possède son éditeur de cellule et d’en-tête. Dans une liste mêlant plusieurs types de groupes, chaque style s’applique uniquement aux lignes de son type ; les en-têtes communs gardent le style standard.",
      athleteScreen: "Athlète",
      loaderScreen: "Chargeurs",
      rankingScreen: "Classement",
      publicScreen: "Public",

      title: "Disciplines personnalisées",
      groupTypesTitle: "Types de groupe",
      add: "Ajouter",
      name: "Nom",
      code: "Code",
      description: "Description",
      groupType: "Type de groupe",
      active: "Active",
      actions: "Actions",
      discipline: "Discipline",
      fields: "Champs",
      groupActions: "Actions groupe",
      edit: "Modifier",
      delete: "Supprimer",
      loading: "Chargement...",
      emptyDisciplines: "Aucune discipline",
      emptyGroupTypes: "Aucun type de groupe",
      emptyFields: "Aucun champ",
      emptyActions: "Aucune action",
      emptyOptions: "Aucune option",
      emptyTranslations: "Aucune traduction",
      emptyValue: "-",
      yes: "Oui",
      no: "Non",
      cancel: "Annuler",
      save: "Enregistrer",
      confirmDeleteDiscipline: (name: string) =>
        `Supprimer la discipline ${name} ?`,
      confirmDeleteGroupType: (name: string) =>
        `Supprimer le type de groupe ${name} ?`,
      confirmDeleteTranslation: (key: string) =>
        `Supprimer la traduction ${key} ?`,
      disciplineDeleted: "Discipline supprimée",
      disciplineUpdated: "Discipline modifiée",
      disciplineCreated: "Discipline créée",
      groupTypeDeleted: "Type de groupe supprimé",
      groupTypeUpdated: "Type de groupe modifié",
      groupTypeCreated: "Type de groupe créé",
      translationDeleted: "Traduction supprimée",
      translationUpdated: "Traduction modifiée",
      translationCreated: "Traduction créée",
      translationsImported: "Traductions importées",
      editDiscipline: "Modifier la discipline",
      newDiscipline: "Nouvelle discipline",
      editGroupType: "Modifier le type de groupe",
      newGroupType: "Nouveau type de groupe",
      editTranslation: "Modifier la traduction",
      newTranslation: "Nouvelle traduction",
      groupFields: "Champs groupe",
      athleteFields: "Champs athlète",
      groupPageActions: "Actions page groupe",
      modals: "Modales",
      translationsTitle: "Traductions",
      key: "Clé",
      label: "Libellé",
      value: "Valeur",
      locale: "Langue",
      type: "Type",
      required: "Obligatoire",
      visible: "Visible (grille)",
      visibleInModal: "Visible (modales)",
      readOnly: "Lecture seule",
      sortable: "Triable",
      order: "Ordre",
      unit: "Unité",
      referenceSource: "Référence",
      referenceIdPath: "Clé ID",
      referenceLabelPath: "Clé libellé",
      referenceFilterBehavior: "Filtre référence",
      options: "Options",
      behavior: "Comportement",
      disabled: "Désactivé",
      startIcon: "Icône",
      variant: "Variant",
      size: "Taille",
      color: "Couleur",
      width: "Largeur",
      height: "Hauteur",
      contentMaxHeight: "Hauteur max contenu",
      resizable: "Redimensionnable",
      cellLayout: "Layout cellule",
      configure: "Configurer",
      enabled: "Activé",
      disable: "Désactiver",
      preview: "Aperçu",
      noneIcon: "Aucune",
      iconGridOrder: "Ordre colonne",
      iconCellOrder: "Ordre cellule",
      iconColumnName: "Colonne",
      iconTooltip: "Infobulle",
      iconGridTarget: "Grille",
      iconGridTargets: {
        ATHLETES: "Athlètes",
        GROUPS: "Groupes",
      },
      iconGroupAction: "Action de groupe",
      iconType: "Type icône",
      iconAssets: "Assets icône",
      groupGridIconActions: "Icônes grille groupes",
      athleteGridIconActions: "Icônes grille athlètes",
      gridIconActions: "Icônes de grille",
      iconLayout: "Layout icône",
      iconLayoutTitle: "Layout bouton icône",
      selectFile: "Choisir fichier",
      behaviorVariables: {
        athlete: "Athlète",
        athletes: "Athlètes",
        currentValue: "Valeur courante",
        selectedRowId: "ID ligne sélectionnée",
        selectedColumnKey: "Clé colonne sélectionnée",
        currentMeet: "Compétition courante",
        group: "Groupe courant",
        currentGroup: "Groupe actuel",
        groups: "Groupes",
        records: "Records",
        levels: "Niveaux",
        ageCategories: "Catégories d'âge",
        disciplineAgeCategories: "Catégories d’âge de la discipline",
        disciplineWeightCategories: "Catégories de poids de la discipline",
        weightCategories: "Catégories de poids",
        disciplines: "Disciplines",
        leagues: "Ligues",
        organisations: "Organisations · catalogue",
        organisation: "Organisation",
        modalValues: "Valeurs modale",
        refereeLights: "Résultat des arbitres (événement)",
        inputValues: "Valeurs inputs",
        referenceItem: "Élément de référence",
      },
      placement: "Emplacement",
      optionsPlaceholder: "libellé:valeur",
      addOption: "Ajouter une option",
      editOptions: (count: number) => `${count} option${count > 1 ? "s" : ""}`,
      optionsTitle: (label: string) => `Options - ${label}`,
      importJson: "Importer JSON",
      exportLabels: "Exporter les libellés",
      untitledField: "Champ",
      untitledAction: "Action",
      emptyModals: "Aucune modale",
      behaviorTitle: (label: string) => `Comportement - ${label}`,
      referenceFilterTitle: (label: string) => `Filtre référence - ${label}`,
      cellLayoutTitle: (label: string) => `Layout cellule - ${label}`,
      modalLayoutTitle: (label: string, section: string) =>
        `Layout modale - ${label} - ${section}`,
      modalTitleLayout: "Titre",
      modalContentLayout: "Contenu",
      modalActionsLayout: "Actions",
      fieldTypes: {
        TEXT: "Texte",
        NUMBER: "Nombre",
        SELECT: "Liste",
        LIFT: "Mouvement",
        BOOLEAN: "Booléen",
        DATE: "Date",
        FOREIGN_KEY: "Référence",
      },
      referenceSources: {
        groups: "Groupes",
        ageCategories: "Catégories d'âge",
        disciplineAgeCategories: "Catégories d’âge de la discipline",
        disciplineWeightCategories: "Catégories de poids de la discipline",
        weightCategories: "Catégories de poids",
        disciplines: "Disciplines",
        levels: "Niveaux",
        records: "Records",
        leagues: "Ligues",
      },
      placements: {
        TOOLBAR_START: "Barre d’outils - début",
        TOOLBAR: "Barre d'outils",
        FOOTER: "Pied de page",
        GRID_ICON: "Icône de grille",
        ROW_ACTIONS: "Actions de ligne",
      },
      getError: (code?: string | null) => {
        switch (code) {
          case "CUSTOM_DISCIPLINE_NOT_FOUND":
            return "Discipline introuvable.";
          case "CUSTOM_DISCIPLINE_HAS_GROUP_TYPE":
            return "Impossible de supprimer une discipline encore liée à un type de groupe.";
          case "CUSTOM_DISCIPLINE_GROUP_TYPE_NOT_FOUND":
            return "Type de groupe introuvable.";
          case "CUSTOM_DISCIPLINE_FIELD_KEY_DUPLICATE":
            return "Deux champs d'une même section ne peuvent pas partager la même clé.";
          case "CUSTOM_DISCIPLINE_FIELD_KEY_REQUIRED":
            return "La clé du champ est obligatoire.";
          case "CUSTOM_DISCIPLINE_FIELD_LABEL_REQUIRED":
            return "Le libellé du champ est obligatoire.";
          case "CUSTOM_DISCIPLINE_SELECT_FIELD_REQUIRES_OPTIONS":
            return "Un champ de type liste doit avoir au moins une option.";
          case "CUSTOM_DISCIPLINE_REFERENCE_FIELD_REQUIRES_SOURCE":
            return "Un champ de type référence doit avoir une source.";
          case "CUSTOM_DISCIPLINE_REFERENCE_SOURCE_INVALID":
            return "La source de référence du champ est invalide.";
          case "CUSTOM_DISCIPLINE_FIELD_OPTION_LABEL_REQUIRED":
            return "Le libellé d'une option est obligatoire.";
          case "CUSTOM_DISCIPLINE_FIELD_OPTION_VALUE_REQUIRED":
            return "La valeur d'une option est obligatoire.";
          case "CUSTOM_DISCIPLINE_FIELD_OPTION_VALUE_DUPLICATE":
            return "Deux options ne peuvent pas partager la même valeur.";
          case "CUSTOM_DISCIPLINE_ACTION_KEY_DUPLICATE":
            return "Deux actions ne peuvent pas partager la même clé.";
          case "CUSTOM_DISCIPLINE_ACTION_KEY_REQUIRED":
            return "La clé de l'action est obligatoire.";
          case "CUSTOM_DISCIPLINE_ACTION_LABEL_REQUIRED":
            return "Le libellé de l'action est obligatoire.";
          case "CUSTOM_DISCIPLINE_UNIQUE_CONSTRAINT":
            return "Ce code ou cette association existe déjà.";
          case "CUSTOM_DISCIPLINE_INVALID_RELATION":
            return "La relation vers la discipline est invalide.";
          case "CUSTOM_DISCIPLINE_CODE_REQUIRED":
            return "Le code est obligatoire.";
          case "CUSTOM_DISCIPLINE_KEY_REQUIRED":
            return "La clé est obligatoire.";
          case "CUSTOM_DISCIPLINE_ATHLETE_COUNT_INVALID":
            return dico().athleteCount.invalid;
          case "CUSTOM_DISCIPLINE_EXPORT_INVALID":
            return "Le profil contient un réglage invalide. Vérifiez les colonnes, les lignes et le modèle.";
          case "INVALID_ENTRY_PROFILE":
            return "La configuration de la saisie athlète est invalide.";
          case "CUSTOM_DISCIPLINE_WEB_VIEW_INVALID":
            return "La configuration de la vue web est invalide.";
          case "CUSTOM_DISCIPLINE_INVALID_BEHAVIOR":
            return "Le graphe de comportement est invalide.";
          case "CUSTOM_DISCIPLINE_LABEL_TRANSLATION_NOT_FOUND":
            return "Traduction introuvable.";
          case "CUSTOM_DISCIPLINE_TRANSLATION_LOCALE_REQUIRED":
            return "La langue de la traduction est obligatoire.";
          case "CUSTOM_DISCIPLINE_TRANSLATION_KEY_REQUIRED":
            return "La clé de traduction est obligatoire.";
          case "CUSTOM_DISCIPLINE_TRANSLATION_LABEL_REQUIRED":
            return "Le libellé traduit est obligatoire.";
          case "CUSTOM_DISCIPLINE_TRANSLATION_IMPORT_INVALID":
            return "Le fichier de traduction est invalide.";
          case "CUSTOM_DISCIPLINE_TRANSLATION_IMPORT_EMPTY":
            return "Le fichier de traduction ne contient aucune entrée.";
          case "CUSTOM_DISCIPLINES_FETCH_ERROR":
            return "Impossible de charger les disciplines personnalisées.";
          case "CUSTOM_DISCIPLINE_CREATE_ERROR":
            return "Impossible de créer la discipline.";
          case "CUSTOM_DISCIPLINE_UPDATE_ERROR":
            return "Impossible de modifier la discipline.";
          case "CUSTOM_DISCIPLINE_DELETE_ERROR":
            return "Impossible de supprimer la discipline.";
          case "CUSTOM_DISCIPLINE_GROUP_TYPE_CREATE_ERROR":
            return "Impossible de créer le type de groupe.";
          case "CUSTOM_DISCIPLINE_GROUP_TYPE_UPDATE_ERROR":
            return "Impossible de modifier le type de groupe.";
          case "CUSTOM_DISCIPLINE_GROUP_TYPE_DELETE_ERROR":
            return "Impossible de supprimer le type de groupe.";
          case "CUSTOM_DISCIPLINE_TRANSLATION_CREATE_ERROR":
            return "Impossible de créer la traduction.";
          case "CUSTOM_DISCIPLINE_TRANSLATION_UPDATE_ERROR":
            return "Impossible de modifier la traduction.";
          case "CUSTOM_DISCIPLINE_TRANSLATION_DELETE_ERROR":
            return "Impossible de supprimer la traduction.";
          case "CUSTOM_DISCIPLINE_TRANSLATION_IMPORT_ERROR":
            return "Impossible d'importer les traductions.";
          default:
            return "Une erreur est survenue.";
        }
      },
    },
    ffForceExport: {
      sheetGridTitle: "Feuilles fédération",
      title: "Export FFForce",
      empty: "Aucun fichier dans le dossier fédéral",
      loading: "Chargement des fichiers…",
      error: "Impossible de charger la liste des fichiers",
      deleteError: "Impossible de supprimer le fichier",
      downloadError: "Impossible de télécharger le fichier",
      confirmDelete: (fileName: string) =>
        `Supprimer définitivement le fichier « ${fileName} » ?`,
      columns: {
        fileName: "Nom du fichier",
        fileSize: "Taille",
        modifiedAt: "Dernière modification",
        createdAt: "Date de création",
      },
      download: "Télécharger",
      delete: "Supprimer",
      actionTooltipDownloadFederationSheet:
        "Télécharger la feuille fédération (fichier tel que stocké côté serveur).",
      actionTooltipDeleteFederationSheet:
        "Supprimer ce fichier de feuille fédération du dossier serveur.",
      actionTooltipDownloadTemplateWorkbook:
        "Télécharger le classeur Excel du modèle d’export.",
      actionTooltipDownloadTemplateScript:
        "Télécharger le script PowerShell (.ps1) associé à ce modèle.",
      actionTooltipDownloadTemplateScriptDisabled:
        "Aucun script PS1 n’est associé à ce modèle pour le moment.",
      actionTooltipManagePs1:
        "Importer ou copier le script PowerShell (.ps1) pour ce modèle.",
      actionTooltipDeleteTemplate:
        "Supprimer ce modèle (classeur Excel et script s’il existe).",
      actions: "Actions",
      syncFromFfForceButton: "Récupérer les feuilles depuis FFForce",
      syncFromFfForceRunning: "Téléchargement depuis FFForce…",
      syncFromFfForceSuccess: (
        downloaded: number,
        skipped: number,
        errorCount: number,
      ) =>
        `Synchronisation terminée : ${downloaded} fichier(s) téléchargé(s), ${skipped} ignoré(s), ${errorCount} erreur(s).`,
      syncFromFfForceError:
        "Échec du téléchargement des feuilles depuis le site FFForce.",
      templateGridTitle: "Modèles d’export (Excel + script)",
      templateEmpty: "Aucun modèle importé",
      templateError: "Impossible de charger la liste des modèles",
      importTemplateButton: "Importer un modèle",
      importTemplateModalTitle: "Importer un classeur modèle",
      displayNameLabel: "Nom du modèle (unique)",
      selectWorkbook: "Fichier Excel (.xlsx, .xlsm, .xls)",
      selectPs1: "Fichier PowerShell (.ps1)",
      selectedFile: (fileName: string) => `Fichier sélectionné : ${fileName}`,
      noFileSelected: "Aucun fichier sélectionné",
      importTemplateSubmit: "Importer",
      importTemplateCancel: "Annuler",
      importTemplateSuccess: "Modèle importé",
      importTemplateError: "Échec de l’import du modèle",
      downloadTemplate: "Télécharger le modèle",
      downloadScript: "Télécharger le script",
      ps1ModalTitle: "Script PowerShell (.ps1)",
      ps1ModeUpload: "Importer un fichier",
      ps1ModeCopy: "Copier depuis un autre modèle",
      ps1SourceLabel: "Modèle source",
      ps1NoSource: "Aucun autre modèle avec un script",
      ps1CopySubmit: "Copier le script",
      ps1UploadSubmit: "Enregistrer le script",
      copyScriptSuccess: "Script copié",
      copyScriptError: "Impossible de copier le script",
      fileRequiredError: "Le fichier est requis (et ne doit pas être vide)",
      uploadScriptSuccess: "Script enregistré",
      uploadScriptError: "Impossible d’enregistrer le script",
      linkPs1: "Script PS1",
      confirmDeleteTemplate: (name: string) =>
        `Supprimer le modèle « ${name} » (Excel et script) ?`,
      deleteTemplateError: "Impossible de supprimer le modèle",
      templateConversionTitle: "Adapter une feuille fédé en modèle d’export",
      templateConversionIntro:
        "Dans l’éditeur VBA du classeur, appliquez les remplacements ci-dessous avant d’importer le fichier comme modèle.",
      templateConversionWindowsNote:
        "Ces modifications doivent être faites sous Windows, dans Excel pour Windows (pas Excel pour Mac ou en ligne).",
      replaceLabel: "Remplacer",
      withLabel: "Par",
      copyCodeTooltip: "Copier dans le presse-papiers",
      copyCodeSuccess: "Texte copié",
      vbaSaveDialogOld: `'on va proposer la boite de dialogue pour enregistrer le fichier
Application.Dialogs(xlDialogSaveAs).Show`,
      vbaSaveDialogNew: `If Len(Trim$(exportPath)) = 0 Then
    Err.Raise vbObjectError + 1000, "feuillefédé_Silent", "exportPath est vide"
End If

Application.DisplayAlerts = False

If LCase$(Right$(exportPath, 5)) = ".xlsx" Then
    ActiveWorkbook.SaveAs Filename:=exportPath, FileFormat:=xlOpenXMLWorkbook
ElseIf LCase$(Right$(exportPath, 5)) = ".xlsm" Then
    ActiveWorkbook.SaveAs Filename:=exportPath, FileFormat:=xlOpenXMLWorkbookMacroEnabled
Else
    ActiveWorkbook.SaveAs Filename:=exportPath & ".xlsx", FileFormat:=xlOpenXMLWorkbook
End If

ActiveWorkbook.Close SaveChanges:=False

Application.DisplayAlerts = True`,
      vbaSubSignatureOld: "Sub feuillefédé()",
      vbaSubSignatureNew: "Sub feuillefédé(ByVal exportPath As String)",
      vbaOrderBarOld: 'Key2:=Range("K9"), Order1:=xlAscending, _',
      vbaOrderBarNew: 'Key2:=Range("A9"), Order2:=xlAscending, _',
    },
    referees: {
      title: "Arbitres",
      create: "Ajouter un arbitre",
      edit: "Modifier l'arbitre",
      delete: "Supprimer",
      search: "Rechercher (nom, prénom, grade, club…)",
      organisation: "Organisation",
      allOrganisations: "Toutes",
      import: "Importer Excel",
      importModalTitle: "Import d'arbitres (Excel)",
      mappingInfo: "Colonnes : A=Nom, B=Prénom, C=Grade, D=Année, E=Club",
      selectFile: "Choisir un fichier .xlsx",
      selectOrganisation: "Sélectionner l'organisation",
      preview: "Aperçu",
      importConfirm: "Importer",
      duplicatesSkipped: (count: number) => `${count} doublon(s) ignoré(s)`,
      created: (count: number) => `${count} arbitre(s) créé(s)`,
      firstname: "Prénom",
      lastname: "Nom",
      rank: "Grade",
      rankYear: "Année de grade",
      club: "Club",
      cancel: "Annuler",
      save: "Enregistrer",
      confirmDelete: "Êtes-vous sûr de vouloir supprimer cet arbitre ?",
      noReferees: "Aucun arbitre",
      loading: "Chargement...",
      error: "Erreur",
      user: "Utilisateur associé",
      noUser: "Aucun",
    },
    testExport: {
      title: "Test Export Feuille Fédération",
      userLabel: "Utilisateur",
      userDescription:
        "Sélectionnez l'utilisateur dont la licence sera utilisée pour l'export",
      generateSection: {
        title: "Génération de données de test",
        description:
          "Génère une compétition temporaire avec des athlètes de différentes catégories pour tester l'export feuille fédération.",
        button: "Générer des données de test",
        generating: "Génération...",
        meetCreated: "Compétition créée",
      },
      exportSection: {
        title: "Export feuille fédération",
        description:
          "Exporte la feuille fédération pour les données de test générées.",
        formatLabel: "Format",
        sheetDateLabel: "Date de feuille",
        button: "Exporter la feuille fédération",
        exporting: "Export en cours...",
        formatOptions: {
          all: "Tous",
          fa: "FA/PL",
          bp: "DC/BP",
        },
      },
      compareSection: {
        title: "Comparaison avec fichier de référence",
        description:
          "Uploadez un fichier Excel de référence pour comparer avec l'export généré.",
        selectFile: "Sélectionner un fichier",
        summary: "Résumé de la comparaison",
        totalDifferences: "Total de différences",
        byType: {
          values: "Valeurs",
          formulas: "Formules",
          types: "Types",
        },
        details: "Détails des différences",
        columns: {
          sheet: "Feuille",
          cell: "Cellule",
          expected: "Valeur attendue",
          actual: "Valeur actuelle",
          type: "Type",
        },
        identical: "Les fichiers sont identiques !",
        differencesFound: (count: number) =>
          `${count} différence(s) trouvée(s)`,
      },
      cleanup: {
        button: "Supprimer les données de test",
        success: "Données de test supprimées",
      },
      errors: {
        generate: "Erreur lors de la génération des données",
        export: "Erreur lors de l'export",
        compare: "Erreur lors de la comparaison",
        cleanup: "Erreur lors du nettoyage",
        loadSheetDates: "Erreur lors du chargement des dates",
      },
      success: {
        generate: "Données de test générées avec succès",
        export: "Export réussi",
      },
    },
    records: {
      title: "Records",
      import: "Importer",
      refresh: "Actualiser",
      exportPortable: "Exporter le modèle fédéral",
      importPortable: "Importer le modèle fédéral",
      portableExportSuccess: "Le modèle fédéral a été exporté",
      portableImportSuccess: "Les records fédéraux ont été importés",
      parentRecordReadOnly:
        "Les records des organisations parentes sont en lecture seule",
      parentRecordsHint:
        "Les records des organisations parentes (fédération, monde…) sont visibles en lecture seule. Seuls les records de votre organisation peuvent être modifiés ou importés.",
      ownOrganisationBadge: "Votre organisation",
      parentOrganisationBadge: "Lecture seule",
      federationScopeRequired:
        "Synchronisez d'abord la fédération pour importer ou modifier les records",
      recordNotFound: "Record introuvable",
      columns: {
        organisation: "Organisation",
        movement: "Mouvement",
        weightCategory: "Catégorie de poids",
        ageCategory: "Catégorie d'âge",
        performance: "Performance",
        athlete: "Athlète",
        dateLocation: "Date/Lieu",
        sheetDate: "Date de la feuille",
      },
      instructions: {
        fileFormat: "Format du fichier",
        sheets: "Onglets",
        structure: "Structure",
        sheetNames: {
          female: "Records féminins",
          male: "Records masculins",
          main: "Niveaux",
        },
        startRow: "Ligne de départ",
        columns: "Colonnes",
        column: "Colonne",
        columnNames: {
          weightCategory: "Catégorie de poids",
          ageCategory: "Catégorie d'âge",
          squat: "Flexion",
          bench: "Développé couché",
          deadlift: "Soulevé de terre",
          total: "Total",
          R3: "R3",
          R2: "R2",
          R1: "R1",
          N2: "N2",
          N1: "N1",
          Europe: "Europe",
          Monde: "Monde",
        },
        subColumnNames: {
          athlete: "Athlète",
          weight: "Performance",
          date: "Date/Lieu",
        },
      },
      errors: {
        importError: "Erreur lors de l'import des records",
        importEmpty:
          "Aucun record importé. Utilisez le modèle fédéral (portable) pour KDKS/IPF, ou une feuille FFForce pour FFForce.",
        ageCategoryEmpty:
          "Catégorie d'âge manquante (colonne ageCategoryCode). Choisissez une valeur du menu, ex. OPEN (FA).",
        ageCategoryInvalid: (detail: string) =>
          `Catégorie d'âge invalide : ${detail}`,
        weightCategoryNotFound: "Catégorie de poids non trouvée",
        ageCategoryNotFound: "Catégorie d'âge non trouvée",
        weightExtractionFailed:
          "Impossible d'extraire le poids de la catégorie",
        recordSaveFailed: "Erreur lors de l'enregistrement du record",
        sheetNotFound: (sex: string) =>
          `Onglet des records ${sex === "F" ? "féminins" : "masculins"} non trouvé`,
        movementNotFound: "Mouvement non trouvé",
        errorList: "Liste des erreurs",
      },
      importSuccess: "Import des records terminé avec succès",
      importedRecords: (count: number) => `${count} record(s) importé(s)`,
      displayModal: {
        title: "Records",
        button: "Afficher les records",
        discipline: "Discipline",
        sex: "Sexe",
        age: "Catégorie d'âge",
        allAges: "Toutes les catégories",
        class: "Catég.",
        lifter: "Athlète",
        weight: "Performance",
        dateLocation: "Date/Lieu",
        empty: "Aucun record pour ces filtres.",
        closeAria: "Fermer",
        organisationFallback: "Organisation",
        movements: {
          squat: "Flexion de jambes",
          bench: "Développé couché",
          deadlift: "Soulevé de terre",
          total: "Total",
        },
      },
    },
    niveaux: {
      title: "Niveaux",
      import: "Importer",
      refresh: "Actualiser",
      exportPortable: "Exporter le modèle fédéral",
      importPortable: "Importer le modèle fédéral",
      portableExportSuccess: "Le modèle de niveaux a été exporté",
      portableImportSuccess: "Les niveaux fédéraux ont été importés",
      inheritedReadOnly:
        "Les niveaux de l'organisation source (héritée) sont en lecture seule",
      inheritedHint:
        "Votre organisation hérite des minimas d'une autre organisation. Pour gérer vos propres niveaux, un administrateur doit pointer la source « Minimas / niveaux » vers votre organisation.",
      ownOrganisationBadge: "Votre organisation",
      parentOrganisationBadge: "Lecture seule",
      federationScopeRequired:
        "Synchronisez d'abord le snapshot fédéral (connexion) pour gérer les niveaux.",
      niveauNotFound: "Niveau introuvable",
      columns: {
        level: "Niveau",
        weightCategory: "Catégorie de poids",
        ageCategory: "Catégorie d'âge",
        minTotal: "Total minimum",
        maxTotal: "Total maximum",
        sheetDate: "Date de la feuille",
        organisation: "Organisation",
      },
      instructions: {
        fileFormat: "Format du fichier",
        sheets: "Onglets",
        structure: "Structure",
        sheetNames: {
          main: "Niveaux",
        },
        startColumn: "Colonne de départ",
        column: "Colonne",
        columnNames: {
          weightCategory: "Catégorie de poids",
          R3: "R3",
          R2: "R2",
          R1: "R1",
          N2: "N2",
          N1: "N1",
          Europe: "Europe",
          Monde: "Monde",
        },
        genderSections: {
          male: "Section masculine",
          female: "Section féminine",
        },
      },
      errors: {
        importError: "Erreur lors de l'import des niveaux",
        errorList: "Liste des erreurs",
      },
      importSuccess: "Import des niveaux terminé avec succès",
      displayModal: {
        title: "Affichage des Niveaux",
        discipline: "Discipline",
        masculine: "masculin",
        feminine: "féminine",
        category: "Catég.",
        note: "les performances inferieures au niveau régionale sont classées par défaut comme niveau départemental",
        button: "Afficher les niveaux",
        emptyCell: "-",
        empty: "Aucun niveau pour cette discipline.",
        closeAria: "Fermer",
      },
    },
    accounts: {
      title: "Comptes",
      users: "Utilisateurs",
      licenses: "Licences",
      profile: "Profil",
    },
  },
  filesSelected: "Fichier(s) sélectionné(s)",
  display: {
    essai: "ESSAI",
    prochainPoids: "PROCHAIN POIDS",
    barChangeFlash: "CHANGEMENT DE BARRE",
    hauteur: "HAUTEUR",
    securites: "SECURITES",
    cales: "CALES",
    rack: "RACK",
    total: "Total",
    place: "Place",
    displayAll: "Afficher",
    category: "Catégorie",
    placement: "Placement",
    totalAnnonced: "Total Annoncé",
    totalReal: "Total Réalisé",
    attempt: "Essai",
    status: "Statut",
    value: "Valeur",
    settings: "Écrans",
    assetsPreparing:
      "Téléchargement des ressources pour une utilisation hors ligne…",
    assetsReady: "Ressources téléchargées - prêt hors ligne",
    assetsMissing: "Certaines ressources ne sont pas disponibles hors ligne.",
    assetsRetry: "Réessayer",
    assetsFontList: "Liste des polices",
    screen: "Écran",
    none: "Aucun",
    noScreenAssigned:
      "Cet affichage n'est pas associé à un écran ne peut pas s'ouvrir. Choisissez un écran dans les paramètres.",
    ticketTimes: "Temps tickets",
    plateau: "Plateau",
    identify: "Identifier les écrans",
    hideIdentification: "Masquer l'identification",
    main: "Écran principal",
    restart: "Redémarrer les écrans",
    standardDisplaysTab: "Écrans standards",
    customDisplaysTab: "Écrans personnalisés",
    customDisplayAdd: "Ajouter un écran",
    customDisplayName: "Nom de l'écran",
    customDisplayLayout: "Affichage",
    customDisplayOpen: "Ouvrir l'écran",
    customDisplayDelete: "Supprimer l'écran",
    customDisplayEmpty: "Aucun écran personnalisé configuré",
    customDisplayNameRequired: "Le nom de l'écran est obligatoire",
    customDisplayLayoutRequired: "Veuillez choisir un affichage",
    customDisplayCreateError: "Impossible d'ajouter cet écran personnalisé",
    customDisplayMissing: "Aucun écran personnalisé sélectionné",
    customDisplayNotFound: "Écran personnalisé introuvable",
    customDisplayInvalid: "Affichage personnalisé invalide",
    customDisplayFallbackLabel: "Écran personnalisé",
    customDisplayLoading: "Chargement…",
    customDisplayQuota: (count: number, max: number) =>
      `${count}/${max} écrans personnalisés configurés`,
    layoutButton: "Paramètres",
    layoutModalTitle: "Affichage de l'écran",
    layoutModalHelp:
      "Sélectionnez un de vos affichages enregistrés sur le compte, puis importez-le pour remplacer l'écran.",
    layoutJsonPlaceholder: "Collez ici l'affichage de l'écran...",
    layoutJsonError: "L'affichage de l'écran est invalide",
    layoutLoadMine: "Charger mes affichages",
    layoutSelectMine: "Mes affichages",
    layoutImportSelected: "Importer",
    layoutLoadingList: "Chargement de la liste des affichages…",
    layoutLoadingImport: "Import de l'affichage…",
    layoutAssigned: "Affichage assigné",
    layoutClearAssignment: "Retirer l'affichage",
    layoutLoadListError: "Impossible de charger la liste des affichages",
    layoutLoadError: "Impossible de charger cet affichage",
    layoutDiscipline: "Discipline du layout",
    layoutDefaultDiscipline: "Défaut",
    duplicateError: "Les affichages suivants sont utilisés plusieurs fois :",
    referees: "Arbitres",
    arbitrage: "Arbitrage",
    webClient: "Application web",
    publicDisplay: "Classement public",
    currentAthlete: "Athlète actuel",
    categoryAthletes: "Athlètes de la catégorie",
    attempts: "Essais",
    totalMax: "Total max",
    totalAnnounced: "Total annoncé",
    success: "Réussi",
    failed: "Échoué",
    announced: "Annoncé",
    current: "En cours",
    tooltips: {
      webClient: "Ouvrir l'application web",
      settings: "Configurer les paramètres d'affichage des écrans",
      displayAll: "Afficher ou masquer tous les écrans simultanément",
      athlete: "Afficher l'écran de gestion des athlètes",
      loader: "Afficher l'écran des chargeurs",
      ranking: "Afficher l'écran des classements",
      publicDisplay: "Afficher l'écran de classement public",
      import: "Importer de nouveaux groupes",
      search: "Afficher le contenu du groupe",
      start: "Démarrer l'affichage du groupe",
      stop: "Arrêter l'affichage du groupe",
      results:
        "Afficher et exporter les résultats de la compétition pour les récompenses",
    },
  },
  placement: (placement: number) => {
    if (placement === 1) return "1er";
    if (placement === 0) return "0";
    return `${placement}ème`;
  },
  addAthlete: "Ajouter un athlète",
  deleteAthlete: "Supprimer l'athlète",
  ranking: {
    passageStatus: (count: number | null) =>
      count === null
        ? "-"
        : count === 0
          ? "Passage en cours"
          : `Passage dans ${count} essai${count > 1 ? "s" : ""}`,
    passagesBefore: "Passage",
    title: "Classement chauffe",
    points: (formula?: string) =>
      String(formula ?? "").toUpperCase() === "DOTS" ? "DOTS" : "Points GL",
    attempt: "Tentative",
    placement: "Place",
    placementAnnonced: "Place annoncée",
    name: "Nom",
    firstName: "Prénom",
    total: "Total",
    liveMode: "Ordre barre",
    categoryMode: "Catégorie",
  },
  results: {
    meetResults: "Résultats de la compétition",
    showPodiums: "Afficher les podiums",
    separateAgeCategories: "Séparer les catégories d'âge",
    resultsPerPage: "Résultats par page",
    page: "Page",
    of: "sur",
    rank: "Rang",
    lastName: "Nom",
    club: "Club",
    squat: "Squat",
    bench: "Dév. Couché",
    deadlift: "Soulevé de Terre",
    total: "Total",
    level: "Niveau",
    points: (formula?: string) =>
      String(formula ?? "").toUpperCase() === "DOTS" ? "DOTS" : "Points GL",
    podiums: "Podiums",
    menCategory: "Hommes",
    womenCategory: "Femmes",
    mixedCategory: "Mixte",
    sexFilter: "Sexe",
    allSexes: "Tous",
    competitionFormatFilter: "Format de compétition",
    allFormats: "Tous les formats",
    ageCategoryFilter: "Catégorie d'âge",
    weightCategoryFilter: "Catégorie de poids",
  },
  exportGroupModal: {
    feuilleFederation: "Export au format fédération (Excel)",
    openPowerlifting: "Export au format OpenPowerlifting (CSV)",
    showTickets: "Afficher les tickets du groupe",
  },
  errors: {
    anErrorOccured: "Une erreur est survenue.",
    wrongPasswordOrLogin: "Identifiant ou mot de passe incorrect.",
    pleaseEnterPassword: "Veuillez saisir votre mot de passe.",
    pleaseEnterLogin: "Veuillez saisir votre identifiant.",
    pleaseEnterLoginAndPassword:
      "Veuillez saisir votre identifiant et votre mot de passe.",
    needToBeConnectedToInternet:
      "Vous devez être connecté à Internet pour activer le direct.",
    needToBeConnectedToNetwork:
      "Vous devez être connecté en WiFi pour utiliser les lumières d'arbitrage.",
    criticalBlock: {
      title: "Blocage Critique de l'Application",
      subtitle: "Comptage d'athlètes compromis",
      description:
        "L'application doit être fermée pour des raisons de sécurité et de conformité de licence.",
      reasonLabel: "Raison du blocage",
      detailsLabel: "Détails techniques",
      warning:
        "Cette situation nécessite une intervention technique. L'application ne peut pas continuer à fonctionner.",
      instructions:
        "Contactez votre administrateur système ou fermez l'application et réessayez plus tard avec une connexion internet stable.",
    },
    licenseSync: {
      success: "Données de licence synchronisées",
      updated: "Limite d'athlètes mise à jour",
      error: "Erreur de synchronisation",
      noChanges: "Aucune mise à jour disponible",
    },
  },
  users: {
    title: "Liste des utilisateurs",
    fields: {
      id: "Identifiant",
      login: "Nom d'utilisateur",
      password: "Mot de passe",
      roles: "Rôles",
      created_at: "Date de création",
      email: "Adresse e-mail",
      organization: "Organisation",
    },
  },
  homeWeb: {
    searchHere: "Recherchez ici...",
    noMeetFound: "Aucune compétition ne correspond à votre recherche",
    organisation: "Organisation",
    allOrganisations: "Toutes les organisations",
    discipline: "Discipline",
    allDisciplines: "Toutes les disciplines",
    athletesCount: (count: number) =>
      count === 1 ? "1 athlète" : `${count} athlètes`,
    statusFinished: "Terminée",
    statusOngoing: "En cours",
    statusThisWeek: "Cette semaine",
    statusThisMonth: "Ce mois",
    statusUpcoming: "À venir",
  },
  // Gestion d'erreurs unifiée pour le système de licence
  systemErrors: {
    authentication: {
      invalidCredentials: {
        title: "Identifiants incorrects",
        message: "Le nom d'utilisateur ou le mot de passe est incorrect",
      },
      accountDisabled: {
        title: "Compte désactivé",
        message: "Votre compte a été désactivé. Contactez votre administrateur",
      },
    },
    network: {
      connectionFailed: {
        title: "Problème de connexion",
        message:
          "Impossible de se connecter au serveur. Vérifiez votre connexion internet",
      },
    },
    license: {
      expired: {
        title: "Licence expirée",
        message: (expirationDate?: Date) =>
          `Votre licence a expiré${expirationDate ? ` le ${expirationDate.toLocaleDateString()}` : ""}. Contactez votre administrateur pour la renouveler`,
      },
    },
    generic: {
      unexpectedError: {
        title: "Erreur inattendue",
        message: "Une erreur inattendue s'est produite. Veuillez réessayer",
      },
    },
    athleteQuotaBlocked: {
      title: "Quota d'athlètes atteint",
    },
  },
  warning: {
    athleteQuotaNearLimit: {
      title: "Quota bientôt atteint",
    },
    athleteQuotaWarning: {
      title: "Attention au quota",
    },
  },
  actions: {
    tryAgain: "Réessayer",
    resetPassword: "Réinitialiser le mot de passe",
    workOffline: "Travailler hors ligne",
    contactSupport: "Contacter le support",
    renewLicense: "Renouveler la licence",
    contactAdmin: "Contacter l'administrateur",
    useLocalLicense: "Utiliser une licence locale",
    reportBug: "Signaler un bug",
    upgradeAccount: "Améliorer le compte",
    manageAthletes: "Gérer les athlètes",
    checkConnection: "Vérifier la connexion",
  },
  rankFromTo: (placeFrom: number, placeTo: number): string => {
    if (placeFrom == placeTo) return `${dico().placement(placeFrom)}`;
    return `${dico().placement(placeFrom)} à ${dico().placement(placeTo)}`;
  },
  stream: {
    noStreamConfigured: "Aucun stream configuré",
    invalidUrl: "URL de stream invalide",
    title: "Diffusion en direct",
    liveGroup: "Groupe en direct",
    hideStream: "Masquer le stream",
    showStream: "Afficher le stream",
    additionalContent: "Contenu additionnel (à venir)",
    plateauLinks: {
      title: "Liens live",
      menuButton: "Liens live",
      globalLabel: "Lien global (tous les plateaux)",
      globalHelper:
        "Utilisé si aucun lien n'est défini pour le plateau du groupe en direct",
      plateauLabel: (n: number) => `Plateau ${n}`,
      urlPlaceholder:
        "YouTube: youtube.com/watch?v=xxx ou @channel | Twitch: twitch.tv/channel",
      save: "Enregistrer",
      cancel: "Annuler",
      saved: "Liens live enregistrés",
      saveError: "Impossible d'enregistrer les liens live",
    },
    errors: {
      noLiveFound:
        "Impossible de trouver un live en cours sur cette chaîne. Vérifiez que le live est bien démarré ou utilisez l'URL directe du live (youtube.com/watch?v=...).",
      twitchHttpsRequired:
        "⚠️  Twitch nécessite HTTPS. Le stream peut ne pas fonctionner en développement (http://localhost)",
      twitchProductionOnly:
        "    Le stream Twitch fonctionnera en production sur https://meet-manager.fr",
    },
  },
  speaker: {
    title: "Vue Speaker",
    landing: {
      title: "Compétitions en direct",
      empty: "Aucune compétition en direct n'est disponible.",
      openSpeaker: "Ouvrir la vue speaker",
    },
    noAthleteSelected: "Aucun athlète sélectionné",
    noGroupSelected: "Aucun groupe en cours",
    selectGroupFromMeetPage:
      "Sélectionnez un groupe depuis la page de la compétition",
    connectingToLive: "Connexion au direct…",
    liveNotEnabled: "Le direct n'est pas activé",
    liveNotEnabledHint:
      "Activez le direct depuis l'application Meet Manager sur l'ordinateur de la compétition. Cette page se mettra à jour automatiquement.",
    noData: "N/A",
    today: "Aujourd'hui",
    yesterday: "Hier",
    daysAgo: (days: number) => `Il y a ${days} jour${days > 1 ? "s" : ""}`,
    weeksAgo: (weeks: number) =>
      `Il y a ${weeks} semaine${weeks > 1 ? "s" : ""}`,
    monthsAgo: (months: number) => `Il y a ${months} mois`,
    yearsAgo: (years: number) => `Il y a ${years} an${years > 1 ? "s" : ""}`,
    bestPerformances: "Meilleures performances",
    bestTotals: "Meilleurs totaux",
    bestTotal: "Meilleur total",
    bestSquat: "Meilleur squat",
    bestBench: "Meilleur développé",
    bestDeadlift: "Meilleur soulevé",
    successRates: "Taux de réussite",
    refereeLights: "Lumières d'arbitrage",
    weightDifferences: "Écarts de poids",
    attempt: "Essai",
    squat: "Squat",
    bench: "Développé couché",
    deadlift: "Soulevé de terre",
    rankingAndLevel: "Classement et niveau",
    projectedPlace: "Place prévisionnelle",
    announcedPlace: "Place annoncée",
    currentLevel: "Niveau",
    announcedLevel: "Niveau annoncé",
    levelMinimum: "Total minimum",
    nextLevel: "Prochain niveau",
    hidePanel: "Masquer le panel",
    showPanel: "Afficher le panel",
    groupSelectLabel: "Groupe",
    liveGroupBadge: "Direct",
    backToLiveGroup: "Revenir au groupe en direct",
    currentAthleteBadge: "En cours",
    backToCurrentAthlete: "Revenir à l'athlète en cours",
    levelsButton: "Minimas",
    recordsButton: "Records",
    notes: {
      title: "Notes",
      placeholder: "Notes privées sur cet athlète…",
      hint: "Notes privées, conservées d'une compétition à l'autre.",
      saving: "Enregistrement…",
      saved: "Enregistré",
      saveError: "Impossible d'enregistrer la note.",
    },
  },
  athleteSpeaker: {
    weightCategory: "Catégorie",
    ageCategory: "Âge",
  },
  mouvementName: (mouv: Exercise) => {
    switch (mouv.name) {
      case "squat":
        return "Flexion de jambes";
      case "bench":
        return "Développé couché";
      case "deadlift":
        return "Soulevé de terre";
      default:
        return "";
    }
  },
  meetDefinedPrivate: "La compétition est maintenant privée.",
  meetDefinedPublic: "La compétition est maintenant public.",
  datagrid: {
    MuiTablePagination: {
      labelRowsPerPage: "Lignes par page :",
      labelDisplayedRows: function defaultLabelDisplayedRows({
        from,
        to,
        count,
      }: {
        from: number;
        to: number;
        count: number;
      }) {
        return `${from}–${to} sur ${count !== -1 ? count : `sur plus de ${to}`}`;
      },
    },
    paginationRowsPerPage: "Lignes par page :",
    noRowLabel: "Aucune ligne",
    toolbarDensity: "Densité",
    toolbarDensityLabel: "Densité",
    toolbarDensityComfortable: "Confortable",
    toolbarDensityCompact: "Compacte",
    toolbarDensityStandard: "Standard",
    columnsManagementSearchTitle: "Recherche",
    columnsManagementNoColumns: "Aucune colonne",
    columnsManagementShowHideAllText: "Afficher/Masquer tout",
    columnsManagementReset: "Réinitialiser",
    columnsManagementDeleteIconLabel: "Clear",
    columnMenuLabel: "Menu",
    columnMenuAriaLabel: (columnName: string) => `${columnName} column menu`,
    columnMenuShowColumns: "Afficher les colonnes",
    columnMenuManageColumns: "Gérer les colonnes",
    columnMenuFilter: "Filtrer",
    columnMenuHideColumn: "Masquer la colonne",
    columnMenuUnsort: "Désactiver le tri",
    columnMenuSortAsc: "Trier par ordre croissant",
    columnMenuSortDesc: "Trier par ordre décroissant",
    columnMenuManagePivot: "Gérer le pivot",
    toolbarFilters: "Filtres",
    toolbarFiltersTooltipShow: "Afficher les filtres",
    toolbarFiltersTooltipHide: "Masquer les filtres",
    filterPanelAddFilter: "Ajouter un filtre",
    filterPanelRemoveAll: "Tout supprimer",
    filterPanelDeleteIconLabel: "Supprimer",
    filterPanelEditIconLabel: "Modifier",
    filterPanelColumns: "Colonne",
    filterPanelOperator: "Opérateur",
    filterPanelLinkOperator: "Opérateur logique",
    filterPanelInputLabel: "Valeur",
    filterPanelInputPlaceholder: "Valeur du filtre",
    linkOperatorAnd: "et",
    linkOperatorOr: "ou",
    filterOperatorContains: "contient",
    filterOperatorDoesNotContain: "ne contient pas",
    filterOperatorEquals: "égal à",
    filterOperatorNotEquals: "différent de",
    filterOperatorStartsWith: "commence par",
    filterOperatorEndsWith: "se termine par",
    filterOperatorIsEmpty: "est vide",
    filterOperatorIsNotEmpty: "n'est pas vide",
    filterOperatorIsAnyOf: "fait partie de",
    filterOperatorIs: "est",
    filterOperatorNot: "n'est pas",
    filterOperatorGreaterThan: "supérieur à",
    filterOperatorGreaterThanOrEqual: "supérieur ou égal à",
    filterOperatorLessThan: "inférieur à",
    filterOperatorLessThanOrEqual: "inférieur ou égal à",
    filterOperatorBefore: "avant",
    filterOperatorOnOrBefore: "le ou avant",
    filterOperatorAfter: "après",
    filterOperatorOnOrAfter: "le ou après",
    filterValueAny: "n'importe lequel",
    filterValueTrue: "vrai",
    filterValueFalse: "faux",
    footerRowSelected: (count: number) =>
      `${count} ligne ${count > 1 ? "selectionnées" : "selectionnée"}`,
  },
  export: {
    exportResultat: "Export des résultats",
    meetFederationTitle: "Export des feuilles fédération",
    meetFederationDescription: "Choisissez le type d'athlètes à exporter",
    meetFederation: "Feuilles fédération",
    exportFaAthletes: "Export FA Athletes",
    exportPlAthletes: "Export PL Athletes",
    faAthletes: "Athlètes FA",
    plAthletes: "Athlètes PL",
    openPowerlifting: "OpenPowerlifting",
    exportOpenPowerlifting: "Export au format OpenPowerlifting (CSV)",
    attemptTimestamps: "Timestamps des tentatives",
    exportAttemptTimestamps:
      "Export CSV des heures de début et de fin de chaque tentative (UTC)",
    exportFullPowerAthletes: "Export des athlètes FA/PL",
    exportSingleLiftAthletes: "Export des athlètes 1 mouvement (DC/BP)",
    // Descriptions spécifiques par discipline
    exportFA:
      "Export des athlètes Force Athlétique (squat, développé couché, soulevé de terre)",
    exportPL:
      "Export des athlètes Powerlifting (squat, développé couché, soulevé de terre)",
    exportDC:
      "Export des athlètes Développé Couché (développé couché uniquement)",
    exportBP: "Export des athlètes Bench Press (développé couché uniquement)",
    saveFile: "Enregistrer le fichier",
    success: "Export réussi",
    error: "Erreur lors de l'export",
    selectFormat: "Sélectionner le format d'export",
    formatDescription:
      "Cette compétition contient des groupes en format FA/PL et DC/BP. Veuillez sélectionner le format à exporter :",
    formatFAPL: "FA/PL - Force Athlétique / Powerlifting",
    formatDCBP: "DC/BP - Développé Couché / Bench Press",
    macroExcelModal: {
      title: "Export feuille fédération (Macro Excel)",
      description:
        "Choisissez le modèle Excel à utiliser. Les modèles sont filtrés selon le format de la compétition.",
      selectTemplate: "Modèle d'export",
      noTemplate:
        "Aucun modèle disponible pour ce format. Demandez à un administrateur d'en importer un.",
      loading: "Chargement des modèles...",
      loadError: "Impossible de charger la liste des modèles.",
      accessDenied:
        "Ce compte n’a pas accès aux modèles Macro Excel. Connectez-vous avec un compte possédant le rôle Licensed.",
      export: "Exporter",
      exporting: "Export en cours...",
      cancel: "Annuler",
      close: "Fermer",
      success: "Export terminé avec succès",
      saved: (savePath: string) => `Fichier enregistré : ${savePath}`,
      error: "Échec de l'export Macro Excel",
      progressTitle: "Génération de la feuille fédération",
      savingTitle: "Enregistrement du fichier...",
      progress: {
        pending: "En attente...",
        preparing: "Préparation des fichiers...",
        connecting: "Connexion au serveur d'export...",
        uploading: "Envoi des données et du modèle...",
        executing: "Génération du classeur en cours...",
        downloading: "Récupération du résultat...",
        cleaning: "Nettoyage...",
        done: "Terminé",
      },
      phaseLabels: {
        athletes: (current: number, total: number) =>
          `${current}/${total} athlètes`,
        macroFede: (current: number, total: number) =>
          `${current}/${total} feuilles`,
        merge: (current: number, total: number) =>
          `${current}/${total} fusions`,
      },
      /**
       * Textes produits par l’agent Windows / scripts PS1 (`Write-StatusFile`);
       * parsés côté client par `translateMacroExcelExternalStatusMessage`.
       */
      externalToolMessages: {
        preparingExport: "Préparation de l'export…",
        writingAthletes: (current: number, total: number) =>
          `Écriture des athlètes ${current}/${total}`,
        macroFeuilleChunk: (
          kind: string,
          macroCurrent: number,
          macroTotal: number,
          chunkCurrent: number,
          chunkTotal: number,
        ) =>
          `Macro feuille (${kind}) ${macroCurrent}/${macroTotal} - bloc ${chunkCurrent}/${chunkTotal}`,
        mergeSimple: (current: number, total: number) =>
          `Fusion ${current}/${total}`,
        mergeBlock: (
          rangeStart: number,
          rangeEnd: number,
          total: number,
          targetFileName: string,
        ) =>
          `Fusion segments ${rangeStart}-${rangeEnd}/${total} vers ${targetFileName}`,
        mergeCompleted: (
          current: number,
          total: number,
          targetFileName: string,
        ) => `Fusion ${current}/${total} terminée vers ${targetFileName}`,
        mergeSaveChunk: (chunkIndex: number, chunkTotal: number) =>
          `Enregistrement de la fusion ${chunkIndex}/${chunkTotal}`,
        mergeChunkSaved: (
          chunkIndex: number,
          chunkTotal: number,
          mergedFileName: string,
        ) =>
          `Fusion ${chunkIndex}/${chunkTotal} enregistrée → ${mergedFileName}`,
        exportCompleted: "Export terminé",
        done: "Terminé",
      },
      saveDialogTitle: "Enregistrer la feuille fédération",
      saveDialogExcelFilesFilter: "Fichiers Excel",
      saveDialogDefaultName: (defaultName: string) => defaultName,
      cancelConfirm:
        "L'export est en cours sur le serveur. Voulez-vous vraiment l'abandonner ?",
      /** Titre de la modale MUI (useConfirmDialog) pour confirmer l’abandon. */
      abortExportDialogTitle: "Abandonner l'export ?",
      /** Bouton principal : confirme l’abandon (serveur distant peut encore finir seul). */
      abortExportConfirmButton: "Abandonner",
      /** Bouton secondaire : fermer la confirmation et poursuivre l’export. */
      abortExportContinueButton: "Continuer",
      cancelled: "Export annulé.",
      saveCancelled: "Enregistrement annulé.",
      errorMessages: {
        notConfigured:
          "Le serveur d'export n'est pas configuré. Contactez votre administrateur.",
        alreadyRunning:
          "Un export est déjà en cours pour cette compétition. Veuillez patienter.",
        connection: "Impossible de se connecter au serveur d'export.",
        upload: "Échec lors de l'envoi des fichiers au serveur d'export.",
        powershell: "Le script d'export a échoué.",
        powershellTimeout:
          "Le script d'export a dépassé le temps imparti. Réessayez ou contactez votre administrateur.",
        outputNotFound:
          "Le fichier de sortie est introuvable. Vérifiez que le script génère bien un classeur.",
        download: "Échec du téléchargement du fichier généré.",
        templateNotFound: "Le modèle sélectionné est introuvable côté serveur.",
        scriptNotFound:
          "Aucun script PowerShell n'est associé à ce modèle. Contactez votre administrateur.",
        unknown: "Une erreur inattendue est survenue.",
      },
    },
  },
  startGroupConfirm: (competitionFormat: CompetitionFormat) =>
    `Voulez-vous vraiment lancer l'affichage du groupe ? Les niveaux sont vides. Importez une feuille de match via la page d'administration des niveaux. (${competitionFormat === CompetitionFormat.FULL_POWER ? "FA/PL" : "DC/BP"})`,
  startGroupIncompleteConfirm: (count: number) => ({
    title: "Données incomplètes",
    message: `${count} athlète${count > 1 ? "s" : ""} ${count > 1 ? "ont" : "a"} des données incomplètes (poids de corps, date de naissance, lot, openers ou hauteurs). Voulez-vous démarrer le groupe quand même ?`,
  }),
  levelAreEmptyError: (competitionFormat: CompetitionFormat) =>
    `Les niveaux sont vides. Importez une feuille de match via la page d'administration des niveaux. (${competitionFormat === CompetitionFormat.FULL_POWER ? "FA/PL" : "DC/BP"})`,
  levelDateEmptyError:
    "La date des niveaux est vides. Importez une feuille de match via la page d'administration des niveaux.",
  exportFederationConfirm: (fileDate: string) =>
    `La feuille fédération va être exportée en utilisant la feuille de match "${fileDate}".`,
  electronWeb: {
    dashboard: "Dashboard",
    startTimer: "Démarrer le chronomètre",
    resumeTime: "Reprendre le chronomètre",
    stopTimer: "Arrêter le chronomètre",
    resetTimer: "Réinitialiser le chronomètre",
    resetLights: "Réinitialiser les lumières",
    powerliftingMode: "Mode Powerlifting",
    powerliftingModeDescription:
      "Powerlifting, 1 Jury, 3 Arbitres, Cartes Blanche, Rouge, Bleue et Jaune",
    timer: "Chronomètre",
    timerDescription:
      "Quand décoché le chronomètre est désactivé. Dans le cas où vous utilisez un chronomètre séparé.",
    timerMinutes: "Minutes du chronomètre",
    timerMinutesDescription:
      "Définir le chronomètre à une valeur: (par exemple 1:32)",
    currentMinutes: "Minutes actuelles:",
    apply: "Appliquer",
    customisation: "Personnalisation",
    resultDuration: "Durée du résultat",
    resultDurationDescription:
      "La durée jusqu'à ce que le résultat soit affiché.",
    currentSeconds: "Secondes actuelles:",
    enterSeconds: "Entrer les secondes",
    settings: "Paramètres",
    ticketTime: "Temps du ticket:",
    juryDiscuss: "Attente, discussion du jury",
    juryOverruled: "Le jury a modifié la décision",
    jury: "Jury",
    leftReferee: "Arbitre latéral gauche",
    chiefReferee: "Chef de plateau",
    rightReferee: "Arbitre latéral droit",
    home: "Accueil",
    youHaveBeenDisconnected: "Vous avez été déconnecté.",
    refereeConnected: "Connecté au PC",
    refereeConnecting: "Connexion au PC en cours…",
    refereeConnectionLost:
      "Liaison avec le PC indisponible. Reconnexion automatique en cours. Vérifiez que le téléphone est sur le même réseau Wi-Fi que le PC.",
    refereeReconnect: "Reconnecter",
    refereeCommandNotSent:
      "Appui non envoyé. Veuillez réessayer une fois connecté au PC.",
    unableToConnectToServer: "Impossible de se connecter au serveur",
    invalidTimeFormat:
      "Format de temps invalide. Veuillez entrer le temps dans le format MM:SS (par exemple 05:30).",
    connectionErrorHelp:
      "Veillez à ce que l'application lumières d'arbitrage soit démarrée en vous rendant dans la page de gestion des lumières d'arbitrage et en cliquant sur le bouton \"Démarrer\".",
    lights: {
      white: "Blanche",
      red: "Rouge",
      blue: "Bleue",
      yellow: "Jaune",
      timer: "Chronomètre",
      barLoaded: "Barre chargée",
      juryDiscussion: "Stop (discussion du jury)",
      resetJury: "Réinitialiser",
    },
  },
  lights: {
    showLightsInRank:
      "Afficher les lumières d'arbitrages et les chronomètres sur l'écran du classement",
    cantStopApp:
      "Vous ne pouvez pas arrêter l'application car elle est utilisé par les widgets.",
    confirmTitle: "Récupération de la configuration Wi-Fi",
    confirmMessage:
      "Voulez-vous récupérer votre configuration Wi-Fi ? \n Cette opération peut nécessiter la saisie de votre mot de passe administrateur. Cela permettra de proposer une connexion via QR code au réseau Wi-Fi, mais n'est pas obligatoire.",
    confirmLabel: "Récupérer",
    cancelLabel: "Non",
    settings: "Paramètres des lumières d'arbitrage",
    typeSelector: {
      title: "Type de lumières d'arbitrage",
      meetManager: "Lumières Meet Manager",
      ipf: "Lumières IPF officielles",
      description: "Choisissez le type de lumières d'arbitrage à utiliser",
    },
    start: "Démarrer",
    stop: "Arrêter",
    openApp: "Ouvrir l'application d'arbitrage",
    url: "URL de l'application",
    fetchNetworkInformations: "Récupération des informations réseau...",
    wifiInformations: "Informations du réseau Wi-FI",
    refresh: "Rafraîchir",
    networkName: "Nom du réseau (SSID)",
    password: "Mot de passe",
    clientsConnected: "Clients connectés",
    clientDeconnect: "Le client a été déconnecté.",
    helpTitle: "Comment utiliser les lumières d'arbitrage",
    helpDescription:
      "Cette interface vous permet de configurer et gérer les lumières d'arbitrage pour votre compétition.",
    helpStep1:
      "Connectez-vous au même réseau Wi-Fi que les appareils des arbitres",
    helpStep2:
      "Sélectionnez l'URL de l'application dans la liste des adresses disponibles",
    helpStep3: 'Cliquez sur "Démarrer" pour lancer le serveur des lumières',
    helpStep4:
      "Scannez les QR codes avec les appareils des arbitres pour accéder à leurs interfaces respectives",
    helpNote:
      "Note : Plusieurs adresses peuvent être disponibles pour le même réseau. Si la connexion ne fonctionne pas avec la première adresse, essayez les autres une par une jusqu'à trouver celle qui permet aux arbitres de se connecter.",
    connectToWifi: "Scannez pour vous connecter",
    tooltips: {
      settings: "Configurer les paramètres des lumières d'arbitrage",
      start: "Démarrer les lumières d'arbitrage",
      stop: "Arrêter les lumières d'arbitrage",
      show: "Afficher l'écran des lumières d'abitrage ",
      disconnect: "Déconnecter le client",
      copyUrl: "Copier l'URL",
    },
    copyUrl: "Copier l'URL",
    urlCopied: "URL copiée !",
    adminTable: {
      columnOs: "Système d'exploitation",
      columnBrowser: "Navigateur",
      columnDevice: "Appareil",
      columnPage: "Page",
      columnAction: "Actions",
    },
  },
  license: {
    unlimitedAthletes: "Athlètes illimités",
    title: "Licence",
    valid: "Valide",
    expired: "Expirée",
    viewActivations: "Voir les activations",
    managementTitle: "Gestion de la licence",
    description:
      "Pour utiliser Meet Manager, vous devez activer une licence valide. Saisissez votre clé de licence ci-dessous :",
    replaceDescription:
      "Vous pouvez remplacer la licence actuelle par une nouvelle :",
    licenseKey: "Clé de licence",
    newLicenseKey: "Nouvelle clé de licence",
    placeholder: "XXXX-XXXX-XXXX-XXXX",
    currentLicense: "Licence actuelle",
    limitReached: "Limite atteinte",
    limitReachedDescription:
      "Cette licence a atteint son nombre maximum d'activations. Aucune nouvelle machine ne peut être activée.",
    machineId: "ID Machine",
    machineName: "Machine sans nom",
    activatedOn: "Activé le",
    activations: "Activations",
    activationsUsed: "Activations utilisées",
    machinesActivated: "Machines activées",
    expiresOn: "Expire le",
    noActivations: "Aucune activation",
    noActivationsDescription:
      "Cette licence n'a pas encore été activée sur une machine.",
    lastUsed: "Dernière utilisation",
    activeNow: "Actif maintenant",
    daysAgo: (days: number) => `Il y a ${days} jour${days > 1 ? "s" : ""}`,
    hoursAgo: (hours: number) => `Il y a ${hours}h`,
    key: "Clé",
    deactivateMachine: "Désactiver la machine",
    confirmDeactivate: "Confirmer la désactivation",
    confirmDeactivateMessage: (machineName: string) =>
      `Êtes-vous sûr de vouloir désactiver la machine "${machineName}" ? Cette action ne peut pas être annulée.`,
    deactivateSuccess: "Machine désactivée avec succès",
    deactivateError: "Erreur lors de la désactivation de la machine",
    activation: {
      title: "Activation de licence",
      managementTitle: "Gestion de la licence",
      description:
        "Pour utiliser Meet Manager, vous devez activer une licence valide. Saisissez votre clé de licence ci-dessous :",
      replaceDescription:
        "Vous pouvez remplacer la licence actuelle par une nouvelle :",
      licenseKey: "Clé de licence",
      newLicenseKey: "Nouvelle clé de licence",
      placeholder: "XXXX-XXXX-XXXX-XXXX",
      currentLicense: "Licence actuelle",
      key: "Clé",
      machine: "Machine",
      expiration: "Expiration",
      expirationNotDefined: "Non définie",
      status: "Statut",
      validStatus: (daysRemaining: number) =>
        `Valide (${daysRemaining} jours restants)`,
      expiredStatus: "Expirée",
      invalidStatus: "Invalide",
      athleteCount: "Nombre d'athlètes",
      checkingLicense: "Vérification de la licence...",
      activate: "Activer",
      replace: "Remplacer",
      remove: "Supprimer la licence",
      activating: "Activation...",
      removing: "Suppression...",
      success: "Licence activée avec succès !",
      noLicense: "Aucune licence activée",
      removeSuccess: "Licence supprimée avec succès",
      errors: {
        required: "Veuillez saisir une clé de licence",
        activationFailed: "Erreur lors de l'activation",
        removeFailed: "Erreur lors de la suppression de la licence",
        unexpected: "Une erreur inattendue s'est produite",
      },
    },
    errors: {
      network: "Impossible de se connecter au serveur de licences",
      server: "Le serveur de licences est temporairement indisponible",
      invalidLicense: "Clé de licence invalide",
      expired: "La licence a expiré",
      activationLimit: "Limite d'activations atteinte pour cette licence",
      machineFingerprint: "Erreur d'identification de la machine",
      encryption: "Erreur de chiffrement des données de licence",
      fileSystem: "Erreur d'accès aux fichiers de licence",
      unknown: "Une erreur inattendue s'est produite",
      nameRequired: "Le nom de la licence est requis",
      maxActivationsRange:
        "Le nombre maximum d'activations doit être compris entre 1 et 100",
      expirationDateFuture: "La date d'expiration doit être dans le futur",
      keyTooShort: "La clé de licence doit contenir au moins 5 caractères",
      keyRequired: "La clé de licence est requise",
    },
    suggestions: {
      network: "Vérifiez votre connexion internet et réessayez",
      server: "Réessayez dans quelques minutes",
      invalidLicense: "Vérifiez que la clé de licence est correcte",
      expired: "Contactez votre administrateur pour renouveler la licence",
      activationLimit:
        "Contactez votre administrateur pour augmenter la limite d'activations",
      machineFingerprint: "Redémarrez l'application",
      encryption: "Supprimez la licence existante et réactivez-la",
      fileSystem: "Redémarrez l'application en tant qu'administrateur",
      unknown: "Réessayez ou contactez le support technique",
    },
    status: "Statut",
    isActive: "Actif",
    maxActivations: "Nombre maximum d'activations",
    expirationDate: "Date d'expiration",
    name: "Nom",
    placeholders: {
      name: "Nom de la licence",
      key: "Clé de licence",
    },
    generateKey: "Générer une clé aléatoire",
    deactivate: "Désactiver",
    configuration: "Configuration",
    informations: "Informations",
    create: "Créer une licence",
    edit: "Modifier la licence",
    delete: "Supprimer la licence",
    confirmDelete: (name: string) =>
      `Êtes-vous sûr de vouloir supprimer la licence "${name}" ?`,
    unlimited: "Illimité",
    keyRequired: "La clé de licence est requise",
    capabilities: {
      sectionTitle: "Affichages personnalisés & régie",
      quotasTitle: "Quotas",
      maxCustomScreens: "Nombre max. d'écrans custom",
      maxCustomWidgets: "Nombre max. de widgets custom",
      quotasHelper: "0 = aucun quota alloué",
      layoutEditor: {
        accessControl: "Éditeur d'affichages",
        accessTooltip:
          "Autorise la création et l'édition des affichages sur le portail licencié",
      },
      customDisplay: {
        accessControl: "Affichages personnalisés (desktop)",
        accessTooltip:
          "Autorise l'utilisation des affichages personnalisés dans l'application desktop",
      },
      remoteCustomDisplay: {
        accessControl: "Affichages personnalisés distants",
        accessTooltip:
          "Autorise les affichages personnalisés via le runtime web (OBS, pages publiques)",
      },
      controlRoom: {
        accessControl: "Régie",
        accessTooltip:
          "Autorise l'accès au panneau de régie pour piloter les affichages",
      },
      enabled: "Activé",
      disabled: "Désactivé",
      accessUpdated: (
        licenseName: string,
        featureLabel: string,
        status: string,
      ) => `${featureLabel} mis à jour pour ${licenseName} : ${status}`,
      accessUpdateError:
        "Erreur lors de la mise à jour des droits de la licence",
      maxQuotaInvalid: "La valeur doit être un entier positif ou nul",
    },
  },
  appLanguage: {
    label: "Langue",
    french: "Français",
    english: "Anglais",
  },
  theme: {
    previewAthlete: "Athlète",
    previewGroup: "Groupe 2 · Squat · Essai 2",

    themes: "Thèmes",
    default: "Par défaut",
    errors: {
      nameRequired: "Le nom est requis",
      thisThemeAlreadExists: "Ce thème existe déjà",
    },
    edit: "Modifier le thème",
    create: "Créer un thème",
    informations: "Informations",
    name: "Nom",
    owner: "Propriétaire",
    public: "Public",
    publicYes: "Public",
    publicNo: "Privé",
    publicLabel: "Rendre ce thème public (visible pour tous les utilisateurs)",
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer le thème "{name}" ?',
    deleteBlockedTitle: "Suppression impossible",
    deleteBlockedMessage: (layouts: string[]) =>
      `Ce thème est utilisé par les affichages suivants : ${layouts.join(", ")}. Veuillez d'abord retirer l'association.`,
    manageThemes: "Gérer les thèmes",
    myThemes: "Mes thèmes",
    noThemes: "Aucun thème créé pour le moment.",
    placeholders: {
      name: "Nom du thème",
    },
    title: "Thème",
    settings: "Paramètres du thème",
    primaryColor: "Couleur principale",
    primaryTextColor: "Couleur du texte (principal)",
    rankingTextColor: "Couleur du texte (classement)",
    backgroundColor: "Couleur de fond",
    rankingColor: "Couleur de fond (classement)",
    backgroundTextColor: "Couleur du texte (fond)",
    preview: "Aperçu",
    previewTooltip: "Aperçu en direct avec les couleurs sélectionnées",
    primaryButtonSample: "Action principale",
    colors: "Couleurs",
    colorsTooltip: "Personnaliser les couleurs des écrans d'affichage",
    reset: "Réinitialiser",
    resetTooltip: "Rétablir les couleurs par défaut",
  },
  ipfLightsModal: {
    title: "Connexion aux lumières IPF",
    description: "Configurez la connexion aux lumières IPF officielles",
    explanation:
      "Pour utiliser les lumières d'arbitrage IPF officielles, vous devez être connecté au même réseau Wi-Fi que les téléphones des arbitres.",
    urlLabel: "URL du contrôleur",
    placeholder: "ex. http://192.168.0.50:8080",
    connect: "Se connecter",
    connecting: "Connexion en cours…",
    status: {
      label: "Statut",
      connected: "Connecté",
      notConnected: "Non connecté",
    },
    connectedTo: "URL connectée",
    snack: {
      connected: "Connecté aux lumières IPF.",
      error: "Échec de la connexion : non connecté aux lumières IPF.",
    },
  },
  moveGroupModal: {
    title: "Déplacer l'athlète vers un autre groupe",
    description:
      "Choisissez le groupe de destination puis validez pour déplacer l'athlète.",
    selectLabel: "Groupe de destination",
    submit: "Valider le déplacement",
    moving: "Déplacement…",
    cancel: "Annuler",
    snack: {
      success: "Athlète déplacé avec succès.",
      error: "Échec du déplacement de l'athlète.",
      sameGroup: "L'athlète est déjà dans ce groupe.",
      formatMismatch:
        "Le groupe de destination doit avoir le même format de compétition que le groupe actuel.",
    },
    noCompatibleGroups:
      "Aucun autre groupe de cette compétition n'a le même format de compétition.",
  },
  account: {
    loading: "Initialisation du système de comptes...",
    login: {
      title: "Connexion",
      usernameLabel: "Nom d'utilisateur ou email",
      usernamePlaceholder: "Entrez votre nom d'utilisateur ou email",
      passwordLabel: "Mot de passe",
      submitButton: "Se connecter",
      openWebClientButton: "Ouvrir l'application web",
      validation: {
        loginRequired: "Le nom d'utilisateur ou email est requis",
        passwordRequired: "Le mot de passe est requis",
        passwordMinLength:
          "Le mot de passe doit contenir au moins 6 caractères",
      },
    },
    profile: {
      notConnected: "Aucun utilisateur connecté",
      userType: {
        title: "Type d'utilisateur",
        admin: "Administrateur",
        licensed: "Utilisateur avec licence",
        demo: "Utilisateur démo",
        unknown: "Inconnu",
      },
      organization: "Organisation",
      license: {
        title: "Licence",
        valid: "Licence valide",
        invalid: "Licence invalide ou expirée",
      },
      memberSince: "Membre depuis",
      lastUpdate: "Dernière mise à jour",
      changePassword: "Changer le mot de passe",
      editTooltip: "Modifier le profil",
      logout: "Se déconnecter",
      profileButton: "Profil",
    },
    changePassword: {
      title: "Changer le mot de passe",
      description:
        "Entrez votre ancien mot de passe et choisissez un nouveau mot de passe sécurisé.",
      oldPasswordLabel: "Ancien mot de passe",
      newPasswordLabel: "Nouveau mot de passe",
      confirmPasswordLabel: "Confirmer le nouveau mot de passe",
      submitButton: "Changer le mot de passe",
      submittingButton: "Changement en cours...",
      cancelButton: "Annuler",
    },
    connection: {
      title: "Connexion requise",
      description: "Une connexion est nécessaire pour activer votre licence.",
      note: "Cette connexion permet de charger vos informations de compte et de licence.",
      loginTitle: "Connexion temporaire",
      loginSubtitle: "Connectez-vous pour valider votre licence",
      cancelButton: "Annuler",
      closeButton: "Fermer",
    },
    errors: {
      invalidCredentials: "Nom d'utilisateur ou mot de passe incorrect",
      accountDisabled: "Compte désactivé",
      emailInvalid: "Adresse email invalide",
      passwordTooWeak: "Mot de passe trop faible",
      networkError: "Erreur de réseau",
      rateLimitExceeded: "Trop de tentatives de connexion",
      connectionRequired: "Connexion requise",
      serverUnavailable: "Serveur d'authentification indisponible",
      licenseExpired: "Licence expirée - contactez votre administrateur",
      licenseInactive: "Licence inactive - contactez votre administrateur",
      noLicense: "Aucune licence active - contactez votre administrateur",
      licenseTermsNotAccepted:
        "Votre licence n'est pas encore activée. Veuillez vous connecter à l'application web pour lire et accepter les conditions de licence.",
      licenseTermsNotAcceptedTitle: "Conditions de licence non acceptées",
      oldPasswordIncorrect: "Ancien mot de passe incorrect",
      passwordChangeFailed: "Erreur lors du changement de mot de passe",
      passwordChangedSuccess: "Mot de passe modifié avec succès",
      tokenExpired: "Session expirée",
      tokenNotFound: "Session introuvable",
      tokenInvalid: "Session invalide",
      authenticationRequired: "Authentification requise",
    },
    warnings: {
      tokenExpired: {
        title: "Session expirée",
        message:
          "Votre session a expiré. Veuillez vous reconnecter pour continuer.",
        action: "Se reconnecter",
      },
      tokenNotFound: {
        title: "Session introuvable",
        message:
          "Aucune session active trouvée. Veuillez vous connecter pour accéder aux fonctionnalités.",
        action: "Se connecter",
      },
      authenticationRequired: {
        title: "Authentification requise",
        message:
          "Vous devez être connecté pour accéder à cette fonctionnalité.",
        action: "Se connecter",
      },
    },
    admin: {
      usersTitle: "Gestion des Utilisateurs",
      createUser: "Créer un utilisateur",
      editUser: "Modifier l'utilisateur",
      createUserButton: "Créer un utilisateur",
      createUserDescription:
        "Remplissez le formulaire pour créer un nouvel utilisateur",
      editUserDescription: "Modifiez les informations de l'utilisateur",
      userInformation: "Informations de l'utilisateur",
      loginLabel: "Nom d'utilisateur",
      emailLabel: "Adresse email",
      passwordLabel: "Mot de passe",
      newPasswordLabel: "Nouveau mot de passe",
      newPasswordHelper: "Laissez vide pour conserver le mot de passe actuel",
      nameLabel: "Nom complet",
      organizationLabel: "Organisation",
      noOrganization: "Aucune",
      userTypeLabel: "Type d'utilisateur",
      rolesLabel: "Rôles",
      rolesHelper: "Sélectionnez les rôles de l'utilisateur",
      parentUserLabel: "Compte licencié parent",
      parentUserHelper:
        "Le compte DisplayEditor utilisera la licence de ce compte parent.",
      parentUserRequired:
        "Un compte licencié parent est requis pour le rôle DisplayEditor",
      licenseLabel: "Licence",
      licenseHelper: "Sélectionnez une licence pour l'utilisateur",
      noLicense: "Aucune licence",
      speakerLicensesLabel: "Licences speaker",
      speakerLicensesHelper:
        "Le speaker verra uniquement les compétitions live de ces licences et n'aura les fonctionnalités connectées que sur celles-ci (0..N).",
      cancelButton: "Annuler",
      createButton: "Créer",
      updateButton: "Mettre à jour",
      savingButton: "Sauvegarde...",
      table: {
        login: "Login",
        email: "Email",
        name: "Nom",
        organization: "Organisation",
        userType: "Type",
        roles: "Rôles",
        license: "Licence",
        status: "Statut",
        actions: "Actions",
        installerFile: "Installateur",
        installerSize: "Taille",
        installerDate: "Date upload",
        installerChecksum: "Checksum",
        noInstaller: "Aucun",
        downloadInstaller: "Télécharger l'installateur",
        downloadError: "Erreur lors du téléchargement",
        termsAccepted: "Conditions acceptées",
        termsPending: "Conditions à accepter",
      },
      status: {
        active: "Actif",
        inactive: "Inactif",
      },
      actions: {
        edit: "Modifier",
        delete: "Supprimer",
        activate: "Activer",
        deactivate: "Désactiver",
        more: "Plus d'actions",
      },
      confirmDelete: {
        title: "Confirmer la suppression",
        message: (login: string) =>
          `Êtes-vous sûr de vouloir supprimer l'utilisateur "${login}" ?`,
        cancel: "Annuler",
        confirm: "Supprimer",
      },
      uploadInstaller: {
        menuLabel: "Téléverser l'installateur",
        success: "Installateur téléversé avec succès.",
        error: "Échec du téléversement de l'installateur.",
        acceptedExtensions: ".exe,.msi,.dmg,.pkg,.zip",
      },
    },
  },
  licensedPortal: {
    layoutEditor: {
      workspace: {
        unsaved: "Modifications non synchronisées",
        noResults: "Aucun affichage ne correspond à la recherche.",
        emptyLibrary: "Aucun affichage disponible pour ce compte.",
        recovered:
          "Une copie locale a été récupérée. Enregistrez pour la synchroniser.",
        recoveryConflict:
          "Une copie locale non synchronisée existe, mais la version en ligne a changé. Choisissez la version à conserver avant de modifier ce document.",
        useLocal: "Récupérer ma copie locale",
        useRemote: "Conserver la version en ligne",
        recoveryFailed:
          "Le stockage local est indisponible. Votre copie reste en mémoire pendant cette session : enregistrez ou exportez avant de fermer ou recharger la page.",
        alreadySaved: "Le document est déjà enregistré.",
        history: "Historique",
        insert: "Insertion",
        selection: "Sélection",
        automation: "Comportements",
        fit: "Ajuster la scène",
        zoomIn: "Zoom avant",
        zoomOut: "Zoom arrière",
        expandGroups: "Déplier les groupes",
        collapseGroups: "Replier les groupes",
      },
      title: "Éditeur d'affichages",
      save: "Enregistrer",
      newLayout: "Nouvel affichage",
      editLayout: "Modifier l'affichage",
      deleteLayout: "Supprimer l'affichage",
      deleteConfirm: "Êtes-vous sûr de vouloir supprimer cet affichage ?",
      canvasSize: "Taille du canvas",
      width: "Largeur",
      height: "Hauteur",
      layoutName: "Nom de l'affichage",
      layoutType: "Type",
      typeWidget: "Widget",
      typeDisplay: "Écran",
      toolbar: {
        text: "Texte",
        image: "Image",
        video: "Vidéo",
        shape: "Forme",
        rectangle: "Rectangle",
        square: "Carré",
        ellipse: "Ellipse",
        oval: "Ovale",
        line: "Ligne",
        triangle: "Triangle",
        rightTriangle: "Triangle rectangle",
        trapezoid: "Trapèze",
        parallelogram: "Parallélogramme",
        pentagon: "Pentagone",
        hexagon: "Hexagone",
        octagon: "Octogone",
        star: "Étoile",
        ranking: "Classement",
        barLoader: "Chargeur de barre",
        layoutList: "Liste",
        qrCode: "QR code",
        icon: "Icône",
        duplicate: "Dupliquer",
        bringForward: "Mettre devant",
        sendBackward: "Mettre derrière",
        bringForwardOne: "Avancer d'un plan",
        sendBackwardOne: "Reculer d'un plan",
        group: "Mettre dans un conteneur",
        ungroup: "Supprimer le conteneur",
        extractFromContainer: "Sortir du conteneur",
        openBehavior: "Ouvrir le comportement",
        openSceneBehavior: "Ouvrir le comportement de scène",
        createAnimation: "Créer une animation",
        addKeyframe: "Ajouter une keyframe",
        saveAnimation: "Sauvegarder l'animation",
        cancelAnimation: "Annuler l'animation",
        cut: "Couper",
        copy: "Copier",
        paste: "Coller",
        resetPreview: "Réinitialiser l'aperçu comme à l'ouverture de la page",
        openRuntimePreview: "Ouvrir la preview compétition",
        delete: "Supprimer",
        undo: "Annuler",
        redo: "Rétablir",
        undoTooltip: "Annuler (Ctrl+Z)",
        redoTooltip: "Rétablir (Ctrl+Y ou Ctrl+Shift+Z)",
        customDisciplineInput: "Champ de saisie",
        customDisciplineButton: "Bouton",
      },
      runtimePreview: {
        loading: "Chargement de la preview...",
        loadError: "Impossible de charger la preview.",
        persistedLayoutRequired:
          "Enregistre cet affichage avant d'ouvrir la preview compétition.",
        play: "Lecture",
        pause: "Pause",
        previousFrame: "Frame précédente",
        nextFrame: "Frame suivante",
        hideControls: "Masquer les contrôles",
        showControls: "Afficher les contrôles",
        sexProfile: "Profil",
        sexProfileMen: "2 groupes hommes",
        sexProfileWomen: "2 groupes femmes",
        sexProfileMenWomen: "Groupe hommes + groupe femmes",
        sexProfileMixedMen: "Groupe mixte + groupe hommes",
        sexProfileMixedWomen: "Groupe mixte + groupe femmes",
        sexProfileMixed: "2 groupes mixtes",
        group1Age: "Âge groupe 1",
        group2Age: "Âge groupe 2",
        secondsPerFrame: "Secondes / frame",
        themeColors: "Couleurs du thème",
        resetThemeColors: "Réinitialiser",
        controlRoomTitle: "Régie preview",
        controlRoomSubtitle: "Actions locales de l'affichage",
        controlRoomPreviewTarget: "Preview compétition",
        controlRoomNoCards:
          "Aucun événement de régie publié dans cet affichage.",
        hideControlRoom: "Masquer la régie",
        showControlRoom: "Afficher la régie",
      },
      tabs: {
        display: "Éditeur",
        behavior: "Comportement",
        sceneBehavior: "Comportement de scène",
        sceneInvalidTitle: "Animations de scène invalides",
        sceneInvalidWarning:
          "Certaines animations de scène sont invalides et ne seront plus jouées :",
        sceneInvalidConfirm: "Continuer",
        sceneInvalidCancel: "Annuler",
        nodeMissing: "Le nœud associé n'existe plus.",
      },
      layers: {
        title: "Composants de l'affichage",
        empty: "Aucun composant pour le moment",
        container: "Conteneur",
        searchPlaceholder: "Rechercher...",
      },
      properties: {
        title: "Propriétés",
        searchPlaceholder: "Rechercher...",
        positionSize: "Position & Taille",
        style: "Style",
        visibility: "Visibilité",
        width: "Largeur",
        height: "Hauteur",
        fontSize: "Taille",
        color: "Couleur",
        background: "Fond",
        backgroundColor: "Couleur",
        backgroundImage: "Dégradé",
        backgroundImageTextHint:
          "Sur un texte, le dégradé remplit les lettres (pas le fond du bloc).",
        styleSubsectionBackground: "Fond",
        borderRadius: "Arrondi",
        border: "Bordure",
        fontFamily: "Police",
        padding: "Espacements",
        opacity: "Opacité",
        fontWeight: "Épaisseur",
        textAlign: "Alignement",
        textTransform: "Casse du texte",
        whiteSpace: "Espace blanc",
        overflow: "Débordement (visible, hidden, auto)",
        breakBefore: "Saut de page avant (auto, page)",
        breakInside: "Coupure de page (auto, avoid)",
        textDecorationLine: "Ligne de décoration",
        textDecorationColor: "Couleur de décoration",
        textDecorationStyle: "Style de décoration",
        textDecorationThickness: "Épaisseur de décoration",
        propertyPanelLabels: {
          textDecorationLine: "Ligne",
          textDecorationColor: "Couleur",
          textDecorationStyle: "Style",
          textDecorationThickness: "Épaisseur",
          textTransform: "Casse",
          textShadow: "Ombre",
        },
        transform: "Inclinaison",
        filter: "Filtre",
        cursor: "Curseur",
        boxShadow: "Ombre portée",
        textShadow: "Ombre de texte",
        dataBinding: "Liaison de données",
        source: "Source",
        path: "Chemin",
        none: "Aucun",
        staticText: "Texte statique",
        imageUrl: "URL de l'image",
        selectImage: "Sélectionner une image",
        selectVideo: "Sélectionner une vidéo",
        videoMuted: "Muet",
        videoLoop: "Boucle",
        booleanYes: "Oui",
        booleanNo: "Non",
        totalWeight: "Poids total",
        barWeight: "Poids de la barre",
        collarsWeight: "Poids des colliers",
        mode: "Mode",
        container: "Conteneur",
        containerLayout: "Mise en page",
        containerLayoutAbsolute: "Absolu",
        containerLayoutFlex: "Flex",
        containerLayoutLockedFlex:
          "La mise en page Flex est requise pour un conteneur en position relative dans un parent Flex.",
        containerFlexDirection: "Direction",
        containerFlexDirectionRow: "Ligne",
        containerFlexDirectionRowReverse: "Ligne inversée",
        containerFlexDirectionColumn: "Colonne",
        containerFlexDirectionColumnReverse: "Colonne inversée",
        containerGap: "Espacement",
        containerJustifyContent: "Justification du contenu",
        containerJustifyContent_center: "Centré",
        "containerJustifyContent_flex-start": "Début",
        "containerJustifyContent_flex-end": "Fin",
        containerJustifyContent_normal: "Normal",
        "containerJustifyContent_space-between": "Espacé entre",
        "containerJustifyContent_space-around": "Espacé autour",
        "containerJustifyContent_space-evenly": "Espacement uniforme",
        containerAlignItems: "Alignement des éléments",
        containerAlignItems_center: "Centré",
        "containerAlignItems_flex-start": "Début",
        "containerAlignItems_flex-end": "Fin",
        "containerAlignItems_space-between": "Espacé entre",
        "containerAlignItems_space-around": "Espacé autour",
        "containerAlignItems_space-evenly": "Espacement uniforme",
        containerSizeModeFixed: "Fixe",
        containerSizeModeFitContent: "Adaptatif",
        listModePreview: "Aperçu",
        listModeEdit: "Édition",
        listLine: "Ligne",
        listLineDefault: "Par défaut",
        listMaxItems: "Nombre maximum",
        listRowKeyPath: "Identifiant",
        listTransitionSection: "Transition",
        listTransitionEnabled: "Activer",
        listTransitionEnabledYes: "Oui",
        listTransitionEnabledNo: "Non",
        listTransitionProperties: "Propriété",
        listTransitionDuration: "Durée (ms)",
        listTransitionEasing: "Courbe",
        listTransitionDelay: "Délai (ms)",
        listTransitionPropertyLabels: {
          transform: "Transformation",
          left: "Position gauche",
          top: "Position haut",
          height: "Hauteur",
          width: "Largeur",
          opacity: "Opacité",
          "background-color": "Couleur de fond",
          color: "Couleur du texte",
          border: "Bordure",
          "border-radius": "Arrondis",
          "box-shadow": "Ombre",
          "font-size": "Taille de police",
          padding: "Marge intérieure",
          margin: "Marge extérieure",
        },
        dataSource: "Source de données",
        listDirection: "Direction de la liste",
        listDirection_column: "Colonne",
        listDirection_row: "Ligne",
        "listDirection_column-reverse": "Colonne inversée",
        "listDirection_row-reverse": "Ligne inversée",
        partsLabel: "Contenu (texte et liaisons)",
        addPart: "Ajouter un élément",
        addPartLiteral: "Ajouter du texte",
        addPartBinding: "Ajouter une liaison",
        partLiteral: "Texte brut",
        partBinding: "Liaison",
        partTypeLiteral: "Texte",
        data: "Donnée",
        partTypeBinding: "Liaison",
        format: "Format",
        pathSubField: "Sous-champ",
        positionX: "X",
        positionY: "Y",
        positionWidth: "Largeur",
        positionHeight: "Hauteur",
        positionRotation: "Pivoter",
        layerLabel: "Libellé",
        styleVisibilityVisible: "Visible",
        styleVisibilityHidden: "Masqué",
        stylePosition: "Position",
        stylePositionRelative: "Relative",
        stylePositionAbsolute: "Absolue",
        styleCategorylayout: "Mise en page",
        styleCategoryfont: "Texte",
        styleCategorydecoration: "Décoration",
        styleCategorycolors: "Couleurs",
        styleCategoryborder: "Bordure",
        styleCategoryeffects: "Effets",
        styleCategorytransform: "Transformation",
        margin: "Espacements",
        behaviorControlledTooltip:
          "Ce champ est piloté par le comportement. Cliquez pour ouvrir son onglet Comportement.",
        tooltip: {
          section: "Infobulle",
          kindNone: "Aucune",
          kindText: "Texte",
          kindLayout: "Layout",
          text: "Texte de l'infobulle",
          editLayout: "Éditer le layout",
          layoutWidth: "Largeur",
          layoutHeight: "Hauteur",
          backgroundColor: "Fond",
          opacity: "Opacité",
          layoutDialogTitle: "Layout de l'infobulle",
          layoutDialogCancel: "Annuler",
          layoutDialogSave: "Enregistrer",
        },
        customDisciplineInputFields: {
          key: "Clé",
          label: "Libellé",
          type: "Type",
          defaultValue: "Valeur par défaut",
          required: "Obligatoire",
          readOnly: "Lecture seule",
          optionSource: "Source des options",
          staticOptions: "Options statiques",
          optionValuePath: "Chemin valeur",
          optionLabelPath: "Chemin libellé",
        },
        customDisciplineButtonFields: {
          label: "Libellé",
          variant: "Variante",
          startIcon: "Icône",
          noneIcon: "Aucune icône",
          size: "Taille",
          color: "Couleur",
          disabled: "Désactivé",
        },
        iconFields: {
          iconName: "Icône",
          noneIcon: "Aucune icône",
          color: "Couleur",
          size: "Taille",
        },
        barLoaderModeFull: "Complet",
        barLoaderModeSmall: "Réduit",
        barLoaderModeBar: "Barre",
        barLoaderUnit: "Unité",
        barLoaderUnitKg: "KG",
        barLoaderUnitLbs: "LBS",
        barLoaderLabelOrientation: "Orientation du libellé",
        barLoaderLabelOrientationHorizontal: "Horizontal",
        barLoaderLabelOrientationVertical: "Vertical",
        barLoaderOptionalDisks: "Disque optionnel",
        barLoaderOptionalDiskOff: "Désactivé",
        barLoaderOptionalDiskOn: "Activé",
        barLoaderCompactWidthMode: "Largeur des disques",
        barLoaderCompactWidthModeFixed: "Fixe",
        barLoaderCompactWidthModeVariable: "Variable",
        barLoaderCompactDiskAlign: "Alignement des disques",
        barLoaderCompactDiskAlignLeft: "Gauche",
        barLoaderCompactDiskAlignCenter: "Centre",
        barLoaderCompactDiskAlignRight: "Droite",
        barLoaderGlobalStyle: "Style global",
        barLoaderDiskStyle: "Style du disque",
        barLoaderDiskBodyStyle: "Style du disque",
        barLoaderLabelSection: "Libellé",
        barLoaderDiskSection: "Disque",
        all: "Tous",
        barLoaderDiskSelect: "Disque",
        barLoaderResetDiskStyle: "Réinitialiser le style du disque",
        barLoaderResetDiskStyleTooltip:
          "Réinitialiser ce disque avec le style global",
        barLoaderLabelText: "Texte",
        qrCodeValue: "Valeur",
        qrCodeStyleHint:
          "Taille du QR : redimensionner le nœud (largeur/hauteur). Couleur du QR : couleur du texte. Fond : couleur de fond.",
        styleOpacity: "Opacité",
        styleTransform: "Inclinaison",
        styleFontSize: "Taille",
        styleFontFamily: "Police",
        styleFontWeight: "Épaisseur",
        styleTextAlign: "Alignement",
        styleTextTransform: "Casse du texte",
        styleWhiteSpace: "Espace blanc",
        styleTextDecorationLine: "Ligne de décoration",
        styleTextDecorationColor: "Couleur de décoration",
        styleTextDecorationStyle: "Style de décoration",
        styleTextDecorationThickness: "Épaisseur de décoration (px)",
        styleTextAlignLeft: "Gauche",
        styleTextAlignCenter: "Centre",
        styleTextAlignRight: "Droite",
        bindingFormats: {
          date: "Date",
          time: "Heure",
          uppercase: "Majuscules",
          lowercase: "Minuscules",
          kg: "kg",
        },
      },
      colorPicker: {
        hexMode: "HEX",
        rgbMode: "RGB",
        hslMode: "HSL",
        opacity: "Opacité",
      },
      borderPicker: {
        title: "Bordure",
        reset: "Réinitialiser",
        scopeLabel: "Portée",
        scopeAll: "Tout",
        scopeTop: "Haut",
        scopeRight: "Droite",
        scopeBottom: "Bas",
        scopeLeft: "Gauche",
        styleLabel: "Style",
        styleSolid: "Plein",
        styleDashed: "Tirets",
        styleDotted: "Pointillés",
        styleDouble: "Double",
        styleNone: "Aucun",
        widthLabel: "Largeur",
        colorLabel: "Couleur",
      },
      borderRadiusPicker: {
        title: "Arrondi",
        reset: "Réinitialiser",
        scopeLabel: "Portée",
        scopeAll: "Tout",
        scopeTopLeft: "Haut gauche",
        scopeTopRight: "Haut droite",
        scopeBottomLeft: "Bas gauche",
        scopeBottomRight: "Bas droite",
        radiusLabel: "Rayon",
      },
      spacingPicker: {
        title: "Espacements",
        reset: "Réinitialiser",
        scopeAll: "Tout",
        scopeTop: "Haut",
        scopeRight: "Droite",
        scopeBottom: "Bas",
        scopeLeft: "Gauche",
        marginScopeLabel: "Portée de la marge extérieure",
        marginValueLabel: "Valeur de la marge extérieure",
        paddingScopeLabel: "Portée de la marge intérieure",
        paddingValueLabel: "Valeur de la marge intérieure",
      },
      boxShadowPicker: {
        title: "Ombre",
        reset: "Réinitialiser",
        layerLabel: "Couche",
        blur: "Flou",
        spread: "Étendue",
        color: "Couleur",
        inset: "Inset",
        insetNo: "Non",
        insetYes: "Oui",
      },
      textShadowPicker: {
        title: "Ombre de texte",
        reset: "Réinitialiser",
        layerLabel: "Couche",
        blur: "Flou",
        color: "Couleur",
      },
      filterPicker: {
        title: "Filtre",
        reset: "Réinitialiser",
        blur: "Flou",
        brightness: "Luminosité",
        contrast: "Contraste",
        grayscale: "Niveaux de gris",
        hueRotate: "Rotation teinte",
        invert: "Inversion",
        opacity: "Opacité",
        saturate: "Saturation",
        sepia: "Sépia",
        dropShadow: "Ombre portée",
        svgUrl: "Filtre SVG (URL)",
        svgFileNamePlaceholder: "fichier.svg",
        svgFilterIdPlaceholder: "filter-element-id",
        selectFile: "Choisir",
      },
      gradientPicker: {
        title: "Dégradé",
        reset: "Réinitialiser",
        typeLabel: "Type de dégradé",
        typeLinear: "Linéaire",
        typeRepeatingLinear: "Linéaire répété",
        typeRadial: "Radial",
        typeRepeatingRadial: "Radial répété",
        typeConic: "Conique",
        typeRepeatingConic: "Conique répété",
        linearSection: "Linéaire",
        radialSection: "Radial",
        conicSection: "Conique",
        direction: "Direction",
        angleMode: "Angle",
        sideMode: "Côté / Coin",
        angle: "Angle",
        side: "Côté",
        shape: "Forme",
        size: "Taille",
        position: "Position",
        from: "Depuis",
        interpolation: "Interpolation couleur",
        colorSpace: "Espace",
        defaultSpace: "Défaut",
        hueMethod: "Teinte",
        defaultHue: "Défaut",
        stopsLabel: "Stops de couleur",
        stopLabel: "Stop",
        color: "Couleur",
        positionA: "Position A",
        positionB: "Position B",
        angleA: "Angle A",
        angleB: "Angle B",
        hint: "Point intermédiaire",
        linearSideToTop: "Vers le haut",
        linearSideToRight: "Vers la droite",
        linearSideToBottom: "Vers le bas",
        linearSideToLeft: "Vers la gauche",
        linearSideToTopRight: "Vers le coin haut droit",
        linearSideToTopLeft: "Vers le coin haut gauche",
        linearSideToBottomRight: "Vers le coin bas droit",
        linearSideToBottomLeft: "Vers le coin bas gauche",
        radialSizeClosestSide: "Côté le plus proche",
        radialSizeClosestCorner: "Coin le plus proche",
        radialSizeFarthestSide: "Côté le plus éloigné",
        radialSizeFarthestCorner: "Coin le plus éloigné",
        positionCenter: "Centre",
        positionTop: "Haut",
        positionBottom: "Bas",
        positionLeft: "Gauche",
        positionRight: "Droite",
        positionTopLeft: "Haut gauche",
        positionTopRight: "Haut droite",
        positionBottomLeft: "Bas gauche",
        positionBottomRight: "Bas droite",
        preview: "Aperçu",
        rawMode: "Mode CSS brut",
      },
      animationPanel: {
        title: "Animation",
        animationLabel: "Animation",
        addAnimation: "Ajouter une animation",
        removeAnimation: "Supprimer l'animation",
        animationType: "Type d'animation",
        none: "Aucune",
        phase: "Mode de lancement",
        triggerSection: "Déclencheur",
        triggerType: "Type de déclencheur",
        editCondition: "Modifier la condition",
        source: "Source",
        path: "Chemin",
        paramsSection: "Paramètres",
        durationMs: "Durée (ms)",
        delayMs: "Délai (ms)",
        cooldownMs: "Cooldown (ms)",
        iterationCount: "Répétitions",
        easing: "Easing",
        intensity: "Intensité",
        direction: "Direction",
        angleDeg: "Angle",
        preview: "Prévisualiser",
        triggerTypes: {
          mount: "Au chargement",
          "condition-true": "Condition",
          "value-change": "Changement de valeur",
        },
        types: {
          fade: "Fondu",
          slide: "Glissement",
          "slide-up": "Glissement haut",
          "slide-down": "Glissement bas",
          "slide-left": "Glissement gauche",
          "slide-right": "Glissement droite",
          "zoom-in": "Zoom avant",
          "zoom-out": "Zoom arrière",
          pop: "Pop",
          wipe: "Balayage",
          "wipe-left": "Balayage gauche",
          "wipe-right": "Balayage droite",
          "wipe-up": "Balayage haut",
          "wipe-down": "Balayage bas",
          "blur-in": "Flou entrant",
          "blur-out": "Flou sortant",
          bounce: "Rebond",
          drift: "Dérive",
        },
        easings: {
          linear: "Linéaire",
          ease: "Ease",
          "ease-in": "Ease in",
          "ease-out": "Ease out",
          "ease-in-out": "Ease in-out",
        },
        intensities: {
          soft: "Douce",
          medium: "Moyenne",
          strong: "Forte",
        },
        directions: {
          up: "Haut",
          down: "Bas",
          left: "Gauche",
          right: "Droite",
        },
        phases: {
          in: "Entrée",
          out: "Sortie",
          "in-out": "Entrée + sortie",
        },
      },
      animationCreator: {
        cancelledBySelection:
          "Création de l'animation annulée : la sélection a changé.",
        nameDialogTitle: "Nom de l'animation",
        nameDialogLabel: "Nom",
        nameDialogConfirm: "Créer",
        nameDialogCancel: "Annuler",
        nameEmptyError: "Le nom ne peut pas être vide.",
        nameTakenError: "Une animation porte déjà ce nom.",
      },
      catalogPaste: {
        conflictTitle: "Conflits de noms du catalogue",
        conflictDescription:
          "Des animations, événements, fonctions ou variables référencés existent déjà dans cet affichage. Renommez-les pour poursuivre le collage.",
        typeAnimation: "Animation",
        typeEvent: "Événement",
        typeFunction: "Fonction",
        typeVariable: "Variable",
        oldNameLabel: "Ancien nom",
        newNameLabel: "Nouveau nom",
        nameEmptyError: "Le nom ne peut pas être vide.",
        nameTakenError: "Un élément porte déjà ce nom.",
        confirm: "Coller",
        cancel: "Annuler",
      },
      dataSources: {
        currentElement: "Élément courant",
        currentValue: "Valeur courante",
        athlete: "Athlète",
        selectedRowId: "ID ligne sélectionnée",
        selectedColumnKey: "Colonne sélectionnée",
        currentAthlete: "Athlète actuel",
        athletes: "Athlètes",
        group: "Groupe courant",
        currentGroup: "Groupe actuel",
        groups: "Groupes",
        currentMeet: "Compétition actuelle",
        rowIndex: "Indice",
        layoutListRowItem: "Ligne courante",
        currentNode: "Nœud courant",
        timer: "Chronomètre",
        timerSeconds: "Chronomètre (secondes)",
        attemptTimers: "Chronomètres d'essai",
        attemptTimerSeconds: "Chronomètres d'essai (secondes)",
        currentLift: "Mouvement actuel",
        currentMouv: "Exercice actuel",
        currentMovement: "Mouvement actuel",
        attemptNumber: "Numéro d'essai",
        placementIfSuccessful: "Classement si réussi",
        meetName: "Nom de la compétition",
        startDate: "Date de début",
        endDate: "Date de fin",
        refereeLights: "Lumières d'arbitrage",
        nextLiftData: "Prochain essai",
        records: "Records",
        niveaux: "Niveaux",
        levels: "Niveaux",
        ageCategories: "Catégories d'âge",
        disciplineAgeCategories: "Catégories d’âge de la discipline",
        disciplineWeightCategories: "Catégories de poids de la discipline",
        weightCategories: "Catégories de poids",
        disciplines: "Disciplines",
        leagues: "Organisations",
        organisation: "Organisation",
        organisations: "Organisations · catalogue",
        displaySettings: "Réglages des écrans",
        themeColors: "Couleurs du thème",
      },
      fields: {
        athlete: {
          id: "ID",
          nom: "Nom",
          prenom: "Prénom",
          club: "Club",
          licence: "Licence",
          sexe: "Sexe",
          dateNaissance: "Date de naissance",
          pdc: "PDC",
          lot: "Lot",
          group_id: "ID groupe",
          squat1: "Squat 1",
          squat1Status: "Squat 1 statut",
          squat1Auto: "Squat 1 auto",
          squat1Overturn: "Squat 1 renversé",
          squat1LeftColor: "Squat 1 gauche",
          squat1ChiefColor: "Squat 1 chef",
          squat1RightColor: "Squat 1 droite",
          squat1OverturnColor: "Squat 1 renversé couleur",
          squat2: "Squat 2",
          squat2Status: "Squat 2 statut",
          squat2Auto: "Squat 2 auto",
          squat2Overturn: "Squat 2 renversé",
          squat2LeftColor: "Squat 2 gauche",
          squat2ChiefColor: "Squat 2 chef",
          squat2RightColor: "Squat 2 droite",
          squat2OverturnColor: "Squat 2 renversé couleur",
          squat3: "Squat 3",
          squat3Status: "Squat 3 statut",
          squat3Auto: "Squat 3 auto",
          squat3Overturn: "Squat 3 renversé",
          squat3LeftColor: "Squat 3 gauche",
          squat3ChiefColor: "Squat 3 chef",
          squat3RightColor: "Squat 3 droite",
          squat3OverturnColor: "Squat 3 renversé couleur",
          bench1: "Développé 1",
          bench1Status: "Dév. 1 statut",
          bench1Auto: "Dév. 1 auto",
          bench1Overturn: "Dév. 1 renversé",
          bench1LeftColor: "Dév. 1 gauche",
          bench1ChiefColor: "Dév. 1 chef",
          bench1RightColor: "Dév. 1 droite",
          bench1OverturnColor: "Dév. 1 renversé couleur",
          bench2: "Développé 2",
          bench2Status: "Dév. 2 statut",
          bench2Auto: "Dév. 2 auto",
          bench2Overturn: "Dév. 2 renversé",
          bench2LeftColor: "Dév. 2 gauche",
          bench2ChiefColor: "Dév. 2 chef",
          bench2RightColor: "Dév. 2 droite",
          bench2OverturnColor: "Dév. 2 renversé couleur",
          bench3: "Développé 3",
          bench3Status: "Dév. 3 statut",
          bench3Auto: "Dév. 3 auto",
          bench3Overturn: "Dév. 3 renversé",
          bench3LeftColor: "Dév. 3 gauche",
          bench3ChiefColor: "Dév. 3 chef",
          bench3RightColor: "Dév. 3 droite",
          bench3OverturnColor: "Dév. 3 renversé couleur",
          deadlift1: "Tirage 1",
          deadlift1Status: "Tirage 1 statut",
          deadlift1Auto: "Tirage 1 auto",
          deadlift1Overturn: "Tirage 1 renversé",
          deadlift1LeftColor: "Tirage 1 gauche",
          deadlift1ChiefColor: "Tirage 1 chef",
          deadlift1RightColor: "Tirage 1 droite",
          deadlift1OverturnColor: "Tirage 1 renversé couleur",
          deadlift2: "Tirage 2",
          deadlift2Status: "Tirage 2 statut",
          deadlift2Auto: "Tirage 2 auto",
          deadlift2Overturn: "Tirage 2 renversé",
          deadlift2LeftColor: "Tirage 2 gauche",
          deadlift2ChiefColor: "Tirage 2 chef",
          deadlift2RightColor: "Tirage 2 droite",
          deadlift2OverturnColor: "Tirage 2 renversé couleur",
          deadlift3: "Tirage 3",
          deadlift3Status: "Tirage 3 statut",
          deadlift3Auto: "Tirage 3 auto",
          deadlift3Overturn: "Tirage 3 renversé",
          deadlift3LeftColor: "Tirage 3 gauche",
          deadlift3ChiefColor: "Tirage 3 chef",
          deadlift3RightColor: "Tirage 3 droite",
          deadlift3OverturnColor: "Tirage 3 renversé couleur",
          squat1Changes: "Changements squat 1",
          bench1Changes: "Changements dév. 1",
          bench3Changes: "Changements dév. 3",
          deadlift1Changes: "Changements tirage 1",
          deadlift3Changes: "Changements tirage 3",
          totalkg: "Total kg",
          totalAnnonced: "Total annoncé",
          placement: "Classement",
          hauteurSquat: "Hauteur squat",
          hauteurDc: "Hauteur DC",
          hauteurSecu: "Hauteur secu",
          cales: "Cales",
          positionRack: "Position rack",
          catAgeId: "ID cat. âge",
          catPoidId: "ID cat. poids",
          indice: "Indice",
          disciplineId: "ID discipline",
          isDisqualified: "Disqualifié",
          catPoidLabel: "Catégorie de poids",
          catAgeLabel: "Catégorie d'âge",
          disciplineLabel: "Discipline",
          powerscoutBestsLabel: "Records Powerscout",
          catPoid: {
            nom: "Nom",
            poidMin: "Poids min",
            poidMax: "Poids max",
            sex: "Sexe",
            isJunior: "Junior",
          },
          catAge: {
            nom: "Nom",
            code: "Code",
            ageMin: "Âge min",
            ageMax: "Âge max",
          },
          discipline: { code: "Code", nom: "Nom" },
          powerscoutBests: {
            best_squat_kg: "Squat",
            best_bench_kg: "Développé",
            best_deadlift_kg: "Tirage",
            best_total_kg: "Total",
          },
        },
        group: {
          id: "ID",
          nom: "Nom",
          meet_id: "ID compétition",
          plateauNumber: "N° plateau",
          groupNumber: "N° groupe",
          observations: "Observations",
          secretaire: "Secrétaire",
          assesseur1: "Assesseur 1",
          assesseur2: "Assesseur 2",
          chefPlateau: "Chef de plateau",
          jury: "Jury",
          share: "Partagé",
          competitionFormat: "Format",
          selected: "Sélectionné",
        },
        meet: {
          id: "ID",
          guid: "GUID",
          name: "Nom",
          ville: "Ville",
          startdate: "Date début",
          enddate: "Date fin",
          streamUrl: "URL stream",
          ligue_id: "ID organisation",
          ligueLabel: "Organisation",
          ligue: { id: "ID", nom: "Nom" },
        },
        organisation: {
          id: "ID",
          name: "Nom",
          code: "Code",
          countryCode: "Code pays",
          recordLabel: "Libellé record",
          recordColor: "Couleur record",
          recordBadgeUrl: "URL badge record",
          parentId: "ID parent",
        },
        record: {
          organisationId: "ID organisation",
          organisationLabel: "Organisation",
        },
        currentNode: {
          x: "Position X",
          y: "Position Y",
          width: "Largeur",
          height: "Hauteur",
          rotation: "Rotation",
          skewX: "Inclinaison X",
          skewY: "Inclinaison Y",
        },
      },
      conditions: {
        addCondition: "Ajouter une condition",
        condition: "Condition",
        workspaceHint:
          "Glissez des blocs depuis la palette ou réordonnez-les entre les zones en pointillés.",
        rootWrapHint:
          "Pour combiner plusieurs règles, déposez un bloc « Et » ou « Ou » au-dessus, ou utilisez les boutons.",
        paletteTitle: "Blocs",
        paletteItemSimple: "Comparaison",
        paletteItemAnd: "Groupe Et",
        paletteItemOr: "Groupe Ou",
        paletteDragHint:
          "Maintenez un bloc et déposez-le sur une zone en pointillés.",
        blockCompare: "Comparaison",
        blockLogicAndHeader: "Et (toutes vraies)",
        blockLogicOrHeader: "Ou (au moins une vraie)",
        dropInsertHere: "Zone d’insertion",
        removeBlock: "Supprimer ce bloc",
        styleValueLabel: "Valeur",
        valueWhenTrueParts: "Valeur si la condition est vraie (contenu texte)",
        defaultValue: "Valeur par défaut",
        valueWhenTrue: "Valeur si la condition est vraie",
        ifThen: "Si … alors",
        operator: "Opérateur",
        operators: {
          eq: "égal",
          neq: "différent de",
          gt: "supérieur à",
          gte: "supérieur ou égal",
          lt: "inférieur à",
          lte: "inférieur ou égal",
          defined: "défini",
          empty: "vide",
        },
        and: "Et",
        or: "Ou",
        addSimpleCondition: "Ajouter une condition simple",
        addAndGroup: "Ajouter un groupe ET",
        addOrGroup: "Ajouter un groupe OU",
        leftOperand: "Opérande gauche",
        rightOperand: "Opérande droit",
        literal: "Littéral",
        binding: "Liaison",
        invalidCondition: "Condition invalide",
        conditionRequired: "La condition est requise",
        partConditional: "Conditionnel",
        partConditionalPlaceholder: "Partie conditionnelle (édition à venir)",
        removeConditionRule: "Supprimer la règle",
        save: "Enregistrer",
        cancel: "Annuler",
      },
      mock: {
        mockData: "Données de prévisualisation",
        editMockData: "Modifier les données mock",
      },
      propertyPanelAria: {
        movePartUp: "Monter la partie",
        movePartDown: "Descendre la partie",
        removePart: "Supprimer la partie",
        addStyleCondition: "Ajouter une condition sur le style",
        removeStyleConditionRule: "Supprimer la règle de style",
      },
      noSelection: "Sélectionnez un élément pour modifier ses propriétés.",
      imageUploadError: "Erreur lors de l'import de l'image",
      videoUploadError: "Erreur lors de l'import de la vidéo",
      preview: "Aperçu",
      savedSuccess: "Affichage enregistré avec succès",
      savedError: "Erreur lors de l'enregistrement de l'affichage",
      loadError: "Affichage introuvable",
      createModalTitle: "Créer un affichage",
      createModalCancel: "Annuler",
      createModalCreate: "Créer",
      createSuccess: "Affichage créé avec succès",
      createError: "Erreur lors de la création de l'affichage",
      dimensionsPositive: "Les dimensions doivent être positives",
      deleteSuccess: "Affichage supprimé",
      deleteError: "Erreur lors de la suppression",
      exportJson: "Exporter JSON",
      exportSuccess: "Export JSON téléchargé",
      fullscreen: "Plein écran",
      exitFullscreen: "Quitter le plein écran",
    },
    layouts: {
      listTitle: "Mes affichages",
      createButton: "Créer un affichage",
      importButton: "Importer un affichage",
      importInvalidJson: "Le fichier d'affichage est invalide.",
      importApplyError:
        "L'affichage a été créé mais l'import du contenu a échoué.",
      open: "Ouvrir",
      delete: "Supprimer",
      emptyList: "Aucun affichage. Créez-en un pour commencer.",
      dimensions: "Dimensions",
      updatedAt: "Modifié",
      themeLabel: "Thème",
      targetLabel: "Écran / Widget",
      disciplineLabel: "Discipline",
      defaultDisciplineLabel: "Défaut / toutes disciplines",
      noTheme: "Sans thème",
      selectTheme: "Sélectionner un thème",
      selectTarget: "Sélectionner un écran / widget",
      none: "Aucun",
      targetAlreadyUsed: "Cet écran/widget est déjà utilisé dans ce thème.",
      readonlyBanner:
        "Ce thème est public et ne vous appartient pas. Consultation seulement.",
      sectionMyLayouts: "Mes affichages",
      targetKeys: {
        athlete_display: "Athlète",
        loader_display: "Chargeur",
        ranking_display: "Classement",
        public_display: "Public",
        lights_display: "Lumières",
        current_athlete: "Athlète actuel",
        current_category: "Catégorie actuelle",
        current_group: "Groupe actuel",
        referee_lights: "Lumières d'arbitrage",
        timer: "Chronomètre",
      },
    },
    title: "Espace licencié",
    subtitle:
      "Gérez vos informations de contact, votre licence et téléchargez l'installateur.",
    profile: {
      title: "Informations de contact",
      subtitle: "Mettez à jour vos coordonnées.",
      loginLabel: "Identifiant",
      nameLabel: "Nom",
      organizationLabel: "Organisation",
      emailLabel: "Email",
      emailPlaceholder: "Entrez votre email de contact",
      emailHelper:
        "Cet email sera utilisé pour les communications liées à votre licence.",
      saveButton: "Mettre à jour l'email",
      emptyValue: "Non renseigné",
    },
    license: {
      title: "Informations de licence",
      subtitle: "Suivi de l'utilisation et des activations.",
      keyLabel: "Clé de licence",
      expirationLabel: "Date d'expiration",
      usageLabel: "Utilisation athlètes",
      statusLabel: "Statut",
      statusActive: "Active",
      statusInactive: "Inactive",
      activationsTitle: "Machines enregistrées",
      noActivation: "Aucune machine enregistrée pour le moment.",
      activationItem: (machine: string) => `Machine : ${machine}`,
    },
    installer: {
      title: "Installateur bureau",
      subtitle:
        "Téléchargez l'installateur le plus récent de l'application bureau.",
      fileNameLabel: "Fichier",
      sizeLabel: "Taille",
      dateLabel: "Téléversé le",
      downloadButton: "Télécharger l'installateur",
      emptyState: "Aucun installateur disponible pour ce compte.",
      refreshLabel: "Actualiser les métadonnées",
    },
    password: {
      title: "Modifier le mot de passe",
      description: "Sécurisez votre compte avec un nouveau mot de passe.",
      oldPasswordLabel: "Mot de passe actuel",
      newPasswordLabel: "Nouveau mot de passe",
      confirmPasswordLabel: "Confirmer le nouveau mot de passe",
      passwordHelper: "Au moins 8 caractères sont recommandés.",
      mismatchError: "Les mots de passe ne correspondent pas.",
      weakPasswordError: "Le mot de passe doit contenir au moins 8 caractères.",
      cancelLabel: "Annuler",
      submitLabel: "Mettre à jour",
      openButton: "Changer de mot de passe",
    },
    liveMeets: {
      liveButton: (meetName: string) => `Direct : ${meetName}`,
      hubTitle: "Compétition en direct",
      hubTitleWithName: (meetName: string) => `Direct : ${meetName}`,
      hubSubtitle:
        "Accédez aux catalogues d'écrans et de widgets pour cette compétition.",
      backToDashboard: "Retour à l'espace licencié",
      loadError: "Impossible de charger les compétitions en direct.",
      displaysButton: "Liste des écrans",
      widgetsButton: "Liste des widgets",
    },
    licenseTermsAcceptance: {
      refusalMessage:
        "Vous devez accepter les conditions de licence pour utiliser Meet Manager. Votre accès n'a pas été activé.",
      verifyError: "Impossible de vérifier les conditions de licence",
      acceptSuccess: "Conditions de licence acceptées.",
      acceptError: "Impossible d'enregistrer l'acceptation",
      pdfPreviewUnavailable:
        "La prévisualisation PDF n'est pas disponible. Vous pouvez ouvrir le document dans un nouvel onglet.",
      dialogTitle: "Conditions de licence Meet Manager",
      intro:
        "Avant d'utiliser Meet Manager, vous devez lire et accepter les conditions de licence applicables à votre compte.",
      noActiveVersion:
        "Aucune version active des conditions n'est disponible. Veuillez contacter le support.",
      versionLabel: "Version",
      hashLabel: "Hash SHA-256",
      openPdfLink: "Ouvrir ou télécharger les conditions au format PDF",
      checkboxLabel:
        "Je reconnais avoir lu et j'accepte les conditions de licence Meet Manager.",
      refuseButton: "Refuser",
      signOutButton: "Se déconnecter",
      acceptButton: "Accepter et activer ma licence",
    },
    acceptedTerms: {
      title: "Conditions d'utilisation acceptées",
      subtitle:
        "Consultez les versions des conditions que vous avez acceptées pour ce compte.",
      empty: "Aucune acceptation enregistrée pour le moment.",
      versionLabel: "Version",
      acceptedAtLabel: "Acceptées le",
      openPdfButton: "Ouvrir le PDF",
      versionFallback: (version: string) => `Conditions version ${version}`,
      methodWeb: "Acceptation web",
      methodAdminManual: "Enregistrée par un administrateur",
      methodEmailReply: "Réponse e-mail",
      methodImport: "Import",
    },
    snack: {
      emailUpdated: "Email mis à jour avec succès.",
      emailUpdateError: "Impossible de mettre à jour l'email.",
      downloadReady: "Téléchargement de l'installateur lancé.",
      downloadError: "Impossible de télécharger l'installateur.",
      missingInstaller: "Aucun installateur disponible pour le moment.",
      passwordChanged: "Mot de passe mis à jour avec succès.",
      passwordChangeError: "Impossible de changer le mot de passe.",
      loadError: "Impossible de charger vos informations.",
      unauthorized: "Vous n'êtes pas autorisé à accéder à cette page.",
      planningAccessRequired:
        "Votre licence ne permet pas d'accéder aux pages planning.",
      planningSignInRequired:
        "Vous devez être connecté avec une licence valide pour accéder à cette page.",
      licenseSignInRequired:
        "Vous devez être connecté avec une licence valide pour accéder à cette page.",
      licenseFeatureAccessRequired:
        "Votre licence ne permet pas d'accéder à cette fonctionnalité.",
    },
    myMeets: {
      title: "Mes compétitions",
      tabCompetitions: "Compétitions",
      tabPlannings: "Plannings",
      noResults: "Aucune compétition ne correspond à votre recherche",
      empty: "Vous n'avez créé aucune compétition",
    },
    myRecords: {
      title: "Mes records",
      subtitle:
        "Modifiez les records de votre organisation ; les records des organisations parentes sont affichés en lecture seule.",
      openButton: "Mes records",
      organisationRequired:
        "Aucune organisation n'est associée à votre compte. Contactez un administrateur.",
      downloadEmptyTemplate: "Télécharger le modèle vide",
      downloadCurrentRecords: "Exporter les records actuels",
      importRecords: "Importer les records",
      importedRecords: (count: number) => `${count} record(s) importé(s)`,
      exportSuccess: "Fichier de records téléchargé",
      workbookError: "Impossible de traiter le fichier de records",
      deleteConfirm: (athleteName: string) =>
        `Supprimer le record de « ${athleteName} » ?`,
      deleteSuccess: "Record supprimé",
      deleteError: "Impossible de supprimer le record",
      discipline: "Discipline",
      sex: "Sexe",
    },
    myLevels: {
      title: "Mes niveaux",
      subtitle:
        "Gérez les minimas de votre organisation via le classeur portable. Un seul jeu de niveaux s'applique (héritage exclusif, sans cumul avec le parent).",
      openButton: "Mes niveaux",
      organisationRequired:
        "Aucune organisation n'est associée à votre compte. Contactez un administrateur.",
      downloadEmptyTemplate: "Télécharger le modèle vide",
      downloadCurrentLevels: "Exporter les niveaux actuels",
      importLevels: "Importer les niveaux",
      importedLevels: (count: number) => `${count} niveau(x) importé(s)`,
      exportSuccess: "Fichier de niveaux téléchargé",
      workbookError: "Impossible de traiter le fichier de niveaux",
      deleteConfirm: (name: string) => `Supprimer le niveau « ${name} » ?`,
      deleteSuccess: "Niveau supprimé",
      deleteError: "Impossible de supprimer le niveau",
      discipline: "Discipline",
      cannotEditInherited:
        "Impossible de modifier les niveaux hérité : changez d'abord la source fédérale.",
    },
    backups: {
      cleanupBackups: "Nettoyer les anciens backups",
      title: "Mes backups",
      noResults: "Aucun backup ne correspond à votre recherche",
      empty: "Vous n'avez aucun backup",
      emptyForMeet: "Vous n'avez aucun backup pour cette compétition",
      status: {
        ongoing: "En cours",
        finished: "Terminé",
      },
      backupLabel: "Backup",
      backupDateLabel: "Date de backup",
      machineLabel: "Machine",
      athletesLabel: "Athlètes",
      groupsLabel: "Groupes",
    },
    planningBuilder: {
      title: "Création de planning",
      subtitle:
        "Import Excel, génération automatique, ajustement par glisser-déposer.",
      stepImport: "Import et édition",
      stepParams: "Paramètres",
      stepBoard: "Planning",
      stepExports: "Exports",
      importExcel: "Importer un fichier Excel",
      meetName: "Nom de la compétition",
      editTable: "Éditer les champs ci-dessous",
      maxAthletesPerGroup: "Max athlètes par groupe",
      minAthletesPerGroup: "Min athlètes par groupe",
      groupsPerPlateau: "Groupes par plateau",
      groupPackingOrder: "Constitution des groupes",
      groupPackingOrderByWeight: "Par catégorie de poids",
      groupPackingOrderByAge: "Par catégorie d'âge",
      attemptDurationSec: "Durée par essai (s)",
      breakBetweenMovements: "Pause entre mouvements (min)",
      breakBetweenPlateaux: "Pause entre plateaux (min)",
      weighInHoursBeforeStart: "Pesée (heures avant le début)",
      stepParamsGenerationSection: "Paramètres de génération",
      stepParamsTimingSection: "Durées et pauses",
      stepParamsHoursSection: "Horaires par jour",
      firstPlateauStart: "Début du premier plateau",
      generate: "Générer le planning",
      plateau: "Plateau",
      group: "Groupe",
      category: "Catégorie",
      athletes: "Athlètes",
      weighIn: "Pesée",
      start: "Début",
      exportPlanning: "Exporter planning (CSV/Excel)",
      exportInstagram: "Exporter (PDF/PNG)",
      maxAthletesError: "Ce groupe ne peut pas accueillir plus d'athlètes.",
      disciplineRequired: "Veuillez sélectionner une discipline.",
      weightCategoryRequired: "Veuillez sélectionner une catégorie de poids.",
      groupCountAboveMax: (max: number) =>
        `Ce groupe dépasse le maximum de ${max} athlètes.`,
      groupCountBelowMin: (min: number) =>
        `Ce groupe a moins que le minimum de ${min} athlètes.`,
      undo: "Annuler",
      redo: "Rétablir",
      fullscreen: "Plein écran",
      exitFullscreen: "Quitter le plein écran",
      name: "Nom",
      firstname: "Prénom",
      license: "Licence",
      club: "Club",
      sex: "Sexe",
      birthDate: "Date de naissance",
      weightCategory: "Catégorie de poids",
      ageCategory: "Catégorie d'âge",
      discipline: "Discipline",
      actions: "Actions",
      deleteAthlete: "Supprimer l'athlète",
      deleteAthleteMessage: "Êtes-vous sûr de vouloir supprimer l'athlète ?",
      deleteAthleteWarning: "Cette action est irréversible.",
      cancel: "Annuler",
      delete: "Supprimer",
      ligue: "Organisation",
      organisation: "Organisation",
      startDate: "Date de début",
      endDate: "Date de fin",
      lieu: "Ville",
      addAthlete: "Ajouter un athlète",
      athleteAlreadyExists: "Un athlète avec cette licence existe déjà",
      end: "Fin",
      back: "Retour",
      backConfirmTitle: "Retour à l'étape précédente",
      backConfirmMessage:
        "Toutes les modifications effectuées sur le planning seront annulées. Souhaitez-vous continuer ?",
      next: "Suivant",
      expand: "Déplier",
      collapse: "Replier",
      emptyOption: "-",
      exportInstagramNotImplemented:
        "Export (PDF/PNG) : à implémenter avec @react-pdf/renderer et html-to-image.",
      dayLabel: "Jour",
      startHour: (date: Date) => {
        const dayName = new Intl.DateTimeFormat("fr-FR", {
          weekday: "long",
        }).format(date);
        const monthName = new Intl.DateTimeFormat("fr-FR", {
          month: "long",
        }).format(date);

        return `Heure de début du ${dayName} ${date.getDate()} ${monthName} `;
      },
      endHour: (date: Date) => {
        const dayName = new Intl.DateTimeFormat("fr-FR", {
          weekday: "long",
        }).format(date);
        const monthName = new Intl.DateTimeFormat("fr-FR", {
          month: "long",
        }).format(date);

        return `Heure de fin du ${dayName} ${date.getDate()} ${monthName} `;
      },
      formatDate: (date: Date) => {
        const dayName = new Intl.DateTimeFormat("fr-FR", {
          weekday: "long",
        }).format(date);
        const monthName = new Intl.DateTimeFormat("fr-FR", {
          month: "long",
        }).format(date);

        return `${dayName} ${date.getDate()} ${monthName}`;
      },
      editAthleteModal: {
        title: "Modifier l'athlète",
        name: "Nom",
        firstname: "Prénom",
        license: "Licence",
        club: "Club",
        sex: "Sexe",
        birthDate: "Date de naissance",
        weightCategory: "Catégorie de poids",
        discipline: "Discipline",
        plateauNumber: "Numéro du plateau",
        groupNumber: "Numéro du groupe",
        segmentSuffix: "Suffixe de la catégorie",
        saveDisabledNoGroup: "Veuillez sélectionner le numéro du groupe.",
        saveDisabledNoSuffix:
          "Veuillez sélectionner le suffixe de la catégorie.",
        save: "Enregistrer",
        cancel: "Annuler",
      },
      editGroupModal: {
        title: "Modifier le groupe",
        name: "Nom",
        plateauNumber: "Numéro du plateau",
        groupPosition: "Numéro du groupe",
        saveDisabledNoPosition: "Veuillez sélectionner le numéro du groupe.",
        save: "Enregistrer",
        cancel: "Annuler",
      },
      editSegmentModal: {
        title: "Modifier la catégorie",
        plateauNumber: "Numéro du plateau",
        groupNumber: "Numéro du groupe",
        segmentSuffix: "Suffixe de la catégorie",
        saveDisabledNoGroup: "Veuillez sélectionner le numéro du groupe.",
        save: "Enregistrer",
        cancel: "Annuler",
      },
      womenCategory: "Femmes",
      menCategory: "Hommes",
      categorySeparator: " & ",
      editPlateauModal: {
        title: "Modifier le plateau",
        name: "Nom",
        plateauNumber: "Numéro du plateau",
        startDate: "Date de début",
        weightInDate: "Date de pesée",
        endDate: "Date de fin",
        dateManualTooltip: "Dates modifiées manuellement",
        save: "Enregistrer",
        cancel: "Annuler",
        saveDisabledMissingDates:
          "Veuillez renseigner toutes les dates (pesée, début, fin).",
        saveDisabledInvalidPlateauNumber: (max: number) =>
          `Le numéro de plateau doit être entre 1 et ${max}.`,
        saveDisabledSameDay: "Les trois dates doivent être le même jour.",
        resetDates: "Réinitialiser les dates",
        recalcFromWeighIn: "Recalculer début et fin à partir de la pesée",
        recalcFromStart: "Recalculer pesée et fin à partir du début",
        recalcFromEnd: "Recalculer début et pesée à partir de la fin",
      },
      plateauExceedsDayEndTitle: "Dépassement de l'heure de fin de journée",
      plateauExceedsDayEndMessage:
        "Un ou plusieurs plateaux dépassent l'heure de fin de journée. Souhaitez-vous confirmer le déplacement ?",
      plateauDateExceedsDayEndTooltip: (maxDate: Date) =>
        `Une des dates dépasse l'heure de fin de journée (max. ${maxDate.getHours()}:${maxDate.getMinutes() < 10 ? "0" + maxDate.getMinutes() : maxDate.getMinutes()}).`,
      plateauDateExceedsDayStartTooltip: (minDate: Date) =>
        `Une des dates dépasse l'heure de début de journée (min. ${minDate.getHours()}:${minDate.getMinutes() < 10 ? "0" + minDate.getMinutes() : minDate.getMinutes()}).`,
      plateauDateConflictTooltip: (plateauNumbers: number[]) =>
        plateauNumbers.length === 1
          ? `Conflit avec le plateau ${plateauNumbers[0]}`
          : `Conflit avec les plateaux ${plateauNumbers
              .slice()
              .sort((a, b) => a - b)
              .join(", ")}`,
      resetDayDatesTooltip: "Réinitialiser les dates du jour",
      confirm: "Confirmer",
      addPlateauZone: "Nouveau plateau",
      addGroupZone: "Nouveau groupe",
      importFile: "Importer un fichier",
      importSettings: "Paramètres d'import",
      bodyweight: "Poids de corps",
      bestSquat: "Meilleur Squat",
      bestBench: "Meilleur Bench",
      bestDeadlift: "Meilleur Deadlift",
      bestTotal: "Meilleur Total",
      squat: "Squat",
      bench: "Bench",
      deadlift: "Deadlift",
      total: "Total",
      filterPlaceholder: "Filtrer...",
      allValues: "Tous",
      filteredCount: (filtered: number, total: number) =>
        `${filtered} / ${total}`,
      requiredFieldsMissing:
        "Veuillez remplir tous les champs obligatoires (nom, ville, dates, organisation).",
      importSettingsModal: {
        title: "Paramètres d'import",
        requiredColumns: "Colonnes obligatoires",
        optionalColumns: "Colonnes optionnelles",
        addColumn: "Ajouter une colonne",
        columnNumber: "N° colonne",
        removeColumn: "Retirer cette colonne",
        save: "Enregistrer",
        cancel: "Annuler",
        reset: "Réinitialiser",
        tooltips: {
          meetName: "Texte : nom de la compétition",
          discipline: "Code discipline : FA, DC, BP, PL",
          licence: "Numéro de licence de l'athlète",
          club: "Nom du club de l'athlète",
          sex: "Sexe de l'athlète : M ou F",
          birthDate: "Date de naissance : JJ/MM/AAAA ou AAAA-MM-JJ",
          lastname: "Nom de famille de l'athlète",
          firstname: "Prénom de l'athlète",
          bodyweight: "Poids de corps en kg (nombre décimal)",
          ligueName: "Nom de l'organisation (texte)",
          startDate: "Date de début de la compétition",
          endDate: "Date de fin de la compétition",
          lieu: "Ville de la compétition",
          squat: "Performance de nomination/qualification en kg (squat)",
          bench:
            "Performance de nomination/qualification en kg (développé couché)",
          deadlift:
            "Performance de nomination/qualification en kg (soulevé de terre)",
          total: "Performance de nomination/qualification en kg (total)",
        },
        columnLabels: {
          meetName: "Nom compétition",
          discipline: "Discipline",
          licence: "Licence",
          club: "Club",
          sex: "Sexe",
          birthDate: "Date de naissance",
          lastname: "Nom",
          firstname: "Prénom",
          bodyweight: "Poids de corps",
          ligueName: "Organisation",
          startDate: "Date de début",
          endDate: "Date de fin",
          lieu: "Ville",
          squat: "Squat",
          bench: "Bench",
          deadlift: "Deadlift",
          total: "Total",
        },
      },
      importSummaryModal: {
        title: "Récapitulatif de l'import",
        totalAthletes: "Total d'athlètes importés",
        men: "Hommes",
        women: "Femmes",
        byDiscipline: "Par discipline",
        byWeightCategory: "Par catégorie de poids",
        byAgeCategory: "Par catégorie d'âge",
        byCombination: "Par combinaison (poids + âge + discipline)",
        close: "Fermer",
        continue: "Continuer",
        unknown: "Non défini",
      },
      duplicateResolverModal: {
        title: "Doublons détectés",
        description:
          "Les athlètes suivants semblent être des doublons (même nom, prénom et date de naissance). Sélectionnez ceux que vous souhaitez supprimer.",
        keepAll: "Tout conserver",
        removeSelected: "Supprimer la sélection",
        cancel: "Annuler",
        duplicateGroup: (count: number) => `${count} occurrences`,
        selectToRemove: "Sélectionner pour supprimer",
        noDuplicates: "Aucun doublon détecté.",
      },
      createCompetition: "Créer la compétition",
      createCompetitionConfirm:
        "Le planning sera verrouillé et vous pourrez gérer les arbitres et exporter les données. Voulez-vous continuer ?",
      persistenceError:
        "Les données ne seront pas sauvegardées car la connexion au serveur est impossible.",
      saving: "Sauvegarde...",
      saved: "Sauvegardé",
      status: {
        import: "Import",
        settings: "Paramètres",
        draft: "Brouillon",
        created: "Créée",
      },
      createdPage: {
        title: "Compétition créée",
        backToDraft: "Revenir au brouillon",
        backToDraftConfirmTitle: "Revenir au brouillon ?",
        backToDraftConfirmMessage:
          "Attention : revenir au brouillon réinitialisera toutes les disponibilités et assignations d'arbitres pour cette compétition. Cette action est irréversible. Voulez-vous continuer ?",
        planningPreview: "Aperçu du planning",
        previewHint:
          "Dépliez un groupe puis une catégorie pour consulter la liste des athlètes.",
        previewEmpty: "Aucun plateau dans ce planning.",
        previewNoCategories: "Aucune catégorie dans ce groupe.",
        previewNoAthletes: "Aucun athlète dans cette catégorie.",
        previewColumns: {
          lot: "Lot",
          name: "Nom",
          licence: "Licence",
          club: "Club",
        },
        planningExports: "Exports du planning",
        refereeSection: "Gestion des arbitres",
        refereeExports: "Exports des arbitres",
        copyAvailabilityLink: "Copier le lien de disponibilité",
        linkCopied: "Lien copié dans le presse-papier",
        manageMyReferees: "Gérer mes arbitres",
        noAssignments: "Aucun arbitre assigné",
        exportPngError: "Erreur lors de l'export Image",
        assignErrorGeneric: "Erreur",
        refereeExportsPngDialogTitle: "Exports des arbitres - Image",
        defaultFileName: "planning",
        exportRefereesIncompleteTitle: "Export des arbitres",
        exportRefereesIncompleteMessage:
          "Certains plateaux n'ont pas tous les postes d'arbitres remplis. Voulez-vous quand même exporter ?",
        exportRefereesConfirmExport: "Exporter quand même",
        noPlateauxForPng: "Aucun plateau à exporter en image.",
        engagementsButton: "Engagements",
        engagementsSelectGroup: "Sélection du groupe",
        engagementsNoAthletes: "Aucun athlète dans ce groupe.",
        engagementsGroupOption: (
          plateauNum: number,
          groupNum: number,
          groupName?: string,
        ) =>
          groupName
            ? `Plateau ${plateauNum} - Groupe ${groupNum} - ${groupName}`
            : `Plateau ${plateauNum} - Groupe ${groupNum}`,
        plateauObservations: "Observations",
        plateauSecretary: "Secrétariat",
        organisationSheets: {
          sectionTitle: "Documents d'organisation",
          controlMaterial: "Contrôle matériel",
          heightFa: "Hauteur des supports FA",
          heightDc: "Hauteur des supports DC",
          tirageAuSort: "Tirage au sort",
          selectPlateaux: "Sélection des plateaux",
          print: "Imprimer / Enregistrer en PDF",
          close: "Fermer",
          expandPreview: "Ouvrir l'aperçu en grand",
          plateauTitle: (num: number, name: string) =>
            `Plateau ${num} - ${name}`,
          groupTitle: (num: number, name: string) =>
            name ? `Groupe ${num} - ${name}` : `Groupe ${num}`,
          subtitleControlMaterial: "CONTRÔLE MATÉRIEL",
          subtitleHeightFa: "HAUTEUR DE BARRE (FA)",
          subtitleHeightDc: "HAUTEUR DE BARRE (DC)",
          weighInAt: (time: string) => `Pesée à ${time}`,
          noteSection: "Note",
          noteVisible: "Afficher la note",
          tirageNoteDefault:
            "Les athlètes doivent avoir une pièce d'identité valide.",
          columns: {
            lastname: "NOM",
            firstname: "Prénom",
            remark: "Remarque",
            signature: "Signature",
            squat: "SQUAT",
            rack: "Rack (Int/Ext)",
            dc: "DC",
            cales: "CALES (O/N)",
            safetyHeight: "Haut. Sécuri.",
            num: "N°",
            nomPrenom: "NOM Prénom",
            fait: "Fait",
          },
        },
      },
      pngExportModal: {
        defaultFileName: "planning",
        title: "Export Image",
        formatSection: "Format d'image",
        formatSquare: "Carré",
        formatLandscape: "Paysage",
        formatPortrait: "Portrait",
        templateSection: "Modèle",
        templateFidele: "Fidèle",
        templateMinimal: "Minimal",
        templateCartes: "Cartes",
        templateTimeline: "Timeline",
        templateDark: "Dark",
        colorsSection: "Couleurs",
        noteSection: "Note",
        close: "Fermer",
        noteVisible: "Afficher la note",
        preview: "Aperçu",
        exportButton: "Exporter Image",
        exportError: "Erreur lors de l'export Image",
        imagePageIndicator: (current: number, total: number) =>
          `Image ${current} sur ${total}`,
        imagePrev: "Image précédente",
        imageNext: "Image suivante",
        pngNoteDefault:
          "Les athlètes qui ne seront pas au poids défini lors de leur inscription participeront en Hors Match. Cela signifie que l'athlète ne sera pas dans le match et ne sera pas classé dans cette compétition mais son résultat sera publié et valide pour avoir un niveau à la fédération (sauf TPU, voir règlement).",
        templateLabels: {
          weighIn: "Pesée",
          weighInUpper: "PESÉE",
          start: "Début",
          startUpper: "DÉBUT",
          weighInStartHeader: "PESÉE / DÉBUT",
          plateau: "Plateau",
          groups: "Groupes",
          detail: "Détail",
          group: "groupe",
          groupsPlural: "groupes",
          groupShort: "gr.",
          groupDetailPrefix: "GR",
          athleteShort: "ath.",
          athlete: "athlète",
          athletes: "athlètes",
          footerSite: "meet-manager.fr",
        },
        colorLabels: {
          headerBg: "Fond en-tête",
          titleColor: "Titre",
          noteColor: "Note",
          dayBannerBg: "Bandeau jour",
          dayBannerText: "Texte jour",
          tableBorder: "Bordure tableau",
          tableBg: "Fond tableau",
          tableText: "Texte tableau",
          footerBorder: "Bordure pied",
          footerText: "Texte pied",
          postBg: "Fond",
          postBorder: "Bordure",
          metaColor: "Métadonnées",
          noteBg: "Fond note",
          noteBorder: "Bordure note",
          noteBorderLeft: "Bordure note",
          dayLabelColor: "Label jour",
          blockBorder: "Bordure bloc",
          blockTimeBg: "Fond horaire",
          blockTimeText: "Texte horaire",
          blockTimeLabelColor: "Label horaire",
          bodyText: "Texte contenu",
          plateauText: "Nom plateau",
          groupText: "Texte groupe",
          cardBg: "Fond carte",
          cardBorder: "Bordure carte",
          cardTitleColor: "Titre carte",
          badgeBg: "Fond badge",
          badgeText: "Texte badge",
          cardTimesColor: "Horaires carte",
          cardGroupsBorder: "Bordure groupes",
          cardGroupsText: "Texte groupes",
          dayTitleBg: "Fond titre jour",
          dayTitleText: "Texte titre jour",
          dayHeadColor: "Titre jour",
          dayHeadBorder: "Bordure jour",
          timelineBorder: "Bordure timeline",
          dotBg: "Point",
          dotBorder: "Bordure point",
          timeColor: "Heure",
          itemTitleColor: "Titre élément",
          detailColor: "Détail",
          gradientStart: "Dégradé (haut)",
          gradientEnd: "Dégradé (bas)",
          titleShadow: "Ombre titre",
          noteBorderLeft2: "Bordure note",
          blockBg: "Fond bloc",
          blockTitleColor: "Titre bloc",
          blockTimeColor: "Heure bloc",
          catText: "Texte catégorie",
        },
      },
      refereesPngExportModal: {
        defaultFileName: "planning",
        fileNameSuffix: "-arbitres",
        title: "Export Image - Arbitres",
        formatSection: "Format d'image",
        formatSquare: "Carré",
        formatLandscape: "Paysage",
        formatPortrait: "Portrait",
        templateSection: "Modèle",
        templateFidele: "Fidèle",
        templateMinimal: "Minimal",
        templateCartes: "Cartes",
        templateTimeline: "Timeline",
        templateDark: "Dark",
        colorsSection: "Couleurs",
        close: "Fermer",
        preview: "Aperçu",
        exportButton: "Exporter Image",
        exportError: "Erreur lors de l'export Image",
        imagePageIndicator: (current: number, total: number) =>
          `Image ${current} sur ${total}`,
        imagePrev: "Image précédente",
        imageNext: "Image suivante",
        templateLabels: {
          referees: "Arbitres",
          weighIn: "Pesée",
          start: "Début",
          end: "Fin",
          plateau: "Plateau",
          observations: "Observations",
          secretary: "Secrétariat",
          footerSite: "meet-manager.fr",
          headerSuffix: "Arbitrage",
        },
        colorLabels: {
          headerBg: "Fond en-tête",
          titleColor: "Titre",
          dayBannerBg: "Bandeau jour",
          dayBannerText: "Texte jour",
          tableBorder: "Bordure tableau",
          tableBg: "Fond tableau",
          tableText: "Texte tableau",
          roleColor: "Rôles",
          footerBorder: "Bordure pied",
          footerText: "Texte pied",
          postBg: "Fond",
          postBorder: "Bordure",
          metaColor: "Métadonnées",
          dayLabelColor: "Label jour",
          blockBorder: "Bordure bloc",
          blockTimeBg: "Fond horaire",
          blockTimeText: "Texte horaire",
          blockTimeLabelColor: "Label horaire",
          bodyText: "Texte contenu",
          plateauText: "Nom plateau",
          cardBg: "Fond carte",
          cardBorder: "Bordure carte",
          cardTitleColor: "Titre carte",
          cardTimesColor: "Horaires carte",
          dayTitleBg: "Fond titre jour",
          dayTitleText: "Texte titre jour",
          dayHeadColor: "Titre jour",
          dayHeadBorder: "Bordure jour",
          timelineBorder: "Bordure timeline",
          dotBg: "Point",
          dotBorder: "Bordure point",
          timeColor: "Heure",
          itemTitleColor: "Titre élément",
          detailColor: "Détail",
          gradientStart: "Dégradé (haut)",
          gradientEnd: "Dégradé (bas)",
          titleShadow: "Ombre titre",
          blockBg: "Fond bloc",
          blockTitleColor: "Titre bloc",
          blockTimeColor: "Heure bloc",
        },
      },
      exports: {
        csv: "CSV",
        excel: "Excel",
        png: "Image",
        configureColumns: "Paramètres d'exports",
        resetColumns: "Réinitialiser",
        separator: "Séparateur CSV",
        primaryColor: "Couleur principale",
        defaultColumns: "Colonnes par défaut",
        additionalColumns: "Colonnes supplémentaires",
        dragToReorder: "Glisser pour réordonner",
        exportModalTitle: "Paramètres d'export",
        save: "Enregistrer",
        cancel: "Annuler",
      },
      refereeAssignment: {
        weightIn: "Pesée",
        materialCheck: "Matériel",
        leftReferee: "Arbitre gauche",
        chiefReferee: "Arbitre central",
        rightReferee: "Arbitre droit",
        jury: "Jury",
        addReferee: "Ajouter un arbitre",
        selectReferee: "Sélectionner un arbitre",
        noAvailableReferees: "Aucun arbitre disponible",
        unavailableWarning:
          "Cet arbitre a modifié sa disponibilité et n'est plus disponible sur ce plateau",
        roleAlreadyAssigned: "Ce rôle est déjà assigné sur ce plateau",
        exclusiveRoleConflict:
          "Cet arbitre a déjà un rôle exclusif sur ce plateau",
      },
    },
    myPlannings: {
      createError:
        "Le planning n’a pas pu être créé. Vérifiez votre organisation et réessayez.",
      loadError: "Les compétitions ou plannings n’ont pas pu être chargés.",
      retry: "Réessayer",
      title: "Mes plannings",
      createPlanning: "Créer une compétition",
      empty: "Vous n'avez créé aucun planning",
      noResults: "Aucun planning ne correspond à votre recherche",
      deletePlanning: "Supprimer le planning",
      deletePlanningConfirm:
        "Êtes-vous sûr de vouloir supprimer ce planning ? Cette action est irréversible.",
      athleteCount: (count: number) =>
        count === 1 ? "1 athlète" : `${count} athlètes`,
      plateauCount: (count: number) =>
        count === 1 ? "1 plateau" : `${count} plateaux`,
      allRefereeRolesAssigned: "Arbitres assignés",
      refereeRolesIncomplete: "Arbitres non assignés",
      cityUndefined: "Non définie",
    },
    referees: {
      title: "Mes arbitres",
      addReferee: "Ajouter un arbitre",
      importReferees: "Importer",
      noReferees: "Aucun arbitre",
      firstname: "Prénom",
      lastname: "Nom",
      rank: "Grade",
      rankYear: "Année de grade",
      club: "Club",
      organisation: "Organisation",
      privateLabel: "Privé",
      readOnly: "Lecture seule",
      readOnlyHint:
        "Les arbitres de l'organisation sont en lecture seule. Vous pouvez uniquement modifier vos arbitres privés.",
      save: "Enregistrer",
      cancel: "Annuler",
      delete: "Supprimer",
      editTitle: "Modifier l'arbitre",
      createTitle: "Nouvel arbitre",
      deleteConfirm:
        "Êtes-vous sûr de vouloir supprimer cet arbitre ? Cette action est irréversible.",
      importModal: {
        title: "Import d'arbitres (Excel)",
        selectFile: "Sélectionner un fichier",
        selectOrganisation: "Sélectionner l'organisation",
        preview: "Aperçu",
        import: "Importer",
        cancel: "Annuler",
        duplicatesSkipped: (count: number) => `${count} doublon(s) ignoré(s)`,
        created: (count: number) => `${count} arbitre(s) créé(s)`,
        mappingInfo: "Format : A=Nom, B=Prénom, C=Grade, D=Année, E=Club",
      },
    },
    refereeAvailability: {
      title: "Disponibilité arbitre",
      subtitle: "Indiquez votre disponibilité pour chaque plateau",
      searchPlaceholder: "Rechercher votre nom...",
      selectYourName: "Sélectionnez votre nom",
      available: "Disponible",
      unavailable: "Indisponible",
      submit: "Valider",
      submitted: "Vos disponibilités ont été enregistrées",
      weightIn: "Pesée",
      start: "Début",
      end: "Fin",
      previousResponsesLoaded: "Vos réponses précédentes ont été pré-remplies",
    },
  },
  controlRoom: {
    title: "Régie",
    noCards:
      "Aucun événement disponible. Chargez des affichages avec des événements de régie sur vos écrans ou widgets.",
    selectMeetLabel: "Compétition live",
    loadingLiveMeets: "Chargement des compétitions live...",
    noLiveMeets: "Aucune compétition live disponible pour ce compte.",
    hubDisconnected: "Hub déconnecté - le déclenchement est désactivé.",
    triggerButton: "Déclencher",
    targets: "Cibles",
    shortcutLabel: "Raccourci",
    openButton: "Régie",
    backButton: "Retour",
    landing: {
      referee: "Sélection des arbitres",
      widgets: "Widgets",
      displays: "Écrans",
      controlRoom: "Régie",
    },
  },
  live: {
    admin: {
      accessControl: "Accès Direct",
      accessTooltip: "Contrôle l'accès au système de direct pour cette licence",
      enabled: "Activé",
      disabled: "Désactivé",
      accessUpdated: (licenseName: string, status: string) =>
        `Accès direct mis à jour pour ${licenseName}: ${status}`,
      accessUpdateError: "Erreur lors de la mise à jour de l'accès direct",
    },
  },
  planning: {
    admin: {
      accessControl: "Accès Planning",
      accessTooltip:
        "Contrôle l'accès aux fonctionnalités planning pour cette licence",
      enabled: "Activé",
      disabled: "Désactivé",
      accessUpdated: (licenseName: string, status: string) =>
        `Accès planning mis à jour pour ${licenseName}: ${status}`,
      accessUpdateError: "Erreur lors de la mise à jour de l'accès planning",
    },
  },
  backup: {
    cleanupBackups: "Nettoyer les sauvegardes",
    beforeRestore: "Avant restauration",
    restore: "Restaurer",
    restoreSuccess: "Sauvegarde restaurée avec succès",
    restoreError: "Erreur lors de la restauration",
    restoreRefreshError:
      "La sauvegarde a été restaurée, mais l’affichage n’a pas pu être actualisé. Rouvrez la compétition.",
    confirmRestoreMessage:
      "La compétition correspondante sera remplacée par cette sauvegarde. Son état actuel sera sauvegardé automatiquement avant le remplacement pour pouvoir revenir en arrière. Si elle n’existe pas sur cet ordinateur, elle sera ajoutée. Les schémas des disciplines personnalisées doivent être synchronisés.",

    saving: "Sauvegarde en cours...",
    saveNow: "Sauvegarder maintenant",
    lastBackupInstant: "Dernière sauvegarde à l'instant",
    lastBackupMinutes: (minutes: number) =>
      `Dernière sauvegarde il y a ${minutes}min`,
    lastBackupHours: (hours: number) => `Dernière sauvegarde il y a ${hours}h`,
    lastBackupDays: (days: number) => `Dernière sauvegarde il y a ${days}j`,
    noBackup: "Aucune sauvegarde",
    noAccessToServer: "Aucun accès au serveur",
    success: "Sauvegarde créée avec succès !",
    error: "Erreur lors de la création du backup",
    noActiveLicense: "Aucune licence active trouvée",
    backupError: "Erreur lors de la création du backup",
    manager: "Gestion des Backups",
    create: "Créer Backup",
    loading: "Chargement des backups...",
    noBackupsAvailable: "Aucun backup disponible",
    createFirstBackup: "Créez votre premier backup pour commencer",
    noMeetSelected: "Aucun meet sélectionné",
    selectMeetFirst: "Sélectionnez un meet pour accéder aux backups",
    deleteSuccess: "Backup supprimé avec succès",
    deleteError: "Erreur lors de la suppression",
    noAccess: "Votre licence ne dispose pas d'accès au système de backup",
    accessDenied: "Accès au backup refusé",
    contactAdmin:
      "Contactez votre administrateur pour activer l'accès au backup",
    admin: {
      accessControl: "Accès Backup",
      accessTooltip:
        "Contrôle l'accès au système de sauvegarde automatique pour cette licence",
      enabled: "Activé",
      disabled: "Désactivé",
      accessUpdated: (licenseName: string, status: string) =>
        `Accès backup mis à jour pour ${licenseName}: ${status}`,
      accessUpdateError: "Erreur lors de la mise à jour de l'accès backup",
    },
    confirmDelete: "Confirmer la suppression",
    confirmDeleteMessage: "Êtes-vous sûr de vouloir supprimer le backup",
    confirmDeleteWarning: "Cette action est irréversible.",
    cancel: "Annuler",
    delete: "Supprimer",
    athletes: "athlètes",
    groups: "groupes",
    createdOn: "Créé le",
  },
  docs: {
    displayEditor: {
      appName: "Meet Manager Docs",
      eyebrow: "Documentation utilisateur",
      title: "Éditeur d'affichage",
      subtitle:
        "Guide complet pour créer, importer, thème, éditer et automatiser les affichages personnalisés de Meet Manager.",
      searchLabel: "Rechercher",
      searchPlaceholder: "Élément, propriété, comportement…",
      noSearchResult: "Aucun résultat ne correspond à la recherche.",
      searchModalTitle: "Résultats",
      searchModalHint:
        "Saisis un mot pour chercher dans les titres et le contenu du guide.",
      searchModalClose: "Fermer la recherche",
      searchModalNavigate: "Ouvrir",
      onThisPage: "Sur cette page",
      screenshotFallback: "Capture à ajouter",
      screenshotMissing:
        "La capture n'est pas encore disponible dans les assets de documentation.",
      tableColumns: {
        item: "Élément",
        category: "Catégorie",
        availability: "Disponible quand",
        purpose: "Utilisation",
        details: "Détails",
      },
      nav: {
        getStarted: "Pour commencer",
        editor: "Éditeur",
        behavior: "Comportement",
      },
      sections: {
        intro: {
          title: "Vue d'ensemble",
          summary:
            "Ce guide couvre l'éditeur d'affichage : créer des affichages, les composer sur le canvas, puis les automatiser avec des comportements.",
        },
        createLayout: {
          title: "Créer un affichage",
          summary:
            "Depuis Mes affichages, crée un écran ou un widget avec un nom, un type, une taille de canvas et un fond.",
        },
        importExport: {
          title: "Importer et réutiliser",
          summary:
            "Tu peux importer un fichier d'affichage exporté, dupliquer des affichages et les réutiliser entre thèmes ou compétitions.",
        },
        themes: {
          title: "Thèmes et attribution",
          summary:
            "Un thème associe chaque cible d'écran ou de widget à l'affichage personnalisé qui doit y apparaître.",
        },
        previewEdition: {
          title: "Aperçu et édition",
          summary:
            "Le canvas central sert à composer l'affichage, sélectionner les éléments, zoomer, les déplacer et prévisualiser avec les données de compétition.",
        },
        displayPreview: {
          title: "Aperçu compétition",
          summary:
            "Ouvre un aperçu plein écran depuis l’éditeur pour parcourir une compétition simulée : frise, lecture/pause, paramètres du scénario et panneau flottant de régie locale.",
        },
        layers: {
          title: "Liste des éléments",
          summary:
            "Le panneau de gauche montre tout ce qui est placé sur l'affichage. Les sous-parties ci-dessous expliquent chaque type d'élément ajoutable depuis la barre d'outils.",
        },
        elementText: {
          title: "Texte",
          summary:
            "Afficher un libellé fixe, une valeur live de la compétition, ou un mélange des deux sur une même ligne.",
        },
        elementImage: {
          title: "Image",
          summary:
            "Afficher une image téléversée, ou la faire changer via les données de compétition ou un comportement.",
        },
        elementVideo: {
          title: "Vidéo",
          summary:
            "Lire une vidéo sur un écran d'attente ou public, avec les options Muet et Boucle.",
        },
        elementShape: {
          title: "Forme",
          summary:
            "Dessiner des fonds, cadres, séparateurs et repères décoratifs derrière ou autour des autres éléments.",
        },
        elementContainer: {
          title: "Conteneur",
          summary:
            "Regrouper plusieurs éléments pour les déplacer, les masquer ou les animer ensemble. Préférez Flex au quotidien ; Absolu surtout pour animer des positions libres.",
        },
        elementLayoutList: {
          title: "Liste",
          summary:
            "Répéter le même design de ligne pour chaque athlète (ou autre liste), avec aperçu, filtres, tri et animations d'apparition/disparition.",
        },
        elementBarLoader: {
          title: "Chargeur de barre",
          summary:
            "Afficher les disques chargés pour un poids en kilogrammes ou livres, avec plusieurs modes et styles par disque ou libellé.",
        },
        elementQrCode: {
          title: "QR code",
          summary:
            "Afficher un code scannable pour un lien ou un texte, dimensionné par le cadre de l'élément et coloré dans Style.",
        },
        properties: {
          title: "Propriétés",
          summary:
            "Le panneau de droite montre les réglages partagés, ceux propres à l'élément sélectionné, et les champs pilotés par un comportement.",
        },
        mockData: {
          title: "Données mock",
          summary:
            "Les données mock permettent de modifier des valeurs de test pour vérifier la Liaison de données sans compétition live.",
        },
        toolbar: {
          title: "Barre d'outils",
          summary:
            "La barre d'outils regroupe création, aperçu, comportement, animation, copier-coller, groupement, ordre d'empilement et suppression.",
        },
        behaviorInterface: {
          title: "Interface du comportement",
          summary:
            "Un comportement est un graphe visuel : les événements démarrent une séquence, les variables fournissent des valeurs, les contrôles choisissent un chemin, et les actions changent ce qui s'affiche.",
        },
        sceneBehavior: {
          title: "Comportement de scène",
          summary:
            "Le comportement de scène est la bibliothèque partagée d'animations, d'événements, de fonctions et de variables réutilisable par tous les comportements d'éléments de l'affichage.",
        },
        sceneAnimations: {
          title: "Animations de scène",
          summary:
            "Les animations réutilisables se créent dans le comportement de scène, puis se démarrent depuis un élément avec Jouer l'animation.",
        },
        sceneFunctions: {
          title: "Fonctions de scène",
          summary:
            "Une fonction regroupe une logique réutilisable avec des ports d'entrée et de sortie configurables (nom et type) que plusieurs comportements peuvent appeler.",
        },
        sceneEvents: {
          title: "Événements de scène",
          summary:
            "Un événement custom de scène devient disponible dans les comportements d'éléments une fois que son graphe déclencheur atteint Sortie d'événement.",
        },
        sceneVariables: {
          title: "Variables de scène",
          summary:
            "Une variable de scène stocke ou calcule une valeur partagée ; tu peux ajouter des entrées typées et la mettre à jour pendant l'affichage (par ex. via des événements) au fil de la compétition.",
        },
        behaviorNodes: {
          title: "Tous les nœuds disponibles",
          summary:
            "Cette liste regroupe les blocs de comportement par type (événements, variables, contrôles, actions, opérateurs). Dans chaque groupe, les nœuds sont triés par type de valeur - les mêmes pastilles colorées que dans l’éditeur (par exemple le vert pour les nombres).",
        },
        controlRoom: {
          title: "Régie",
          summary:
            "Les événements de régie deviennent des actions opérateur déclenchables depuis la page de régie ou par raccourci clavier.",
        },
      },
      screenshots: {
        layoutsList: {
          alt: "Liste des affichages personnalisés",
          caption:
            "Mes affichages : créer, importer, gérer les thèmes, puis ouvrir un écran ou un widget déjà associé à une cible.",
        },
        createLayout: {
          alt: "Création d'un affichage personnalisé",
          caption:
            "Boîte de dialogue de création : nom, type (écran ou widget), thème optionnel, taille du canvas (par exemple 1920×1080) et couleur de fond.",
        },
        importJson: {
          alt: "Action d'import d'affichage",
          caption:
            "Actions d'en-tête : Importer un affichage charge un fichier d'affichage exporté et ouvre la boîte de création déjà remplie.",
        },
        themes: {
          alt: "Gestion des thèmes d'affichage",
          caption:
            "Mes thèmes : créer un thème, puis y rattacher des affichages aux cibles d'écran ou de widget.",
        },
        editorOverview: {
          alt: "Vue complète de l'éditeur d'affichage",
          caption:
            "Éditeur : liste des éléments à gauche, canvas au centre, propriétés à droite, barre d'outils au-dessus.",
        },
        displayPreviewOverview: {
          alt: "Aperçu compétition avec les deux panneaux flottants",
          caption:
            "Aperçu compétition : l’affichage remplit l’écran. Deux panneaux flottants restent au-dessus - paramètres et frise en bas, régie locale en haut à droite.",
        },
        layers: {
          alt: "Panneau de liste des éléments",
          caption:
            "Composants de l'affichage : recherche et arborescence (conteneurs, textes, lumières…) pour sélectionner hors canvas.",
        },
        properties: {
          alt: "Panneau de propriétés",
          caption:
            "Propriétés de l'élément sélectionné : position, taille, rotation, libellé, mise en page du conteneur et styles.",
        },
        mockData: {
          alt: "Panneau des données mock",
          caption:
            "Sources mock : ouvrir Athlète actuel, timers, listes et autres valeurs de compétition pour tester sans meet live.",
        },
        toolbar: {
          alt: "Barre d'outils de l'éditeur",
          caption:
            "Barre d'outils : outils de création, aperçu, données mock, comportement de scène/élément, copier-coller et ordre d'empilement.",
        },
        behavior: {
          alt: "Canvas de comportement d'élément",
          caption:
            "Comportement d'élément : palette à gauche, graphe au centre, bibliothèque de scène à droite. Panoramique clic molette ; zoom Ctrl/Cmd + molette.",
        },
        sceneBehavior: {
          alt: "Hub du comportement de scène",
          caption:
            "Hub de scène : Animations, Événements, Fonctions et Variables partagés par tous les éléments de l'affichage.",
        },
        sceneAnimation: {
          alt: "Graphe d'animation de scène",
          caption:
            "Graphe d'animation : Début d'animation → keyframe(s) → Fin d'animation. Seules les propriétés qui diffèrent entre les poses sont animées.",
        },
        sceneFunction: {
          alt: "Graphe de fonction de scène",
          caption:
            "Graphe de fonction : Début de fonction (ajouter des entrées avec nom et type) → logique → Fin de fonction (ajouter des sorties avec nom et type). Créable aussi via le menu contextuel du comportement.",
        },
        sceneEvent: {
          alt: "Graphe déclencheur d'événement de scène",
          caption:
            "Graphe déclencheur : les flux Au chargement / Au changement doivent atteindre Sortie d'événement avant que d'autres comportements puissent écouter l'événement custom.",
        },
        sceneVariable: {
          alt: "Graphe de variable de scène",
          caption:
            "Graphe de variable centré sur Fin de variable. Le Début de variable optionnel permet d'ajouter des entrées nommées et typées ; Définir la variable peut mettre à jour la valeur pendant l'affichage.",
        },
        controlRoom: {
          alt: "Page régie",
          caption:
            "Régie : sélectionne une compétition live pour déclencher les actions publiées par les affichages et widgets chargés.",
        },
      },
      blocks: {
        learn: "À apprendre",
        procedure: "Procédure",
        shortcuts: "Raccourcis et gestes",
        reference: "Référence",
        propertyReferenceTitle: "Familles de propriétés",
        graphicNodesTitle: "Éléments graphiques",
        styleFieldsTitle: "Champs de style",
        sourceOfTruth:
          "Ce guide suit ce que tu vois dans l'éditeur d'affichage : barre d'outils, canvas, liste des éléments, propriétés, données mock et comportement.",
        sectionDetails: {
          intro: [
            "L'éditeur d'affichage construit ce que verront les écrans et widgets pendant une compétition. Un affichage contient une taille de canvas, un fond, des éléments graphiques, des liaisons de données et, si besoin, des comportements qui réagissent aux données de compétition ou aux actions de régie.",
            "Avance étape par étape : crée ou importe un affichage, attribue-le à un écran ou un widget via un thème, puis compose le visuel. Ajoute les comportements ensuite pour tout ce qui doit changer automatiquement pendant la compétition.",
          ],
          createLayout: [
            "Créer un affichage démarre un nouveau fichier de travail. Choisis Écran pour un écran complet, ou Widget pour une zone réutilisable (athlète actuel, chronomètre, lumières, etc.).",
            "La taille du canvas est la zone de travail. Place les éléments avec position, taille et ordre d'empilement dans cette zone : choisis donc des dimensions proches de la destination réelle avant de composer.",
          ],
          importExport: [
            "L'import restaure un affichage existant avec sa scène, ses dimensions et son fond. Utile pour partager une base entre compétitions ou repartir d'un affichage qui fonctionne déjà.",
            "Après l'import, vérifie les Liaisons de données (sources connues), les fichiers média, et les éléments de scène (animations, événements, fonctions, variables) que les comportements peuvent appeler.",
          ],
          themes: [
            "Un thème, ce n'est pas seulement des couleurs : il indique aussi quel affichage ou widget personnalisé apparaît sur chaque cible.",
            "Choisis un affichage compatible avec la cible. Les écrans couvrent les sorties principales ; les widgets couvrent des zones comme l'athlète actuel, les feux ou le chronomètre.",
          ],
          previewEdition: [
            "Le canvas est l'endroit où tu composes. Tu vois le rendu réel, plus des poignées et des guides pour sélectionner, déplacer, redimensionner et faire pivoter les éléments.",
            "L'aperçu montre comment l'affichage réagit aux données de compétition. Quand une donnée change, les liaisons se mettent à jour et les comportements peuvent lancer des actions - teste avant le live.",
            "Utilise les raccourcis et gestes ci-dessous pour te déplacer sur le canvas et éditer les éléments sans quitter la souris ou le clavier.",
          ],
          displayPreview: [
            "L’aperçu compétition ouvre l'affichage en plein écran avec des frames de compétition simulées. Sert à vérifier liaisons, transitions de listes et actions de régie avant d’assigner l'affichage à une cible live.",
            "Deux panneaux flottants restent disponibles : la barre du bas pour les paramètres du scénario, les couleurs du thème, lecture/pause et la frise ; le panneau en haut à droite pour les actions de régie locales publiées par cet affichage.",
            "Tu peux masquer chaque panneau flottant et le rappeler avec le bouton flottant. Avancer dans les frames met à jour l’état simulé pour que l’affichage réagisse comme en compétition.",
          ],
          layers: [
            "La liste des éléments montre la structure de l'affichage. Elle sert quand des éléments se superposent ou sont difficiles à sélectionner sur le canvas.",
            "L'ordre de la liste correspond à ce qui apparaît devant. Les conteneurs peuvent contenir d'autres éléments, et les listes montrent le design de ligne pendant l'édition.",
            "Les sous-parties sous Liste des éléments expliquent chaque type : quand l'utiliser, quels réglages comptent dans Propriétés, et quels outils de comportement lui sont propres.",
          ],
          elementText: [
            "Ajoute Texte depuis la barre d'outils pour un nom, un club, un poids, un record ou tout libellé à lire pendant la compétition.",
            "Dans Propriétés, construis le contenu en parties successives : texte simple et/ou Liaison de données (Source + champ). Les parties sont réunies dans l'ordre, ce qui permet de mélanger mots fixes et valeurs live.",
            "Réglages utiles : Largeur (Fixe ou Adaptatif), police, taille, graisse, alignement, couleur et ombre de texte, plus position, taille, rotation et Visibilité.",
            "Ouvre le comportement de l'élément quand le libellé doit changer pendant la compétition (masquer une ligne, changer de couleur, changer la valeur liée). Relie de préférence les données de compétition pour que le texte se mette à jour dès qu'elles changent.",
          ],
          elementImage: [
            "Ajoute Image depuis la barre d'outils, puis choisis un fichier sur ton ordinateur. Meet Manager le conserve pour cet affichage afin de le réutiliser sur les écrans et widgets.",
            "Dans Propriétés tu règles l'image, la taille et le Style (opacité, filtre, bordure, ombre, Visibilité). Tu peux aussi changer l'image plus tard via une Liaison de données ou un comportement.",
            "Les images sont préparées à l'avance pour éviter un flash vide au moment où tu les affiches.",
            "Comportements typiques : afficher un badge uniquement pour un record, faire apparaître une image, ou changer la Visibilité quand une condition devient vraie.",
          ],
          elementVideo: [
            "Ajoute Vidéo depuis la barre d'outils et choisis un fichier à téléverser, comme pour une image.",
            "Réglages spécifiques : Muet et Boucle. Sur les écrans d'attente publics, préfère une vidéo muette en boucle pour un démarrage fiable.",
            "Garde des clips raisonnablement courts pour ne pas alourdir les widgets distants.",
            "Les comportements montrent ou masquent surtout la vidéo, ou changent son style. Teste Muet et Boucle en aperçu avant d'assigner l'affichage à un écran live.",
          ],
          elementShape: [
            "Ajoute une Forme depuis le menu de la barre d'outils : rectangle, carré, ellipse, ovale, ligne, triangles, trapèze, parallélogramme, polygones ou étoile.",
            "Utilise les formes comme fonds, cadres, séparateurs ou badges. Style-les avec fond, bordure, opacité, ombre et inclinaison dans Propriétés.",
            "Les formes ne se relient pas seules aux données de compétition. Associe-les à un Texte ou un Conteneur pour un panneau libellé.",
            "Les comportements changent souvent la Visibilité, la couleur ou l'opacité. Les conteneurs en Absolu accueillent souvent des formes qui bougent ensemble dans une animation.",
          ],
          elementContainer: [
            "Un Conteneur regroupe des éléments pour les déplacer, les masquer ou les animer d'un bloc. Crée-le depuis la barre d'outils, ou sélectionne plusieurs éléments puis utilise Grouper.",
            "Mise en page Absolu : chaque enfant garde sa position libre sur le canvas. Préfère Absolu pour animer des positions ou composer librement. C'est puissant pour le mouvement, mais des Absolu imbriqués peuvent paraître moins stables si tu attends une interface compacte qui se réorganise seule.",
            "Mise en page Flex : les enfants suivent un flux (Direction flex, Espacement, Justification, Alignement des éléments). Utilise la position Relative pour empiler naturellement, et Absolu seulement pour des surcouches dans le conteneur Flex. Largeur et Hauteur peuvent être Fixe ou Adaptatif.",
            "Règle pratique : construis l'interface stable en Flex ; passe en Absolu surtout pour une animation libre. Si tu changes un conteneur Flex en Absolu, ses enfants directs deviennent librement positionnés.",
            "Un comportement sur le conteneur peut masquer tout le groupe ou jouer une animation de scène ; chaque enfant peut garder son propre comportement.",
          ],
          elementLayoutList: [
            "Ajoute Liste depuis la barre d'outils. Par défaut elle montre les athlètes : le même design de ligne est répété pour chaque personne.",
            "Le mode Édition permet de composer la ligne par défaut (et d'éventuelles variantes) dans la liste des éléments. Le mode Aperçu montre le rendu avec les données mock ou live, avec Nombre maximum et Direction de la liste appliqués.",
            "Réglages importants : Source (quelle liste), Direction de la liste, Nombre maximum, Identifiant (un champ unique comme la licence), options de Transition, et variantes de ligne si certaines lignes doivent différer.",
            "Renseigne Identifiant pour animer l'apparition et la disparition des lignes. Sans lui, ces animations sont peu fiables.",
            "Sur le comportement de la liste tu peux Filtrer ou Trier les lignes visibles, et Créer une variante de ligne pour des designs conditionnels. Dans une ligne tu disposes de Ligne courante, Indice et Comparateur pour un tri avancé.",
            "Dans une ligne, Entrée dans la liste et Sortie de la liste démarrent les animations d'apparition/disparition. Préfère Jouer l'animation avec une animation de scène pour un rendu soigné.",
          ],
          elementBarLoader: [
            "Ajoute Chargeur de barre depuis la barre d'outils. Définis ou lie Poids total (et Poids de barre / Poids des colliers si besoin) pour afficher les bons disques en KG ou LBS.",
            "Le mode Complet montre la pile classique, Réduit une rangée compacte, et Barre des blocs rectangulaires. Unité bascule kilogrammes ou livres. Les disques lourds optionnels restent désactivés tant que tu ne les actives pas.",
            "En Réduit ou Barre, Largeur des disques peut être Fixe ou Variable, et Alignement des disques place la charge. Variable suit les disques chargés et empêche d'étirer le chargeur à la main ; Fixe réserve toute la largeur pour que l'alignement ait de la place.",
            "Style les disques et libellés globalement (style global), puis surcharge un poids de disque si besoin. Le redimensionnement sur le canvas garde une empreinte cohérente.",
            "En comportement, Poids total et Poids de barre changent la charge. Les actions de style peuvent Cibler un Disque ou un Libellé pour un look temporaire pendant la compétition ; ces changements temporaires ne deviennent pas des valeurs permanentes dans Propriétés.",
          ],
          elementQrCode: [
            "Ajoute un QR code depuis la barre d'outils. Dans Propriétés, définis la valeur à encoder (lien ou texte), ou change-la plus tard depuis un comportement (Source / liaison).",
            "Le code remplit le plus petit côté du cadre. Couleur stylise les points ; Couleur de fond la zone vide ; Visibilité et opacité fonctionnent comme pour les autres éléments.",
            "Utilise-le pour des liens vers widgets, écrans publics ou pages externes. Vérifie le scan avec les mêmes données mock ou live qu'en compétition.",
            "Comportements typiques : changer la valeur encodée, ou montrer/masquer le code quand une condition devient vraie.",
          ],
          properties: [
            "Le panneau de propriétés s'adapte à l'élément sélectionné. Texte, vidéo, QR code et liste n'affichent pas les mêmes champs, mais partagent tous position, taille, libellé et style de base.",
            "Quand une propriété est pilotée par un comportement, modifie-la dans le graphe plutôt qu'en champ manuel. Ouvre le comportement de l'élément pour voir quelle action change la valeur.",
          ],
          mockData: [
            "Les données mock remplacent temporairement les valeurs de compétition dans l'éditeur. Elles ne changent pas le fichier d'affichage : elles permettent de tester Liaison de données, conditions et comportements en sécurité.",
            "Utile pour les listes, les variantes de ligne et les écrans qui dépendent de l'athlète actuel ou du chronomètre. Change les données de test pour vérifier les valeurs vides, le réordonnancement ou les mises à jour du timer.",
          ],
          toolbar: [
            "La barre d'outils regroupe les actions de tout l'éditeur. Les outils de création ajoutent des éléments ; les outils d'édition agissent sur la sélection ; aperçu et comportement ouvrent des modes spécialisés.",
            "Travaille comme dans un éditeur graphique : sélectionne d'abord, puis utilise l'action. Certains boutons restent désactivés tant que le contexte ne convient pas (par exemple Grouper demande une sélection ; Comportement demande un élément sélectionné).",
          ],
          behaviorInterface: [
            "Un comportement est un graphe orienté. Un événement démarre la séquence, des contrôles décident quand continuer, des variables et opérateurs calculent des valeurs, puis des actions mettent à jour l'élément, la liste, une animation ou une variable de scène.",
            "Lis le graphe de gauche à droite. Les connexions de flux (flèches) fixent l'ordre des étapes ; les connexions de valeur passent une valeur typée (nombre, texte, oui/non, etc.). Panoramique au clic molette ; zoom avec Ctrl/Cmd + molette.",
          ],
          sceneBehavior: [
            "Le comportement de scène n'est pas lié à un seul élément du canvas : c'est la bibliothèque partagée d'animations, d'événements custom, de fonctions et de variables pour tout l'affichage.",
            "Ouvre-le via Ouvrir le comportement de scène dans la barre d'outils. Tu arrives sur un hub à quatre cartes ; chacune ouvre une liste, puis un graphe de détail pour une entrée.",
            "Les comportements d'éléments peuvent réutiliser ces entrées (Jouer l'animation, écouter un événement custom, appeler une fonction, lire ou définir une variable) sans reconstruire le même graphe partout.",
          ],
          sceneAnimations: [
            "Une animation de scène est réutilisable. Elle décrit une suite de poses et peut être jouée depuis plusieurs comportements d'éléments sans recopier le même graphe sur chaque élément.",
            "Le graphe commence par Début d'animation, continue avec une ou plusieurs keyframes, et doit se terminer par Fin d'animation. Le début porte le nom ; la fin clôt la chaîne pour que Jouer l'animation puisse la lancer.",
            "Tu peux aussi capturer des poses depuis la barre d'outils d'affichage (Créer une animation / Ajouter une keyframe / Enregistrer) au lieu de construire le graphe à la main.",
          ],
          sceneFunctions: [
            "Une fonction de scène regroupe une logique. Elle reçoit des valeurs sur Début de fonction, exécute un graphe interne et renvoie des résultats sur Fin de fonction.",
            "Sur Début de fonction, tu peux ajouter ou retirer des ports d'entrée et définir le nom et le type de chaque port. Sur Fin de fonction, tu fais de même pour les ports de sortie. Si tu changes les ports, chaque Appeler la fonction qui utilise cette fonction doit rester compatible.",
            "Crée une fonction depuis la liste du hub de scène, ou extrais une sélection en fonction via le menu contextuel du canvas comportement.",
          ],
          sceneEvents: [
            "Un événement de scène est un déclencheur personnalisé défini dans le comportement de scène. Les comportements d'éléments peuvent l'écouter avec Événement de scène personnalisé.",
            "Le graphe déclencheur doit atteindre Sortie d'événement. Sans ce bloc de fin, le graphe peut exister mais les autres comportements ne peuvent pas réagir à l'événement.",
            "Construis le déclencheur avec Au chargement / Au changement et des contrôles, puis termine sur Sortie d'événement pour que les écouteurs démarrent leurs propres séquences.",
          ],
          sceneVariables: [
            "Une variable de scène stocke ou calcule une valeur partagée. Plusieurs éléments peuvent la lire ou la mettre à jour avec Définir la variable pendant l'affichage.",
            "Le graphe s'articule autour de Fin de variable (le résultat partagé). Si la variable a besoin d'entrées, Début de variable apparaît : tu peux ajouter ou retirer des ports d'entrée et définir le nom et le type de chaque port.",
            "Tu peux redéfinir la variable pendant que l'affichage tourne - par exemple depuis un événement Au changement ou Régie avec Définir la variable - pour conserver des valeurs différentes au fil de la compétition, sans modifier le fichier d'affichage.",
            "Crée une variable depuis le hub de scène, ou extrais une sélection de valeur en variable via le menu contextuel du canvas comportement.",
          ],
          behaviorNodes: [
            "Les blocs disponibles dépendent du contexte. Un comportement d'élément, une ligne de liste, un événement de scène, une fonction ou une variable n'offrent pas exactement les mêmes sources et actions.",
            "Les tableaux sont regroupés par section de la palette. Dans chaque section, les lignes sont triées par type de valeur et affichent les mêmes pastilles colorées que dans l’éditeur de comportement (nombre en vert, texte en rose, etc.).",
          ],
          controlRoom: [
            "La régie transforme un comportement en commande opérateur. Quand un affichage ou un widget chargé publie un événement de régie, Meet Manager peut l'afficher comme action sur la page de régie.",
            "Le nom, la description et le raccourci clavier rendent l'action utilisable pendant la compétition. La page demande une compétition live : sans meet live hébergé pour le compte, aucune carte d'action n'apparaît.",
          ],
        },
        createLayoutSteps: [
          "Ouvrir l'espace licencié puis Mes affichages.",
          "Créer un nouvel affichage.",
          "Choisir un nom clair pour les opérateurs.",
          "Choisir Écran ou Widget.",
          "Définir la taille du canvas et la couleur de fond.",
          "Créer l'affichage puis ouvrir l'éditeur.",
        ],
        importSteps: [
          "Importer un fichier d'affichage depuis Mes affichages.",
          "Vérifier que le fichier importé s'ouvre correctement.",
          "Contrôler le type, les dimensions, la scène et le fond.",
          "Choisir un thème et une cible si l'affichage remplace un écran ou un widget existant.",
          "Confirmer et enregistrer l'affichage importé.",
        ],
        themeSteps: [
          "Créer ou modifier un thème depuis la gestion des thèmes.",
          "Définir les couleurs utilisées par les liaisons de thème si besoin.",
          "Associer l'affichage au thème.",
          "Choisir une seule cible compatible avec Écran ou Widget.",
          "Tester l'aperçu avec le thème actif.",
        ],
        displayPreviewSteps: [
          "Enregistre l'affichage, puis utilise Ouvrir l’aperçu compétition dans la barre d'outils de l’éditeur (nouvel onglet).",
          "Dans le panneau du bas, choisis le profil de groupes, les catégories d’âge et les couleurs du thème de la compétition simulée.",
          "Avance avec Précédent / Suivant, glisse la frise, ou lance Lecture pour parcourir les frames automatiquement (secondes par frame).",
          "Dans le panneau régie en haut à droite, déclenche les actions locales publiées par cet affichage (ou note s’il n’y en a encore aucune).",
          "Masque un panneau flottant avec sa croix ; le bouton flottant le ramène sans quitter l’aperçu.",
        ],
        canvasFeatures: [
          "Sélectionne un élément d'un clic ; ajoute à la sélection avec Maj, Ctrl ou Cmd + clic.",
          "Glisse un élément (ou sa poignée de déplacement) pour le bouger ; utilise les poignées des coins et des côtés pour redimensionner.",
          "Fais pivoter avec la poignée du bas en maintenant Ctrl ou Cmd (l'icône de rotation apparaît), ou quand seul le pivotement est disponible.",
          "Une multi-sélection se déplace d'un bloc (contour bleu). Redimensionnement et rotation restent limités à un seul élément.",
          "Des guides d'alignement apparaissent pendant le déplacement ; maintiens Ctrl pendant le drag pour désactiver l'aimantation.",
          "Clic droit : menu contextuel (dupliquer, supprimer, grouper, dégrouper, ordre d'empilement, comportement…).",
          "En aperçu, vérifie le résultat avec des données mock ou live.",
        ],
        canvasShortcuts: [
          "Déplacer la vue : clic molette + glisser, ou molette (sans Ctrl/Cmd).",
          "Zoom : Ctrl ou Cmd + molette (zoom vers le pointeur).",
          "Déplacer la sélection : flèches (10 px, avec guides et aimantation).",
          "Déplacement fin : Maj + flèches (1 px ; guides visibles, sans aimantation).",
          "Déplacement sans aimantation : Ctrl + flèches (comme Ctrl pendant un drag).",
          "Copier / Couper / Coller : Ctrl ou Cmd + C / X / V.",
          "Annuler : Ctrl ou Cmd + Z. Rétablir : Ctrl ou Cmd + Maj + Z, ou Ctrl ou Cmd + Y.",
          "Supprimer la sélection : Suppr ou Retour arrière (onglet Affichage, hors champs de saisie).",
        ],
        displayPreviewFeatures: [
          "Panneau du bas - transport : frame précédente, lecture/pause, frame suivante, compteur et libellé de l’étape courante.",
          "Panneau du bas - frise : se placer sur n’importe quelle frame simulée sans attendre la lecture.",
          "Panneau du bas - paramètres : profil de groupes, catégorie d’âge par groupe, couleurs du thème, et secondes par frame pour la lecture automatique.",
          "Panneau haut droite - régie : déclencher les actions définies comme événements de régie dans les comportements de cet affichage.",
          "Si le panneau régie indique qu’aucun événement n’est publié, ajoute des événements On Control Room dans le comportement, puis rouvre l’aperçu.",
          "Chaque panneau flottant peut être masqué ; des boutons flottants les restaurent sans quitter l’aperçu.",
        ],
        layersFeatures: [
          "Montre tous les éléments de l'affichage, y compris ceux dans les conteneurs.",
          "Montre le design de ligne d'une liste en mode Édition.",
          "Recherche par nom ou type.",
          "Glisser-déposer pour réordonner dans le même parent.",
          "Clic droit : mêmes actions que sur le canvas.",
          "Les sous-parties expliquent chaque type d'élément en langage simple.",
        ],
        elementTextFeatures: [
          "Barre d'outils : Texte.",
          "Parties de contenu : texte simple et/ou Liaison de données, dans l'ordre.",
          "Largeur : Fixe ou Adaptatif.",
          "Polices et ombre de texte dans Style.",
          "Le comportement peut changer le contenu, la couleur ou la Visibilité pendant la compétition.",
        ],
        elementImageFeatures: [
          "Barre d'outils : Image (choisir un fichier).",
          "L'image est conservée avec l'affichage pour les écrans.",
          "Style : opacité, filtre, bordure, ombre.",
          "L'image peut rester fixe ou suivre les données / un comportement.",
          "Préparée à l'avance pour éviter un flash vide.",
        ],
        elementVideoFeatures: [
          "Barre d'outils : Vidéo (téléverser un fichier).",
          "Réglages : Muet, Boucle.",
          "Préférer une vidéo muette en boucle sur les écrans d'attente publics.",
          "Garder des clips courts pour les widgets distants.",
          "Le comportement montre, masque ou restyle surtout la vidéo.",
        ],
        elementShapeFeatures: [
          "Barre d'outils : menu Forme (rectangle, ellipse, ligne, polygones, étoile…).",
          "Décoratif ou structurel - pas de données de compétition seules.",
          "Style avec fond, bordure, opacité, ombre et inclinaison.",
          "Utile derrière du texte, ou comme accent dans un conteneur Absolu.",
          "Comportement : Visibilité, couleur ou opacité.",
        ],
        elementContainerFeatures: [
          "Barre d'outils : Conteneur, ou Grouper plusieurs éléments sélectionnés.",
          "Flex : mise en page du quotidien (direction, espacement, justification, alignement).",
          "Absolu : positions libres - idéal pour les animations ; moins stable pour une UI compacte.",
          "En Flex, Largeur/Hauteur peuvent être Fixe ou Adaptatif.",
          "Dégrouper replace les enfants sur le canvas.",
          "Un comportement peut masquer ou animer tout le groupe.",
        ],
        elementLayoutListSteps: [
          "Ajouter une Liste depuis la barre d'outils.",
          "Rester en mode Édition et composer la ligne par défaut (textes, formes, liaisons).",
          "Régler Source et Identifiant (par exemple la licence).",
          "Régler Direction de la liste, Nombre maximum et d'éventuelles transitions.",
          "Passer en Aperçu pour vérifier les données mock ou live ; ajouter Filtre, Tri ou variantes en comportement si besoin.",
          "Pour l'apparition/disparition, utiliser Entrée dans la liste / Sortie de la liste dans la ligne avec Jouer l'animation.",
        ],
        elementLayoutListFeatures: [
          "Édition = composer la ligne ; Aperçu = voir la liste réelle.",
          "Direction de la liste : colonne, ligne et options inversées.",
          "Identifiant requis pour des animations d'apparition/disparition fiables.",
          "Variantes de ligne : designs différents selon une condition.",
          "Comportement de liste : Filtre, Tri, Créer une variante de ligne.",
          "Dans une ligne : Ligne courante, Indice, Comparateur.",
          "Événements : Entrée dans la liste / Sortie de la liste.",
        ],
        elementBarLoaderSteps: [
          "Ajouter Chargeur de barre depuis la barre d'outils.",
          "Choisir Unité (KG/LBS) et Mode (Complet, Réduit ou Barre).",
          "Définir ou lier Poids total ; ajuster Poids de barre et Poids des colliers si besoin.",
          "Activer les disques lourds optionnels seulement si la compétition les utilise.",
          "En Réduit/Barre, choisir Largeur des disques (Fixe ou Variable) et Alignement des disques.",
          "Styliser disques et libellés globalement, puis surcharger un disque si besoin.",
          "Optionnel : ouvrir le comportement pour Poids total / Poids de barre ou Cibler un Disque / Libellé.",
        ],
        elementBarLoaderFeatures: [
          "L'unité bascule les disques kilogrammes ou livres.",
          "Modes : Complet, Réduit, Barre.",
          "Les colliers sont toujours comptés par paire.",
          "Largeur des disques Variable : suit la charge réelle.",
          "Style global plus style optionnel par poids de disque.",
          "Comportement : Poids total, Poids de barre ; style avec Cible optionnelle (Disque / Libellé).",
          "Les changements d'apparence ciblés pendant la compétition sont temporaires.",
        ],
        elementQrCodeFeatures: [
          "Barre d'outils : QR code.",
          "Valeur : texte/lien fixe, ou changée depuis un comportement.",
          "La taille suit le plus petit côté du cadre.",
          "Couleur = points du code ; Couleur de fond = zone vide.",
          "Usage typique : liens vers widgets ou pages publiques.",
        ],
        propertyFeatures: [
          "Position, taille, rotation et libellé de calque.",
          "Liaison de données par source et champ.",
          "Champs spécifiques texte, image, vidéo, forme, conteneur, liste, QR code et chargeur de barre.",
          "Styles visuels, espacements, typographie, bordures, ombres, filtres et transitions.",
          "Indication des champs verrouillés par un comportement.",
          "Recherche locale dans les propriétés visibles.",
        ],
        mockFeatures: [
          "Sources éditables : athlète courant, listes, groupe, compétition, timers, records, niveaux, catégories, disciplines, organisations et couleurs de thème.",
          "Les objets s'ouvrent par sections.",
          "Les tableaux se parcourent élément par élément.",
          "Les champs oui/non utilisent un choix.",
          "Les dates utilisent un sélecteur de date.",
          "Les champs couleur utilisent le sélecteur de couleur.",
        ],
        behaviorInterfaceFeatures: [
          "La palette de gauche liste les blocs disponibles dans le contexte actuel.",
          "Le canvas central reçoit les blocs par glisser-déposer.",
          "Les connexions de flux relient les déclenchements aux actions.",
          "Les connexions de valeur passent une valeur typée : nombre, texte, oui/non, liste, objet, date ou valeur de style.",
          "Le panneau de droite liste les éléments de scène réutilisables lorsqu'ils sont disponibles.",
          "Le menu contextuel permet couper, copier, coller, dupliquer, supprimer et extraire une sélection en fonction ou variable de scène.",
        ],
        sceneBehaviorSteps: [
          "Ouvrir l'éditeur sur un écran ou un widget.",
          "Cliquer sur Ouvrir le comportement de scène dans la barre d'outils.",
          "Depuis le hub, ouvrir Animations, Événements, Fonctions ou Variables.",
          "Créer ou sélectionner une entrée, puis éditer son graphe dans la vue détail.",
          "Réutiliser cette entrée depuis les comportements d'éléments (jouer, écouter, appeler, lire ou définir).",
        ],
        sceneBehaviorFeatures: [
          "Bibliothèque partagée pour tout l'affichage, pas pour un seul élément du canvas.",
          "Hub à quatre cartes : Animations, Événements, Fonctions, Variables.",
          "Fil d'Ariane : Scène / section / nom de l'entrée.",
          "Les comportements d'éléments réutilisent les éléments de scène au lieu de dupliquer des graphes.",
          "Panoramique au clic molette ; zoom avec Ctrl/Cmd + molette.",
        ],
        sceneAnimationSteps: [
          "Ouvrir le comportement de scène.",
          "Entrer dans Animations.",
          "Créer une animation ou capturer une animation depuis la barre d'outils.",
          "Construire un graphe avec Début d'animation, une ou plusieurs keyframes et Fin d'animation.",
          "Jouer l'animation depuis un élément avec Jouer l'animation.",
        ],
        sceneAnimationFeatures: [
          "Début d'animation porte le nom unique de l'animation.",
          "Les keyframes ne stockent que les propriétés qui diffèrent entre les poses.",
          "Fin d'animation clôt la chaîne pour que Jouer l'animation puisse lancer la séquence.",
          "Capturer depuis la barre d'outils d'affichage ou éditer le graphe à la main.",
        ],
        sceneFunctionSteps: [
          "Ouvrir Comportement de scène → Fonctions, ou extraire une sélection via le menu contextuel du comportement.",
          "Sur Début de fonction, ajouter les ports d'entrée nécessaires et définir le nom et le type de chacun.",
          "Construire le graphe interne.",
          "Sur Fin de fonction, ajouter les ports de sortie nécessaires et définir le nom et le type de chacun.",
          "Appeler la fonction depuis un comportement d'élément.",
        ],
        sceneFunctionFeatures: [
          "Début de fonction : ajouter/retirer des entrées ; chaque entrée a un nom et un type.",
          "Fin de fonction : ajouter/retirer des sorties ; chaque sortie a un nom et un type.",
          "Créer depuis la liste de scène ou Extraire en fonction dans le menu contextuel.",
          "Réutiliser la même logique depuis plusieurs comportements d'éléments.",
        ],
        sceneEventSteps: [
          "Ouvrir Comportement de scène → Événements et créer un événement custom.",
          "Construire le graphe déclencheur avec Au chargement / Au changement et des contrôles.",
          "Relier l'étape finale à Sortie d'événement.",
          "Écouter depuis les comportements d'éléments avec Événement de scène personnalisé.",
        ],
        sceneEventFeatures: [
          "Publie un événement nommé pour tout l'affichage.",
          "Sortie d'événement est obligatoire ; sans elle rien n'est publié.",
          "Les comportements d'éléments écoutent avec Événement de scène personnalisé.",
          "Les graphes déclencheurs restent dans le comportement de scène, pas sur chaque élément.",
        ],
        sceneVariableSteps: [
          "Ouvrir Comportement de scène → Variables, ou extraire une valeur via le menu contextuel du comportement.",
          "S'il faut des entrées, utiliser Début de variable : ajouter des ports et définir le nom et le type de chacun.",
          "Construire le calcul qui alimente Fin de variable.",
          "Lire avec une référence de variable, ou mettre à jour pendant l'affichage avec Définir la variable (par ex. depuis un événement).",
        ],
        sceneVariableFeatures: [
          "Fin de variable publie le résultat partagé - ce bloc de fin est obligatoire.",
          "Début de variable (optionnel) : ajouter/retirer des entrées ; chaque entrée a un nom et un type.",
          "Définir la variable depuis les comportements d'éléments (événements, régie, etc.) pour stocker des valeurs qui changent pendant la compétition.",
          "Créer depuis la liste de scène ou Extraire en variable dans le menu contextuel.",
        ],
        controlRoomSteps: [
          "Ajouter un événement de régie dans un comportement.",
          "Renseigner un nom lisible.",
          "Renseigner une description utile pour l'opérateur.",
          "Choisir un raccourci de une à trois touches.",
          "Relier l'événement aux actions à exécuter.",
          "Charger l'affichage dans un écran ou un widget.",
          "Déclencher l'action depuis la page de régie ou au clavier.",
        ],
      },
      references: {
        targets: {
          athlete_display:
            "Écran athlète utilisé pour afficher l'athlète courant et son essai.",
          loader_display:
            "Écran chargeur adapté au rendu de barre et de disques.",
          ranking_display: "Écran de classement ou de résultats.",
          public_display:
            "Écran public ou stream pour le suivi de compétition.",
          lights_display: "Écran de lumières d'arbitrage.",
          current_athlete: "Widget de l'athlète courant.",
          current_category: "Widget de la catégorie courante.",
          current_group: "Widget du groupe courant.",
          referee_lights: "Widget de lumières d'arbitrage.",
          timer: "Widget de chronomètre.",
        },
        toolbar: {
          undo: "Annule la dernière modification.",
          redo: "Rétablit une modification annulée.",
          resetPreview:
            "Réinitialise l'aperçu comme si l'affichage venait de charger.",
          openRuntimePreview: "Ouvre un aperçu compétition avec régie locale.",
          text: "Ajoute un élément texte.",
          image: "Ajoute un élément image.",
          video: "Ajoute un élément vidéo en boucle.",
          shape: "Ouvre le menu des formes.",
          barLoader: "Ajoute un chargeur de barre.",
          layoutList: "Ajoute une liste liée aux athlètes par défaut.",
          qrCode: "Ajoute un QR code stylable.",
          customDisciplineInput: "Ajoute un input de discipline custom.",
          customDisciplineButton: "Ajoute un bouton de discipline custom.",
          mockData: "Ouvre l'édition des données de test.",
          openSceneBehavior: "Ouvre la bibliothèque partagée de scène.",
          createAnimation: "Démarre la capture d'animation.",
          addKeyframe: "Ajoute une keyframe.",
          saveAnimation: "Enregistre la capture comme animation de scène.",
          cancelAnimation: "Annule la capture d'animation.",
          openBehavior: "Ouvre le comportement de l'élément sélectionné.",
          duplicate: "Duplique la sélection.",
          cut: "Coupe la sélection.",
          copy: "Copie la sélection.",
          paste: "Colle le contenu compatible copié.",
          group: "Crée un conteneur autour de la sélection.",
          ungroup: "Retire le conteneur sélectionné.",
          extractFromContainer:
            "Sort l'élément sélectionné de son conteneur parent.",
          bringForward: "Place l'élément au premier plan.",
          sendBackward: "Place l'élément à l'arrière-plan.",
          bringForwardOne: "Avance l'élément d'un niveau.",
          sendBackwardOne: "Recule l'élément d'un niveau.",
          delete: "Supprime la sélection.",
        },
        properties: {
          positionSize:
            "Contrôle position, taille, rotation et libellé de calque.",
          dataBinding:
            "Lie un élément à une source de compétition et à un champ.",
          style:
            "Regroupe visibilité, fond, typographie, espacements, bordures, ombres, filtres et transformations.",
          transitions: "Anime les changements visuels pris en charge.",
          text: "Texte statique, une Liaison de données, ou un contenu composé de textes et liaisons.",
          image:
            "Image fixe, ou image pilotée par Liaison de données ou comportement.",
          video: "Source vidéo avec options muet et boucle.",
          shape: "Forme stylée par fond, bordure, opacité et transformations.",
          container: "Structure les enfants en Absolu ou Flex.",
          layoutList:
            "Répète un design de ligne sur une source liste, avec direction, limite, identifiant, variantes et transitions.",
          barLoader:
            "Affiche une barre chargée avec poids total, barre, colliers, unité, mode, disques et styles de libellés.",
          qrCode:
            "Encode une valeur ou une Liaison de données dans un QR code stylable.",
          behaviorLocked:
            "Un champ piloté par comportement doit être modifié dans le graphe.",
        },
        graphicNodes: {
          purpose: {
            text: "Afficher un libellé statique, une donnée liée ou un texte composé de plusieurs parties.",
            image:
              "Afficher une image fixe ou une image issue des données de compétition.",
            video:
              "Afficher une vidéo locale ou distante pour les écrans publics ou d'attente.",
            rectangle:
              "Créer un fond, un cadre ou une séparation rectangulaire.",
            square: "Créer une forme carrée stable.",
            ellipse: "Créer un disque ou une forme arrondie libre.",
            oval: "Créer une pastille horizontale ou verticale.",
            line: "Tracer une séparation ou un repère visuel.",
            triangle: "Créer un indicateur directionnel simple.",
            rightTriangle:
              "Créer un coin visuel ou une diagonale de composition.",
            trapezoid: "Créer un cartouche incliné.",
            parallelogram: "Créer un bandeau oblique.",
            pentagon: "Créer une forme polygonale décorative.",
            hexagon: "Créer une forme polygonale équilibrée.",
            octagon: "Créer un badge ou un panneau de type stop.",
            star: "Créer un repère de mise en avant.",
            container: "Regrouper des éléments et choisir Absolu ou Flex.",
            barLoader:
              "Afficher une barre chargée avec poids, disques, colliers, unités et libellés.",
            layoutList:
              "Répéter une ligne graphique pour chaque élément d'une liste de compétition.",
            qrCode:
              "Encoder une URL, un texte ou une valeur liée dans un QR code.",
          },
          details: {
            common:
              "Réglages partagés : position, taille, rotation, ordre d'empilement, verrouillage, libellé, style, transitions, comportement et Liaison de données.",
            text: "Réglages spécifiques : texte statique, largeur Fixe ou Adaptatif, parties texte/liaison et typographie.",
            media:
              "Réglages spécifiques : source média fixe, sélection de fichier et source pilotée par Liaison de données ou comportement.",
            video: "Réglages spécifiques : source vidéo, Muet et Boucle.",
            shape:
              "Réglages spécifiques : type de forme, fond, bordure, opacité, ombre et transformations.",
            container:
              "Réglages spécifiques : Absolu ou Flex, taille Fixe ou Adaptatif, direction, justification, alignement et espacement.",
            layoutList:
              "Réglages spécifiques : source de données, direction, mode Aperçu/Édition, nombre maximum, identifiant, design de ligne, variantes et transitions.",
            barLoader:
              "Réglages spécifiques : poids total, poids de barre, colliers, unité, mode Complet/Réduit/Barre, disques optionnels, largeur compacte, alignement et styles de disques/libellés.",
            qrCode:
              "Réglages spécifiques : valeur encodée, couleur du code via couleur texte, fond via couleur de fond et taille via le cadre de l'élément.",
          },
        },
        styleFields: {
          valueTypeLabel: "Type attendu :",
          targets: {
            "primitive:text": "Texte",
            "primitive:image": "Image",
            "primitive:video": "Vidéo",
            "primitive:shape": "Forme",
            container: "Conteneur",
            component: "Composant",
            "component:qrCode": "QR code",
          },
          categoryPurpose: {
            layout:
              "Mise en page : visibilité, fond, dimensions visuelles et effets globaux.",
            font: "Texte : typographie, couleur et rendu des caractères.",
            decoration:
              "Décoration : soulignement, couleur, style et épaisseur de décoration.",
            border:
              "Bordure : contour et arrondis appliqués au cadre de l'élément.",
          },
          valueTypes: {
            boolean: "oui/non",
            number: "nombre",
            string: "texte",
            color: "couleur",
            gradient: "dégradé",
            border: "bordure ou bordure détaillée",
            fontFamily: "police",
            fontWeight: "épaisseur de police",
            textAlign: "alignement de texte",
            textTransform: "transformation de casse",
            whiteSpace: "gestion des espaces",
            textDecorationLine: "type de ligne de décoration",
            textDecorationColor: "couleur de décoration",
            textDecorationStyle: "style de décoration",
            textDecorationThickness: "épaisseur de décoration",
            filter: "filtre visuel",
            spacing: "espacement simple ou détaillé",
          },
        },
        behaviorAvailability: {
          node: "Comportement d'élément",
          nodeList: "Comportement de liste ou de ligne",
          scene: "Comportement de scène",
          triggerGraph: "Graphe d'événement de scène",
          functionGraph: "Graphe de fonction",
          variableGraph: "Graphe de variable",
        },
        behaviorSectionTitles: {
          events: "Événements",
          variables: "Variables",
          controls: "Contrôles",
          actions: "Actions",
          operators: "Opérateurs",
        },
        behaviorPurposeBySection: {
          events: "Démarre une séquence.",
          variables: "Produit une valeur.",
          controls: "Oriente ou synchronise la séquence.",
          actions:
            "Met à jour ce qui s'affiche, une liste, une animation ou une valeur de scène.",
          operators: "Transforme, compare ou combine des valeurs.",
        },
        behaviorDetailsByType: {
          event: "À placer au début d'une séquence.",
          variable: "À connecter à une entrée de valeur compatible.",
          control: "À connecter entre un événement et des actions.",
          action:
            "À connecter à un flux entrant ; les entrées de valeur attendent le type indiqué par la couleur.",
          operator:
            "À utiliser entre variables et actions pour calculer une valeur.",
          sceneReference:
            "Disponible uniquement lorsque l'entrée de scène est valide et prête à l'emploi.",
        },
      },
    },
  },
  behavior: {
    timers: {
      title: "Chronomètres et timers",
      read: "Lire un timer",
      value: "Valeur entière",
      timerStart: "Démarrer un timer",
      timerStop: "Arrêter le timer",
      timerResume: "Reprendre le timer",
      timerReset: "Réinitialiser le timer",
      timerSet: "Définir la valeur du timer",
      timerDelete: "Supprimer le timer",
      reference: "Référence",
      duration: "Valeur initiale",
      unit: "Unité",
      mode: "Mode",
      output: "Valeur (ms)",
      seconds: "Valeur (s)",
      formatted: "Texte (m:ss)",
      formattedMs: "Texte (m:ss.SSS)",
      elapsedMs: "Temps écoulé (ms)",
      remainingMs: "Temps restant (ms)",
      running: "En cours",
      finished: "Terminé",
      exists: "Existe",
      connected: "Serveur connecté",
      state: "État complet",
      countdown: "Compte à rebours",
      stopwatch: "Chronomètre",
      ms: "Millisecondes",
      s: "Secondes",
      min: "Minutes",
      help: "Même référence et même compétition : un seul timer partagé. Démarrer remplace sa valeur ; Reprendre continue après un arrêt.",
    },
    canvas: {
      cut: "Couper",
      copy: "Copier",
      paste: "Coller",
      duplicate: "Dupliquer",
      delete: "Supprimer",
      insertConnectedNode: "Ajouter un nœud",
      searchNode: "Rechercher un nœud",
      noCompatibleNode: "Aucun nœud compatible pour cette connexion.",
      createVariableFromSelection: "Créer une variable",
      createVariableFromSelectionDefaultName: (index: number) =>
        `Variable ${index}`,
      createFunctionFromSelection: "Créer une fonction",
      createFunctionFromSelectionDefaultName: (index: number) =>
        `Fonction ${index}`,
    },
    nodeList: {
      title: "Nœuds disponibles",
      searchPlaceholder: "Rechercher...",
      categories: {
        events: "Événements",
        operators: "Opérateurs",
        variables: "Variables",
        controls: "Contrôles",
        actions: "Actions",
        animation: "Animation",
      },
      inputTypes: {
        number: "Nombre",
        string: "Texte",
        boolean: "Booléen",
        list: "Liste",
        object: "Objet",
        date: "Date",
        fontFamily: "Police",
        fontWeight: "Épaisseur de police",
        textAlign: "Alignement du texte",
        textTransform: "Casse du texte",
        whiteSpace: "Espace blanc",
        textDecorationLine: "Ligne de décoration",
        textDecorationColor: "Couleur de décoration",
        textDecorationStyle: "Style de décoration",
        textDecorationThickness: "Épaisseur de décoration",
        color: "Couleur",
        gradient: "Dégradé",
        filter: "Filtre",
        boxShadow: "Ombre portée",
        textShadow: "Ombre de texte",
        border: "Bordure",
        borderRadius: "Rayon de bordure",
        spacing: "Espacement",
        location: "Position",
        transform: "Transformation",
        animationDirection: "Direction d’animation",
        animationFill: "Remplissage d'animation",
        animationEasing: "Courbe d’animation",
        layoutListTarget: "Cible de liste",
        flow: "Flux",
        any: "Tous types",
      },
      eventSubCategories: {
        onChange: "Au changement",
        lifecycle: "Cycle de vie",
        listTransition: "Transition de liste",
        controlRoom: "Régie",
      },
      actionSubCategories: {
        content: "Contenu",
        position: "Position",
        style: "Style",
        animation: "Animation",
        barLoader: "Chargeur de barre",
      },
      variableSubCategories: {
        literal: "Littéraux",
        object: "Objets",
        lists: "Listes",
        source: "Sources",
        context: "Contexte",
      },
    },
    operators: {
      readTimer: "Lire un timer",
      defined: "Défini",
      empty: "Vide",
      length: "Longueur",
      isNotEmpty: "Non vide",
      sum: "Somme",
      average: "Moyenne",
      min: "Minimum",
      max: "Maximum",
      equals: "=",
      notEquals: "≠",
      greaterThan: ">",
      lessThan: "<",
      greaterThanOrEqual: "≥",
      lessThanOrEqual: "≤",
      contains: "Contient",
      notContains: "Ne contient pas",
      startsWith: "Commence par",
      endsWith: "Se termine par",
      compare: "Comparer",
      and: "Et",
      or: "Ou",
      not: "Non",
      boolToSign: "Convertir pour comparaison",
      ifElse: "Si",
      add: "+",
      subtract: "−",
      multiply: "×",
      divide: "÷",
      modulo: "%",
      power: "^",
      round: "Arrondir",
      factorial: "!",
      ceil: "Arrondi supérieur",
      concat: "+",
      chartAt: "Caractère à l'index",
      join: "Joindre",
      push: "Ajouter",
      remove: "Retirer",
      take: "Prendre",
      get: "Récupérer",
      map: "Mapper",
      find: "Trouver",
      groupBy: "Grouper par",
      aggregateGroups: "Agréger les groupes",
      findByPath: "Trouver (chemin)",
      findByCondition: "Trouver (condition)",
      filter: "Filtrer",
      sort: "Trier",
      sortBy: "Trier par clés (élément courant)",
      currentEntry: "Entrée courante",
      currentItem: "Élément courant",
      comparator: "Comparateur",
      constructObject: "Créer un objet",
      extendObject: "Étendre un objet",
      setProperty: "Définir une propriété",
      pickObject: "Garder des propriétés",
      omitObject: "Exclure des propriétés",
      objectKeys: "Clés de l’objet",
      objectValues: "Valeurs de l’objet",
      objectEntries: "Entrées de l’objet",
      mapItems: "Transformer chaque élément",
      mapValues: "Transformer chaque valeur",
      getByPath: "Récupérer (chemin)",
      getFieldLabel: "Champ",
      replace: "Remplace",
      castToString: "Convertir en texte",
      castToNumber: "Convertir en nombre",
      castToFontFamily: "Convertir en police",
      castToFontWeight: "Convertir en épaisseur de police",
      castToTextAlign: "Convertir en alignement du texte",
      castToTextTransform: "Convertir en casse du texte",
      castToWhiteSpace: "Convertir en espace blanc",
      castToTextDecorationLine: "Convertir en ligne de décoration",
      castToTextDecorationStyle: "Convertir en style de décoration",
      castToBoolean: "Convertir en booléen",
      castToColor: "Convertir en couleur",
      castToGradient: "Convertir en dégradé",
      castToFilter: "Convertir en filtre",
      castToBoxShadow: "Convertir en ombre portée",
      castToTextShadow: "Convertir en ombre de texte",
      castToBorder: "Convertir en bordure",
      castToBorderRadius: "Convertir en rayon de bordure",
      castToObject: "Convertir en objet",
      withAlpha: "Alpha",
      mix: "Mélanger",
      replacePorts: {
        source: "Source",
        search: "Chercher",
        replacement: "Remplacer par",
      },
      mixPorts: {
        colorA: "Couleur A",
        colorB: "Couleur B",
        ratio: "Ratio %",
      },
      boolToSignPorts: {
        condition: "Condition",
        whenTrue: "Si vrai",
        whenFalse: "Si faux",
      },
      ifElsePorts: {
        whenTrue: "Valeur si vrai",
        whenFalse: "Valeur si faux",
        condition: "Condition",
      },
      findByPathPorts: {
        list: "Liste",
        fieldPath: "Champ (chemin)",
        expected: "Valeur à trouver",
      },
      isSame: "Est pareil",
      dateDifference: "Différence de dates",
      dateDifferencePorts: {
        dateA: "Date A",
        dateB: "Date B",
        years: "Années",
        months: "Mois",
        days: "Jours",
      },
      isAfter: "Après",
      isBefore: "Avant",
      addDays: "Ajouter jours",
      addMonths: "Ajouter mois",
      addYears: "Ajouter années",
      addHours: "Ajouter heures",
      addMinutes: "Ajouter minutes",
      addSeconds: "Ajouter secondes",
      getDay: "Jour",
      getMonth: "Mois",
      getYear: "Année",
      getHour: "Heures",
      getMinute: "Minutes",
      getSecond: "Secondes",
      toUpperCase: "Majuscules",
      toLowerCase: "Minuscules",
      capitalize: "Capitaliser",
      datePartFormat: {
        label: "Format de sortie",
        numeric: "Numérique",
        narrow: "Très court",
        short: "Court",
        long: "Long",
        twoDigit: "Deux chiffres",
      },
    },
    events: {
      listener: "Événement",
      wholeObject: "Tous les champs",
      output: "Sortie",
      triggerOnInit: "Exécuter au premier chargement",
      kinds: {
        onChange: "Au changement",
        onLoad: "Au chargement",
        onClick: "Au clic",
        onListEnter: "Entrée dans la liste",
        onListExit: "Sortie de la liste",
        onListFilterExit: "Sortie filtre de liste",
        onListFilterEnter: "Entrée filtre de liste",
        onControlRoom: "Régie",
        onCustomSceneEvent: "Événement custom",
      },
      controlRoom: {
        name: "Nom",
        namePlaceholder: "Nom de l'événement",
        description: "Description",
        descriptionPlaceholder: "Description de l'événement",
        shortcut: "Raccourci",
        shortcutCapture: "Appuyez sur les touches…",
        shortcutEditing: "Saisissez un raccourci (1 à 3 touches)…",
        shortcutEmpty: "Aucun raccourci défini",
        shortcutClear: "Effacer le raccourci",
        preference: "Préférence clavier de l’opérateur",
        ownShortcut: "Raccourci défini ci-dessus",
        preferenceHelp:
          "Utilise le réglage des paramètres clavier. La combinaison ci-dessus sert de valeur par défaut.",
        tooltipAction: "Clé de l’action à afficher dans le tooltip",
        tooltipActionHelp:
          "Vide : cette action. Utile pour relier un raccourci masqué à un bouton visible.",
        invalidNode:
          "Renseignez le nom, la description et le raccourci pour publier cet événement.",
      },
    },
    controls: {
      ifElse: "Si...Sinon",
      wait: "Attendre",
      repeat: "Répéter",
      condition: "Condition",
      value: "Valeur",
      delayMs: "Délai (ms)",
      count: "Répétitions",
      body: "Boucle",
      loopIndex: "Index boucle",
      done: "Terminé",
      mergeFlows: "Fusionner",
      eventOutput: "Sortie event",
      functionBegin: "Début fonction",
      functionEnd: "Fin fonction",
      variableBegin: "Début variable",
      variableEnd: "Fin variable",
      flowIn1: "Entrée 1",
      flowIn2: "Entrée 2",
      true: "Vrai",
      false: "Faux",
    },
    actions: {
      setHeader: "Définir",
      setStyle: "Style",
      setText: "Texte",
      setListSource: "Source calculée",
      setFilter: "Filtre",
      setSort: "Tri",
      setBinding: "Source",
      iconColor: "Couleur de l'icône",
      iconSize: "Taille de l'icône",
      customActionDisabled: "Désactivé",
      customActionIcon: "Icône",
      customActionStartIcon: "Icône",
      customActionVariant: "Variante",
      customActionSize: "Taille",
      customActionColor: "Couleur",
      customActionTooltip: "Infobulle",
      customActionLabel: "Libellé",
      customListSetField: "Mettre à jour un champ",
      customListSetFieldList: "Liste",
      customListSetFieldSearchKey: "Clé de recherche",
      customListSetFieldSearchValue: "Valeur recherchée",
      customListSetFieldFieldKey: "Champ à mettre à jour",
      customListSetFieldNextValue: "Nouvelle valeur",
      customListSetRows: "Redéfinir la liste",
      customListSetRowsList: "Liste",
      customListSetRowsMode: "Mode",
      customListSetRowsTargetGroupId: "Groupe cible",
      customListSetRowsPersistFields: "Persister les champs",
      customListSetRowsDeleteMissing: "Supprimer les absents",
      customListSetViewRows: "Redéfinir l'affichage",
      customListSetViewRowsList: "Liste",
      customListSetViewRowsIncludeNewRows:
        "Inclure les nouveaux athlètes (tri sans filtrage)",
      customGroupSetField: "Mettre à jour un champ de groupe",
      customGroupSetFieldGroupId: "Groupe",
      customGroupSetFieldFieldKey: "Champ à mettre à jour",
      customGroupSetFieldNextValue: "Nouvelle valeur",
      customOpenGroup: "Ouvrir un groupe",
      customOpenGroupId: "ID groupe",
      customSetCurrentGroup: "Définir le groupe courant",
      customSetCurrentGroupId: "ID groupe",
      customSetCurrentAthlete: "Définir l'athlète courant",
      customSetCurrentAthleteId: "ID athlète",
      customOpenModal: "Ouvrir une modale",
      customOpenModalKey: "Clé modale",
      customOpenModalAthleteId: "Athlète contexte",
      customOpenModalGroupId: "Groupe contexte",
      customRunAction: "Exécuter une action configurée",
      customRunActionColumn: "Colonne du contexte (facultatif)",
      customRunActionKey: "Clé de l’action",
      customIncrementAthleteCount: "Incrémenter le compteur d’athlètes",
      customGroupService: "Service du groupe",
      customGroupServiceName:
        "Service (synchronise, federation, macroExcel, openpowerlifting, powerscout, automaticRefereeing, competitionResults)",
      customGroupServiceMap: "Correspondance des champs",
      customGroupServiceOptions: "Options du service",
      customGroupServiceFormat: "Format du service",
      customSubmitForm: "Enregistrer le formulaire",
      customPrintModal: "Imprimer une maquette de modale",
      customCloseModal: "Fermer une modale",
      customCloseModalKey: "Clé modale",
      customInputOptions: "Options d'input",
      customEntryEligible: "Ticket : saisie autorisée",
      customEntryMinimum: "Ticket : minimum",
      customEntryMaximum: "Ticket : maximum",
      customEntryStep: "Ticket : pas de saisie",
      customEntryAllowWhileCalled: "Ticket : changement pendant l’appel",
      customEntryUnlimitedChanges: "Ticket : changements illimités",
      customEntryReviewChanges: "Ticket : validation du secrétaire",
      customEntryMaxChanges: "Ticket : nombre de changements",
      customEntryTicketReference: "Ticket : référence du chronomètre",
      customReferenceFilter: "Inclure l'élément",
      setLocation: "Position",
      setTransform: "Transformation",
      setTarget: "Cible",
      currentRow: "Ligne courant",
      comparator: "Comparateur",
      comparatorA: "Comparateur A",
      comparatorB: "Comparateur B",
      findIndexOutput: "Index",
      createRowVariant: "Créer une variante de ligne",
      barLoaderDisks: "Disques",
      setBarLoaderTotalWeight: "Poids total",
      setBarLoaderBarWeight: "Poids de barre",
      setVariableHeader: "Définir variable",
      setVariablePrefix: "Définir",
      setVariableValue: "Valeur",
      barLoaderTargetDisk: "Disque",
      barLoaderTargetLabel: "Libellé",
      barLoaderTargetAll: "Tous",
      styleNodeLabels: {
        fontSize: "Taille de police",
        fontWeight: "Épaisseur de police",
        borderRadius: "Arrondi de bordure",
        backgroundColor: "Couleur du fond",
        backgroundImage: "Image d'arrière-plan",
        textAlign: "Alignement du texte",
        textTransform: "Casse du texte",
        textShadow: "Ombre de texte",
        textDecorationLine: "Ligne de décoration",
        textDecorationColor: "Couleur de décoration",
        textDecorationStyle: "Style de décoration",
        textDecorationThickness: "Épaisseur de décoration (px)",
      },
      textValuePort: "Texte",
      flowIn: "Entrée",
      flowOut: "Sortie",
      splitPorts: "Séparer les poignées",
      joinPorts: "Rejoindre les poignées",
      locationX: "X",
      locationY: "Y",
      locationZ: "Z",
      transformWidth: "L",
      transformHeight: "H",
      transformRotation: "R",
    },
    fontWeightChoices: {
      100: "Très fin",
      200: "Très léger",
      300: "Léger",
      400: "Normal",
      500: "Moyen",
      600: "Semi-gras",
      700: "Gras",
      800: "Très gras",
      900: "Ultra gras",
    },
    fontFamilyChoices: {
      Arial: "Arial",
      Verdana: "Verdana",
      Tahoma: "Tahoma",
      "Trebuchet MS": "Trebuchet MS",
      "Times New Roman": "Times New Roman",
      Georgia: "Georgia",
      Garamond: "Garamond",
      "Courier New": "Courier New",
      "Palatino Linotype": "Palatino Linotype",
      "Lucida Sans Unicode": "Lucida Sans Unicode",
      "Comic Sans MS": "Comic Sans MS",
      Impact: "Impact",
      "Brush Script MT": "Brush Script MT",
    },
    textAlignChoices: {
      left: "Gauche",
      center: "Centré",
      right: "Droite",
    },
    textTransformChoices: {
      none: "Aucune",
      capitalize: "Première lettre en majuscule",
      uppercase: "Majuscules",
      lowercase: "Minuscules",
    },
    whiteSpaceChoices: {
      normal: "normal",
      pre: "pre",
      "pre-wrap": "pre-wrap",
      "pre-line": "pre-line",
      nowrap: "nowrap",
      wrap: "wrap",
      "break-spaces": "break-spaces",
      collapse: "collapse",
      "preserve nowrap": "preserve nowrap",
    },
    textDecorationLineChoices: {
      none: "Aucune",
      underline: "Souligné",
      overline: "Ligne au-dessus",
      "line-through": "Barré",
      blink: "Clignotant",
      "spelling-error": "Erreur d'orthographe",
      "grammar-error": "Erreur de grammaire",
    },
    textDecorationStyleChoices: {
      solid: "Plein",
      double: "Double",
      dotted: "Pointillé",
      dashed: "Tirets",
      wavy: "Ondulé",
    },
    layoutList: {
      createRowVariant: {
        label: "Créer une variante de ligne",
        name: "Nom",
        condition: "Condition",
        order: "Ordre",
      },
    },
    animation: {
      begin: "Début d’animation",
      keyframe: "Image clé",
      end: "Fin d’animation",
      play: "Jouer l’animation",
      name: "Nom",
      durationMs: "Durée (ms)",
      delayMs: "Délai (ms)",
      iterationCount: "Répétitions",
      playInfinite: "Lire à l'infini",
      direction: "Direction",
      fillMode: "Remplissage",
      freezeChildren: "Figer les enfants",
      offset: "Position (%)",
      offsetOut: "Position (sortie)",
      easing: "Courbe",
      easingOut: "Courbe (sortie)",
      mirrorSuffix: "(sortie)",
      directionChoices: {
        normal: "Normale",
        reverse: "Inverse",
        alternate: "Alternée",
        alternateReverse: "Alternée inverse",
      },
      fillModeChoices: {
        none: "Aucun",
        forwards: "En avant",
        backwards: "En arrière",
        both: "Les deux",
      },
      easingChoices: {
        linear: "Linéaire",
        ease: "Ease",
        "ease-in": "Ease in",
        "ease-out": "Ease out",
        "ease-in-out": "Ease in-out",
      },
      props: {
        opacity: "Opacité",
        x: "X",
        y: "Y",
        scale: "Échelle",
        scaleX: "Échelle X",
        scaleY: "Échelle Y",
        rotation: "Rotation",
        skewX: "Inclinaison X",
        skewY: "Inclinaison Y",
        width: "Largeur",
        height: "Hauteur",
      },
      addPort: "Ajouter une propriété",
      addPortEmpty: "Toutes les propriétés sont déjà présentes",
      deletePort: "Supprimer la propriété",
    },
    sceneCatalog: {
      objectEditor: {
        nativeTypes: {
          currentAthlete: "Athlète",
          currentGroup: "Groupe",
          currentMeet: "Compétition",
          refereeLights: "Arbitrage",
          nextLiftData: "Prochain passage",
          records: "Record",
          levels: "Niveau",
          organisation: "Organisation",
          ageCategories: "Catégorie d’âge",
          weightCategories: "Catégorie de poids",
        },
        definition: "Définition d’objet",
        end: "Sortie d’objet",
        objectMode: "Ajouter comme",
        objectField: "Champ objet imbriqué",
        extension: "Extension d’un objet",
        extendType: "Objet à étendre",

        title: "Types d’objets réutilisables",
        base: "1 · Objet de base",
        baseType: "Type de base",
        emptyObject: "Objet vide",
        inherited: "Champs hérités",
        extend: "2 · Étendre",
        fields: "champs",
        key: "Clé du champ",
        valueType: "Type de valeur",
        defaultValue: "Valeur par défaut",
        noDefault: "Aucune valeur par défaut",
        itemType: "Type des éléments",
        untyped: "Objet libre",
        removeField: "Supprimer le champ",
        addField: "Ajouter un champ",
        output: "3 · Type de sortie",
        typeName: "Nom du type",
        availableInVariables: "Disponible dans les variables",
        inUse: "Ce type est utilisé par un objet, une variable ou un élément.",
        errors: {
          graph:
            "Le graphe doit contenir une définition et une sortie d’objet, avec des connexions valides et sans boucle.",
          nameTaken: "Un type porte déjà ce nom.",
          name: "Donnez un nom au type.",
          cycle: "Cette référence crée une boucle entre les types.",
          reference: "Un type référencé n’existe plus.",
          field:
            "Les clés doivent être uniques, sans espace, et les types valides.",
          default: "La valeur par défaut ne correspond pas au type choisi.",
        },
      },
      objects: "Objets",
      countObjects: "{n} type(s) d’objet",
      emptyObjects: "Aucun type d’objet",
      panelObjects: "Objets",

      breadcrumbScene: "Scène",
      animations: "Animations",
      events: "Événements",
      functions: "Fonctions",
      functionCall: "Fonction",
      variableRef: "Variable",
      variables: "Variables",
      countAnimations: "{n} animation(s)",
      countEvents: "{n} événement(s)",
      countFunctions: "{n} fonction(s)",
      countVariables: "{n} variable(s)",
      create: "Créer",
      rename: "Renommer",
      duplicate: "Dupliquer",
      delete: "Supprimer",
      nameEmptyError: "Le nom ne peut pas être vide.",
      animationNameTakenError: "Une animation porte déjà ce nom.",
      nameTakenError: "Un élément porte déjà ce nom.",
      emptyAnimations: "Aucune animation",
      emptyEvents: "Aucun événement",
      emptyFunctions: "Aucune fonction",
      emptyVariables: "Aucune variable",
      panelTitle: "Catalogue scène",
      panelAnimations: "Animations",
      panelEvents: "Événements",
      panelFunctions: "Fonctions",
      panelVariables: "Variables",
      panelEmpty: "-",
      searchPlaceholder: "Rechercher...",
      defaultAnimations: {
        fade: "Fondu",
        "slide-up": "Glissement vers le haut",
        "slide-down": "Glissement vers le bas",
        "slide-left": "Glissement vers la gauche",
        "slide-right": "Glissement vers la droite",
        "zoom-in": "Zoom avant",
        "zoom-out": "Zoom arrière",
        pop: "Pop",
        bounce: "Rebond",
        drift: "Dérive",
      },
      functionGraph: {
        addInputPort: "Ajouter une entrée",
        addOutputPort: "Ajouter une sortie",
        selectValueType: "Type de valeur",
        portLabel: "Libellé du port",
        portLabelPlaceholder: "Nom affiché",
        confirmAddPort: "Ajouter",
        renamePort: "Renommer le port",
        confirmRenamePort: "Renommer",
        deletePort: "Supprimer le port",
        cancel: "Annuler",
      },
      variableGraph: {
        addInputPort: "Ajouter une entrée",
        selectValueType: "Type de valeur",
        portLabel: "Libellé du port",
        portLabelPlaceholder: "Nom affiché",
        confirmAddPort: "Ajouter",
        renamePort: "Renommer le port",
        confirmRenamePort: "Renommer",
        deletePort: "Supprimer le port",
        cancel: "Annuler",
      },
    },
  },
} as const;

export default fr;
